(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/marionette/nyxclient-stripped.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/marionette/nyxclient-stripped.js');


function ClassUtil() {}
ClassUtil.CreateClass = function(object, inherits_from) {
  if (inherits_from != null)
    object.prototype = Object.create(inherits_from.prototype);
  object.prototype.constructor = object;
  object.Events = {};
};

ClassUtil.CreateEventDispatcher = function(object) {
  object.prototype.AddEventListener = function(
    event_id,
    callback_function,
    this_pointer,
    sync
  ) {
    if (!this.__eventlisteners__) this.__eventlisteners__ = new Array();
    if (this.HasEventListener(event_id, callback_function, this_pointer))
      return;

    this.__eventlisteners__.push({
      name: event_id,
      thisPointer: this_pointer,
      callback: callback_function,
      sync: sync
    });
  };
  object.prototype.RemoveEventListener = function(
    event_id,
    callback_function,
    this_pointer
  ) {
    if (!this.__eventlisteners__) this.__eventlisteners__ = new Array();

    for (var i = 0; i < this.__eventlisteners__.length; i++) {
      if (
        this.__eventlisteners__[i].name == event_id &&
        this.__eventlisteners__[i].callback == callback_function &&
        this.__eventlisteners__[i].thisPointer == this_pointer
      ) {
        this.__eventlisteners__.splice(i, 1);
        i--;
      }
    }
  };
  object.prototype.HasEventListener = function(
    event_id,
    callback_function,
    this_pointer
  ) {
    if (!this.__eventlisteners__) this.__eventlisteners__ = new Array();

    for (var i = 0; i < this.__eventlisteners__.length; i++) {
      if (
        this.__eventlisteners__[i].name == event_id &&
        this.__eventlisteners__[i].callback == callback_function &&
        this.__eventlisteners__[i].thisPointer == this_pointer
      ) {
        return true;
      }
    }
    return false;
  };
  object.prototype.DispatchEvent = function(event_id, data) {
    if (!this.__eventlisteners__) this.__eventlisteners__ = new Array();
    for (var i = 0; i < this.__eventlisteners__.length; i++) {
      if (this.__eventlisteners__[i].name == event_id) {
        if (this.__eventlisteners__[i].sync) {
          var lenBefore = parseInt(this.__eventlisteners__.length, 10);
          this.__eventlisteners__[i].callback.call(
            this.__eventlisteners__[i].thisPointer,
            data
          );
          var lenAfter = parseInt(this.__eventlisteners__.length, 10);
          if (lenBefore > lenAfter) {
            i--;
          }
        } else {
          setTimeout(
            this.__eventlisteners__[i].callback.bind(
              this.__eventlisteners__[i].thisPointer,
              data
            ),
            1
          );
        }
      }
    }
  };
};

ClassUtil.serialize = function(object) {
  var string_array = [];
  string_array.push('{');
  for (var p in object) {
    if (object.hasOwnProperty(p)) {
      string_array.push('{' + p + ': ' + object[p] + '}');
    }
  }
  string_array.push('}');
  return string_array.join(', ');
};

function InterfaceUtil() {}

InterfaceUtil.getGameList = function(array) {
  var result = [];

  for (var i = 0; i < array.length; i++) {
    result.push(new IGame(array[i]));
  }
  return result;
};

InterfaceUtil.getLastWinList = function(lastWinString) {
  var result = [];

  var array = lastWinString.split(',');

  for (var i = 0; i < array.length; i++) {
    var item = array[i].split(';');
    if (item.length === 4) {
      result.push({
        name: item[0],
        game: item[1],
        amount: item[2],
        time: item[3]
      });
    } else {
      console.log('Warning lastwin data is incorrect.');
    }
  }
  return result;
};

function Settings() {
  this.id = null;
  this.operator = null;
  this.partner = null;
  this.skin = null;
  this.channel = null;
  this.universe = null;
  this.language = null;

  this.nyxroot = null;
  this.assets = null;
  this.assetsRootPath = null;
  this.pollPath = null;

  this.session = '';
  this.gameid = '';
  this.wagerid = 0;
  this.ref = 0;

  this.debug = false;
}
ClassUtil.CreateClass(Settings);

Settings.prototype.parseObject = function(jsonData) {
  var json = jsonData['application'];

  this.id = json['id'];
  this.operator = json['operator'];
  this.partner = json['partner'];
  this.skin = json['skinname'];
  this.channel = json['channel'];
  this.universe = json['universe'];
  this.language = json['language'];

  this.nyxroot = json['nyxroot'];
  this.assetsRootPath = json['assetsrootpath'];
  this.pollPath = json['pollpath'];

  if (!!json['gameid']) {
    this.gameid = json['gameid'];
  }

  if (!!json['wagerid']) {
    this.wagerid = json['wagerid'];
  }

  if (!!json['ref']) {
    this.ref = json['ref'];
  }
};

Settings.prototype.mergeStartupSettings = function(startupSettings) {
  if (!!startupSettings['skin']) {
    this.skin = startupSettings['skin'];
  }
  if (!!startupSettings['wagerid']) {
    this.wagerid = startupSettings['wagerid'];
  }
  if (!!startupSettings['language']) {
    this.language = startupSettings['language'];
  }
  if (!!startupSettings['gameid']) {
    this.gameid = startupSettings['gameid'];
  }
  if (!!startupSettings['session']) {
    this.session = startupSettings['session'];
  }
  if (!!startupSettings['nyxroot']) {
    this.nyxroot = startupSettings['nyxroot'];
  }
  if (!!startupSettings['operator']) {
    this.operator = startupSettings['operator'];
  }
  if (!!startupSettings['partner']) {
    this.partner = startupSettings['partner'];
  }
  if (!!startupSettings['assets']) {
    this.assets = startupSettings['assets'];
  }

  if (!!startupSettings['debug']) {
    if (startupSettings['debug'] === true) this.debug = true;
  }
};

function ResponseItem(name, data) {
  this.name = name;
  this.data = data;
}
ClassUtil.CreateClass(ResponseItem);

function DefaultDefinition(settings) {
  this.settings = settings;
  this.sources = { globals: null, game: null, layout: null };

  this.model = '';
  this.thousandSeparator = '.';
  this.gameidandversion = '';
  this.defaultPlayerSettings = {};
  this.links = {};

  this.defaultData = {
    idClientSoftware: {
      name: 'Svs Scratch Engine',
      version: '0.00',
      date: '2017-03-22'
    },
    size: {
      width: 640,
      height: 840
    },
    font: {
      family: 'Arial',
      align: 'left',
      style: ''
    },
    colors: {
      colorBgLoad: { color: '#000000' },
      colorBgError: { color: '#add8e6' },
      colorBgFatalError: { color: '#ffffff' },
      colorSpinner: { color: '#ffffff' }
    },
    texts: {
      textDialogRcGameNotLoadedMessage: {
        value: 'Spelet kan inte laddas.',
        color: '#000000',
        fontSize: '20'
      },
      textDialogRcGameParsingErrorMessage: {
        value: 'Fel i filen.',
        color: '#000000',
        fontSize: '20'
      },
      textDialogRcErrorTitle: {
        value: 'Tekniskt fel',
        color: '#000000',
        fontSize: '30'
      },
      textDialogRcMessageText: {
        value: '%1',
        color: '#000000',
        fontSize: '20'
      },
      textRcMsg: { value: '', color: '#FF0000', fontSize: '20' }
    },
    currencies: {
      SEK: '%0:-',
      EUR: '%0\u20AC',
      USD: '$%0',
      GBP: 'Â£%0'
    },
    dialogs: {
      _fatalerror: {
        position: { x: 0, y: 0 },
        size: { width: 640, height: 840 },

        onevt: [{ id: '_fatalerror', action: 'show' }], 
        colors: {
          colorBgFatalError: {
            use: 'background',
            position: { x: 0, y: 0 },
            size: { width: 'scene', height: 'scene' }
          }
        },
        texts: {
          textDialogRcErrorTitle: { position: { x: 'center', y: 100 } },
          textDialogRcMessageText: {
            param: 'message',
            position: { x: 'center', y: 180 }
          },
          textRcMsg: {
            param: 'msg',
            position: { x: 'center', y: 220 },
            condition: { debug: true }
          }
        }
      },
      _error: {
        position: { x: 0, y: 0 },
        size: { width: 640, height: 840 },

        onevt: [{ id: '_error', action: 'show' }], 
        colors: {
          colorBgError: {
            use: 'background',
            position: { x: 0, y: 0 },
            size: { width: 'scene', height: 'scene' }
          }
        },
        texts: {
          textDialogRcErrorTitle: { position: { x: 'center', y: 100 } },
          textRc: {
            param: 'rc',
            position: { x: 'center', y: 180 },
            condition: { debug: true }
          },
          textRcRequest: {
            param: 'request',
            position: { x: 'center', y: 200 },
            condition: { debug: true }
          },
          textRcMsg: {
            param: 'msg',
            position: { x: 'center', y: 220 },
            condition: { debug: true }
          }
        }
      }
    }
  };
  this.dataDefinition = null;

  this.keyWords = [
    'defaultPlayerSettings',
    'links',
    'colors',
    'texts',
    'animations',
    'resources',
    'demo'
  ]; 

  this.data = JSON.parse(JSON.stringify(this.defaultData));
}

DefaultDefinition.prototype.init = function(model) {
  switch (model) {
    case 'kryss':
    case 'bingo':
      this.dataDefinition = null;
      break;

    default:
      this.dataDefinition = null;
      break;
  }

  if (!!this.dataDefinition) {
    for (var key in this.dataDefinition.data) {
      this.data[key] = JSON.parse(
        JSON.stringify(this.dataDefinition.data[key])
      );
    }
  }
};

DefaultDefinition.prototype.setLink = function(data) {
  var link = data['url'];
  var delimiter = '?';

  if (data['url'].indexOf(delimiter) !== -1) {
    delimiter = '&';
  }

  if (!!data['param']) {
    if (data['param'].indexOf('session') !== -1) {
      link += delimiter + 'session=' + this.settings.session;
      delimiter = '&';
    }
    if (data['param'].indexOf('gameid') !== -1) {
      link += delimiter + 'gameid=' + this.settings.gameid;
      delimiter = '&';
    }
  }

  data.link = link;
  return data;
};

DefaultDefinition.prototype.setGameSetting = function(game_settings, type) {
  if (!!game_settings[type]) {
    var mySettings = game_settings[type];
    if (mySettings.constructor === Array) {
      if (!this.data[type]) {
        this.data[type] = [];
      }
      for (var i = 0; i < mySettings.length; ++i) {
        this.data[type].push(mySettings[i]);
      }
    } else {
      if (!this.data[type]) {
        this.data[type] = {};
      }
      for (var key in mySettings) {
        this.data[type][key] = mySettings[key];
      }
    }
  }
};

DefaultDefinition.prototype.updateGameSettings = function(game_settings) {
  for (var i = 0; i < this.keyWords.length; ++i) {
    this.setGameSetting(game_settings, this.keyWords[i]);
  }

  if (!!game_settings.id) {
    var name = '';
    if (!!game_settings.id.name) {
      name = game_settings.id.name;
    }
    var version = '';
    if (!!game_settings.id.version) {
      version = game_settings.id.version;
    }
    this.gameidandversion = name + ', version:' + version;

    if (!!game_settings.id.title) {
      document.title = game_settings.id.title;
    }
  }

  if (!!game_settings['formatting']) {
    this.thousandSeparator = game_settings['formatting']['thousandSeparator'];
  }
};

DefaultDefinition.prototype.set = function(id, data) {
  this.sources[id] = JSON.parse(JSON.stringify(data));
};

DefaultDefinition.prototype.findPresentationItems = function(
  id,
  targetData,
  type
) {
  var result = [];

  var items = targetData[type];
  if (!!items) {
    if (items.constructor === Array) {
      for (var j = 0; j < items.length; j++) {
        if (id === items[j]['id']) {
          result.push(items[j]);
        }
      }
    } else {
      if (!!items['id']) {
        if (id === items['id']) {
          result.push(items);
        }
      } else {
        if (!!items[id]) {
          result.push(items[id]);
        }
      }
    }
  }
  if (targetData['containers']) {
    for (var key in targetData['containers']) {
      var containerResult = this.findPresentationItems(
        id,
        targetData['containers'][key],
        type
      );
      result = result.concat(containerResult);
    }
  }

  return result;
};

DefaultDefinition.prototype.setOnEvtData = function(data, targetItems) {
  for (var i = 0; i < targetItems.length; i++) {
    if (data['id'] === targetItems[i]['id']) {
      for (var key in data) {
        targetItems[i][key] = data[key];
      }
    }
  }
};

DefaultDefinition.prototype.setResultData = function(data, targetItems) {
  for (var i = 0; i < targetItems.length; i++) {
    for (var key in data) {
      targetItems[i][key] = data[key];
    }
  }
};

DefaultDefinition.prototype.setScratchData = function(data, targetItems) {
  for (var i = 0; i < targetItems.length; i++) {
    if (data['id'] === targetItems[i]['id']) {
      for (var key in data) {
        targetItems[i][key] = data[key];
      }

      targetItems[i]['hitarea']['type'] = data['type'];

      targetItems[i]['hitarea']['position']['x'] = data['position']['x'];
      targetItems[i]['hitarea']['position']['y'] = data['position']['y'];

      switch (data['type']) {
        case 'circle':
          if (!targetItems[i]['hitarea']['data']) {
            targetItems[i]['hitarea']['data'] = {};
          }
          targetItems[i]['hitarea']['data']['radius'] = data['data']['radius'];
          break;

        case 'polygon':
          if (!targetItems[i]['hitarea']['data']) {
            targetItems[i]['hitarea']['data'] = {};
          }
          if (!!data['data']) {
            targetItems[i]['hitarea']['data'] = data['data'];
          }
          break;

        case 'ellipse':
        case 'rect':
        default:
          if (!targetItems[i]['hitarea']['size']) {
            targetItems[i]['hitarea']['size'] = {};
          }
          targetItems[i]['hitarea']['size']['height'] = data['size']['height'];
          targetItems[i]['hitarea']['size']['width'] = data['size']['width'];
          break;
      }
    }
  }
};

DefaultDefinition.prototype.setPresentationData = function(
  myId,
  data,
  targetItems,
  type
) {
  switch (type) {
    case 'onevt':
      this.setOnEvtData(data, targetItems);
      break;
    case 'result':
      this.setResultData(data, targetItems);
      break;
    case 'scratch':
      this.setScratchData(data, targetItems);
      break;
    default:
      var found = false;
      for (var i = 0; i < targetItems.length; i++) {
        found = true;
        for (var key in data) {
          targetItems[i][key] = data[key];
        }
      }
      if (!found) {
        targetItems.push(data);
      }
      break;
  }
};

DefaultDefinition.prototype.updateItem = function(items, targetData, type) {
  var itemId = items['id'];
  if (!!itemId) {
    var targetItems = this.findPresentationItems(itemId, targetData, type);
    if (targetItems.length > 0) {
      this.setPresentationData(itemId, items, targetItems, type);
    } else {
      if (!targetData[type]) {
        targetData[type] = [];
      }
      targetData[type].push(items);
    }
  } else {
    for (var key in items) {
      var targetItems = this.findPresentationItems(key, targetData, type);
      if (targetItems.length > 0) {
        items[key].id = key;
        this.setPresentationData(key, items[key], targetItems, type);
      } else {
        if (!targetData[type]) {
          targetData[type] = {};
        }
        targetData[type][key] = items[key];
      }
    }
  }
};

DefaultDefinition.prototype.findInArray = function(id, array, type) {
  if (type === 'onevt') {
    return null;
  }

  for (var i = 0; i < array.length; ++i) {
    if (id === array[i].id) {
      return array[i];
    }
  }
  return null;
};

DefaultDefinition.prototype.updateArray = function(items, targetData, type) {
  var j;

  if (!targetData[type]) {
    targetData[type] = [];
  }

  if (targetData[type].constructor === Array) {
    for (j = 0; j < items.length; j++) {
      var result = this.findInArray(items[j]['id'], targetData[type], type);

      if (!!result) {
        for (var attr in items[j]) {
          result[attr] = items[j][attr];
        }
      } else {
        targetData[type].push(items[j]);
      }
    }
  } else {
    for (j = 0; j < items.length; j++) {
      if (targetData[type][items[j]['id']]) {
        for (var attr in items[j]) {
          targetData[type][items[j]['id']][attr] = items[j][attr];
        }
      } else {
        targetData[type][items[j]['id']] = items[j];
      }
    }
  }
};

DefaultDefinition.prototype.updateItems = function(items, targetData, type) {
  if (!!items) {
    if (items.constructor === Array) {
      this.updateArray(items, targetData, type);
    } else {
      this.updateItem(items, targetData, type);
    }
  }
};

DefaultDefinition.prototype.updatePresentationDataItems = function(
  data,
  targetData,
  type
) {
  var i;

  switch (type) {
    case 'scratch':
      for (var j = 0; j < data.length; ++j) {
        if (!!data[j][type]) {
          for (i = 0; i < data[j][type].length; ++i) {
            if (data[j][type][i].id === 'imageBgUnscratched') {
              data[j][type][i].id = 'scratchid';
            }
          }
        }
      }
      break;
    default:
      break;
  }

  if (data.constructor === Array) {
    for (i = 0; i < data.length; i++) {
      if (!!targetData[data[i]['id']]) {
        this.updateItems(data[i][type], targetData[data[i]['id']], type);
      }
    }
  } else {
    for (var key in data) {
      if (!targetData[key]) {
        targetData[key] = {};
      }

      this.updateItems(data[key][type], targetData[key], type);
    }
  }
};

DefaultDefinition.prototype.updateTargetDataItems = function(data, targetData) {
  for (var key in data) {
    if (!targetData[key]) {
      targetData[key] = {};
    }

    var source = data[key];
    var dest = targetData[key];

    for (var myKey in source) {
      if (
        source[myKey].constructor !== Array &&
        source[myKey].constructor !== Object
      ) {
        dest[myKey] = source[myKey];
      }
    }
  }
};

DefaultDefinition.prototype.updatePresentationData = function(
  data,
  targetData
) {
  if (!!data) {
    this.updateTargetDataItems(data, targetData);

    this.updatePresentationDataItems(data, targetData, 'size');

    this.updatePresentationDataItems(data, targetData, 'images');

    this.updatePresentationDataItems(data, targetData, 'buttons');

    this.updatePresentationDataItems(data, targetData, 'colors');

    this.updatePresentationDataItems(data, targetData, 'texts');

    this.updatePresentationDataItems(data, targetData, 'paytable');

    this.updatePresentationDataItems(data, targetData, 'scratch');

    this.updatePresentationDataItems(data, targetData, 'result');

    this.updatePresentationDataItems(data, targetData, 'onevt');

    this.updatePresentationDataItems(data, targetData, 'elements');

    this.updatePresentationDataItems(data, targetData, 'containers');

    this.updatePresentationDataItems(data, targetData, 'onenter');

    this.updatePresentationDataItems(data, targetData, 'onexit');
  }
};

DefaultDefinition.prototype.updateData = function(flagPortrait) {
  var data;

  if (flagPortrait) {
    data = this.sources['layout']['portrait'];

    if (data['size']['height'] === 0 || data['size']['width'] === 0) {
      data = this.sources['layout']['landscape'];
    }
  } else {
    data = this.sources['layout']['landscape'];

    if (data['size']['height'] === 0 || data['size']['width'] === 0) {
      data = this.sources['layout']['portrait'];
    }
  }

  if (!this.data['states']) {
    this.data['states'] = {};
  }
  if (!this.data['dialogs']) {
    this.data['dialogs'] = {};
  }

  this.updatePresentationData(data['states'], this.data['states']);
  this.updatePresentationData(data['dialogs'], this.data['dialogs']);
};

DefaultDefinition.prototype.findLayoutObject = function(id, layoutArray) {
  if (layoutArray.constructor === Array) {
    for (var i = 0; i < layoutArray.length; i++) {
      if (layoutArray[i].id === id) {
        return layoutArray[i];
      }
    }
  } else {
    return layoutArray[id];
  }
  return null;
};

DefaultDefinition.prototype.setLayout = function(game_layout) {
  this.data = JSON.parse(JSON.stringify(this.defaultData)); 

  this.gameLayout = game_layout;

  this.data['portrait'] = game_layout['portrait'];
  this.data['landscape'] = game_layout['landscape'];

  var gamestates = this.data['states'];

  for (var stateKey in gamestates) {
    if (!!this.gameLayout['portrait']['states']) {
      var portraitLayout = this.findLayoutObject(
        stateKey,
        this.gameLayout['portrait']['states']
      );
      gamestates[stateKey].portrait = portraitLayout;
    } else {
      gamestates[stateKey].portrait = null;
    }

    if (!!this.gameLayout['landscape']['states']) {
      var landscapeLayout = this.findLayoutObject(
        stateKey,
        this.gameLayout['landscape']['states']
      );
      gamestates[stateKey].landscape = landscapeLayout;
    } else {
      gamestates[stateKey].landscape = null;
    }
  }

  var dialogs = this.data['dialogs'];

  for (var dialogKey in dialogs) {
    if (!!this.gameLayout['portrait']['dialogs']) {
      var portraitLayout = this.findLayoutObject(
        dialogKey,
        this.gameLayout['portrait']['dialogs']
      );
      dialogs[dialogKey].portrait = portraitLayout;
    } else {
      dialogs[dialogKey].portrait = null;
    }

    if (!!this.gameLayout['landscape']['dialogs']) {
      var landscapeLayout = this.findLayoutObject(
        dialogKey,
        this.gameLayout['landscape']['dialogs']
      );
      dialogs[dialogKey].landscape = landscapeLayout;
    } else {
      dialogs[dialogKey].landscape = null;
    }
  }
};

DefaultDefinition.prototype.updateLayout = function(layout) {};

DefaultDefinition.prototype.parse = function() {
  if (!!this.sources['globals']) {
    this.updateGameSettings(this.sources['globals']);
  }

  if (!!this.sources['game']) {
    this.updateGameSettings(this.sources['game']);
  }

  if (!!this.sources['layout']) {
    this.updateLayout(this.sources['layout']);
  }

  for (var key in this.data.links) {
    this.links[key] = this.setLink(this.data.links[key]);
  }
};

function DemoDefinition() {
  this.gameConfig = null;
  this.xStandaloneSym = null;
  this.model = '';

  this.xOnSymsSymbol = '0';

  this.winData = [];
  this.winDataProbability = 0.25; 
  this.winDataDistribution = [1]; 
  this.winDataIndex = 0;

  this.winningSymbol = '0';
  this.availableSymbols = [];

  this.standaloneSymbols = {};
  this.standaloneSymbolsPercent = {
    dag: { '1': 25, '2': 75 } 
  };

  this.basedata = {
    base_data: {
      id: '123456000'
    },
    default_gameconfig: { gameid: '12345', ticketPrice: '10' },
    wager: {
      id: '',
      userid: '',
      betted: '',
      won: '',
      bets: [
        {
          id: '1',
          created: '',
          step: '1',
          gameid: '',
          roundid: '1234567',
          ba: '',
          bc: '',
          wa: '',
          wc: '',
          ns: '0',
          cmds: '',
          status: 'PAID',
          payid: '',
          params: '',
          data: ''
        }
      ]
    }
  };
}

DemoDefinition.prototype.getRandom = function(probability) {
  var value = Math.random() * 100;
  var lastKey;

  for (var key in probability) {
    lastKey = key;
    if (value < probability[key]) {
      return key;
    } else {
      value -= probability[key];
    }
  }
  return lastKey;
};

DemoDefinition.prototype.getPosition = function(src, value) {
  var before = src.slice(0, src.indexOf(value));
  var s1 = ',';
  var count =
    (before.length - before.replace(new RegExp(s1, 'g'), '').length) /
    s1.length;

  return count + 1;
};

DemoDefinition.prototype.configure = function(flagWin) {
  this.gameConfig = LotteryData.getInstance().getGameConfig();
  var gameConfig = this.gameConfig;

  var ticketPrice = gameConfig.ticketPrice;
  this.basedata.default_gameconfig.ticketPrice = ticketPrice;

  var i;
  this.model = gameConfig.model;
  this.xOnSymsSymbol = '0';

  if (gameConfig.xStandaloneSym) {
    this.xStandaloneSym = gameConfig.xStandaloneSym.split(',');
  } else {
    this.xStandaloneSym = null;
  }

  this.scratchCount = 9;
  this.maxPlayableSymbol = 9;
  this.flagMultiplier = true;
  this.multiplier = 1;
  this.extraSymboles = [0, 0, 0, 0, 0, 0, 0, 0, 0];
  this.flagBonus = 'x1';
  this.dataEnd = '';

  this.xIconsArray = gameConfig.xIcons.split(',');
  this.standaloneSymbols = {};

  this.xIconMap = {};
  for (i = 0; i < this.xIconsArray.length; ++i) {
    this.xIconMap[i + 1] = this.xIconsArray[i];
  }

  if (!!this.xStandaloneSym) {
    for (i = 0; i < this.xStandaloneSym.length; ++i) {
      this.standaloneSymbols[this.xStandaloneSym[i]] = this.xIconMap[
        this.xStandaloneSym[i]
      ];
      delete this.xIconMap[this.xStandaloneSym[i]];
    }
  }

  this.nonWinningMultiplier = { Third: 30, '1': 30, '2': 20, '5': 15, '10': 5 }; 
  this.winningMultiplier = { '1': 100 }; 

  this.jokerSymbols = [];
  this.jokerIncludeFlag = false;

  switch (this.model) {
    case 'Triplet':
      this.scratchCount = 6; 
      this.maxPlayableSymbol = 6;
      this.flagMultiplier = false;
      this.extraSymboles = [0, 0, 0, 0, 0, 0];
      break;

    case 'DTripletStar':
      this.scratchCount = 18; 
      this.maxPlayableSymbol = 12;
      this.flagMultiplier = true;
      this.extraSymboles = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ];
      break;

    case 'TripletJoker':
      this.nonWinningMultiplier = { '1': 60, '2': 20, '5': 15, '10': 5 };

      this.extraSymboles = [0, 0, 0, 0, 0, 0, 0, 0];
      this.jokerIncludeFlag = true;
      if (this.jokerIncludeFlag) {
        this.winningMultiplier = { '1': 100 };
        this.scratchCount = 8; 
      }
      this.jokerSymbols = [0, 0, 0, 0, 0, 0, 0, 0, 0];
      break;

    default:
      this.scratchCount = gameConfig.tcount;
      var count = 0;
      var noOfPrizes1 = gameConfig.noOfPrizes1.split(',');
      for (i = 0; i < noOfPrizes1.length; ++i) {
        if (parseInt(noOfPrizes1[i], 10) > 0) {
          count++;
        } else {
          break;
        }
      }
      this.maxPlayableSymbol = count;
      var extraSymbolsLength = this.extraSymboles.length;
      if (this.scratchCount > extraSymbolsLength) {
        var toAdd = this.scratchCount - extraSymbolsLength;
        for (i = 0; i < toAdd; i++) {
          this.extraSymboles.push(0);
        }
      }
      break;
  }
  if (this.flagMultiplier) {
    if (flagWin) {
      this.flagBonus = this.getRandom(this.winningMultiplier);
    } else {
      this.flagBonus = this.getRandom(this.nonWinningMultiplier);
    }

    if (this.flagBonus === 'Third' || this.flagBonus === 'Star') {
      this.multiplier = this.getPosition(gameConfig.multNames, this.flagBonus);
      this.dataEnd = '/' + this.flagBonus;

      if (this.flagBonus === 'Third') {
        this.scratchCount++;
        this.extraSymboles.push(0);
      }
    } else {
      this.multiplier = this.getPosition(
        gameConfig.multiplicators,
        this.flagBonus
      );
    }
  }

  this.availableSymbols = [];
  var mychar = 65;

  var xprizesArray = [];
  if (gameConfig.xPrizes !== '') {
    xprizesArray = gameConfig.xPrizes.split(',');
  }

  var prizesArray = [];
  if (gameConfig.prizes !== '') {
    prizesArray = gameConfig.prizes.split(',');
  }

  this.winData = [];
  for (i = 0; i < this.maxPlayableSymbol; i++) {
    var symbol = '' + (i + 1);
    this.availableSymbols.push(symbol);

    if (i < this.winDataDistribution.length) {
      this.winData.push({
        probability: this.winDataDistribution[i],
        symbol: symbol,
        prize: prizesArray[i]
      });
    }
  }
};

DemoDefinition.prototype.shouldWin = function(flagWin) {
  this.winDataIndex = 0;
  this.winningSymbol = '0';

  if (flagWin) {
    var flagWinIndex = Math.random();
    for (var i = 0; i < this.winData.length; i++) {
      if (flagWinIndex < this.winData[i].probability) {
        this.winDataIndex = i;
        this.winningSymbol = this.winData[i].symbol;
        return;
      } else {
        flagWinIndex = flagWinIndex - this.winData[i].probability;
      }
    }
  }
};

DemoDefinition.prototype.setupXOnSymsSymbol = function() {
  if (this.gameConfig.xOnSyms !== null) {
    var xOnSyms = this.gameConfig.xOnSyms.split(',');
    this.xOnSymsSymbol = '0';

    if (!!this.gameConfig.xIcons) {
      if (this.winningSymbol !== '0') {
        var index = xOnSyms.indexOf(this.winningSymbol);
        if (index !== -1) {
          xOnSyms.splice(index, 1);
        }
      }

      this.xOnSymsSymbol = xOnSyms[Math.floor(Math.random() * xOnSyms.length)];
    }
  }
};

DemoDefinition.prototype.generateRandomSymbols = function(should_win) {

  var arr = [];
  var tempArray = [];

  if (should_win) {
    if (this.jokerIncludeFlag) {
      tempArray = [this.winningSymbol, this.winningSymbol]; 
    } else {
      tempArray = [this.winningSymbol, this.winningSymbol, this.winningSymbol]; 
    }
  }

  for (var i = 0, length = this.availableSymbols.length; i < length; i++) {
    var num = this.availableSymbols[i];
    if (num !== this.xOnSymsSymbol) {
      if (!should_win || num !== this.winningSymbol) {
        if (this.jokerIncludeFlag) {
          arr.push(num);
        } else {
          arr.splice(0, 0, num, num);
        }
      }
    }
  }
  if (this.xOnSymsSymbol !== '0') {
    if (!this.jokerIncludeFlag) {
      arr.push(this.xOnSymsSymbol);
    }
    tempArray.push(this.xOnSymsSymbol);
  }

  if (!!this.xStandaloneSym) {
    for (var standaloneKey in this.standaloneSymbols) {
      var myStandaloneSymbol = this.standaloneSymbols[
        standaloneKey
      ].toLowerCase();

      if (!!this.standaloneSymbolsPercent[myStandaloneSymbol]) {
        var standaloneCount = this.getRandom(
          this.standaloneSymbolsPercent[myStandaloneSymbol]
        );
        for (var k = 0; k < standaloneCount; ++k) {
          tempArray.push('X' + standaloneKey);
          console.log('STANDALONE ' + myStandaloneSymbol);
        }
      }
    }
  }

  arr = ValueUtil.arr_shuffle(arr);

  var countToRemove = tempArray.length;
  if (this.jokerIncludeFlag) {
    countToRemove++;
  }

  if (tempArray.length > 0) {
    return ValueUtil.arr_shuffle(
      tempArray.concat(arr.slice(0, this.scratchCount - tempArray.length))
    );
  } else {
    return arr.slice(0, this.scratchCount);
  }
};

DemoDefinition.prototype.addXIconValues = function(symbols) {
  var i;
  var key;
  var randomXIconIndex;

  if (!!this.xOnSymsSymbol && this.xOnSymsSymbol !== '0') {
    if (!!this.xStandaloneSym) {
      var keys = Object.keys(this.xIconMap);

      randomXIconIndex = keys[Math.floor(keys.length * Math.random())];
    } else {
      randomXIconIndex =
        Math.floor(Math.random() * this.xIconsArray.length) + 1;
    }

    for (i = 0; i < symbols.length; i++) {
      if (this.xOnSymsSymbol === symbols[i]) {
        this.extraSymboles[i] = randomXIconIndex;
      }
    }
  }
};

DemoDefinition.prototype.findFirstOtherSymbol = function(symbol, symbols) {
  for (var i = 0; i < symbols.length; i++) {
    if (symbol !== symbols[i] && !symbols[i].startsWith('X')) {
      return i;
    }
  }
  return -1;
};

DemoDefinition.prototype.replacePosition = function(index1, index2, symbols) {
  var temp = symbols[index1];
  symbols[index1] = symbols[index2];
  symbols[index2] = temp;
};

DemoDefinition.prototype.checkRules = function(symbols) {
  if (this.flagBonus === 'Third') {
    var multiplierIndex = symbols.length - 1;

    if (
      this.xOnSymsSymbol === symbols[multiplierIndex] ||
      symbols[multiplierIndex].startsWith('X')
    ) {
      var index = this.findFirstOtherSymbol(this.xOnSymsSymbol, symbols);

      if (index !== -1) {
        this.replacePosition(index, multiplierIndex, symbols);
        this.extraSymboles[index] = this.extraSymboles[multiplierIndex];
        this.extraSymboles[multiplierIndex] = 0;
      } else {
        console.error('Technical problem'); 
      }
    }
  }

  if (this.model === 'TripletJoker') {
    if (this.jokerIncludeFlag) {
      var indexJoker =
        parseInt(this.getRandom({ '1': 25, '2': 25, '4': 25, '5': 25 }), 10) -
        1; 
      if (this.winningSymbol !== '0') {
        symbols.splice(indexJoker, 0, this.winningSymbol); 
      } else {
        symbols.splice(indexJoker, 0, '1'); 
      }
      this.extraSymboles.splice(indexJoker, 0, 0);
      this.jokerSymbols[indexJoker] = 1;
    }
  }

  if (symbols[0] === symbols[1] && symbols[0] === symbols[2]) {
    this.replacePosition(2, 5, symbols);
  }
};

DemoDefinition.prototype.getDemoWager = function(data) {
  var skinId = data['skinid'];
  var skinIdData = '';
  if (!!skinId) {
    skinIdData = 'SkinId=' + skinId + ';';
  }
  var winProbability = this.winDataProbability; 
  var flagWin = Math.random() < winProbability;

  this.configure(flagWin);

  this.shouldWin(flagWin); 
  this.setupXOnSymsSymbol();

  var symbols = this.generateRandomSymbols(flagWin);

  this.addXIconValues(symbols);

  this.checkRules(symbols);

  var wager = JSON.parse(JSON.stringify(this.basedata.wager));

  if (this.model === 'TripletJoker') {
    this.dataEnd += '/Joker/' + this.jokerSymbols;
  }

  if (flagWin) {
    wager.won = this.winData[this.winDataIndex].prize;
    wager.bets[0].status = 'WON';
    wager.bets[0].data =
      'D=' +
      this.winData[this.winDataIndex].symbol +
      '/' +
      symbols.join() +
      '/' +
      this.multiplier +
      '/' +
      this.extraSymboles.join() +
      this.dataEnd +
      ';DESCR=Demo;FT=0;PL=0;' +
      skinIdData +
      'T=DEMO/123456/' +
      this.winData[this.winDataIndex].symbol +
      '/' +
      this.winData[this.winDataIndex].prize +
      '/0/';
  } else {
    wager.won = '0.00';
    wager.bets[0].status = 'LOST';
    wager.bets[0].data =
      'D=0/' +
      symbols.join() +
      '/' +
      this.multiplier +
      '/' +
      this.extraSymboles.join() +
      this.dataEnd +
      ';DESCR=Demo;FT=0;PL=0;' +
      skinIdData +
      'T=DEMO/123456/0/0.00/0/';
  }

  return wager;
};

function GameConfig(data) {
  this.gameId = 0;
  this.ticketPrice = null;
  this.currency = '';

  this.icon = '';

  this.name = null;
  this.namet = null;

  this.model = null;

  this.multiplicators = null;
  this.multNames = null;

  this.noOfPrizes1 = null;
  this.noOfTickets = null;

  this.prizeplan = null;
  this.prizeplanInfo = null;
  this.prizes = null;

  this.scratchesToWinOnRows = null;

  this.tcount = 0;

  this.wgmap = null;

  this.xIcons = null;
  this.xOnSyms = null;
  this.xStandaloneSym = null;

  this.xPrizes = null;

  this._winnings = null;
  this._totalNumberOfPrizes = 0;
  this._totalSumOfPrizes = 0;
  this._totalWinnings = null;
  this._prizes = null;

  if (data != undefined) {
    this.fromJson(data);
  }
}
ClassUtil.CreateClass(GameConfig);

GameConfig.prototype.parseXML = function(node) {
  function sortNumber(a, b) {
    return a - b;
  }

  this.gameId = node.getAttribute('gameId');
  this.ticketPrice = node.getAttribute('TicketPrice');
  this.currency = node.getAttribute('Currency');

  this.cat1 = node.getAttribute('Cat1');
  this.cat2 = node.getAttribute('Cat2');

  this.icon = node.getAttribute('Icon');

  this.name = node.getAttribute('Name');
  this.namet = node.getAttribute('namet');

  this.model = node.getAttribute('Model');

  this.multiplicators = node.getAttribute('Multiplicators');
  this.multNames = node.getAttribute('MultNames');

  this.noOfPrizes1 = node.getAttribute('NoOfPrizes1');
  this.noOfTickets = node.getAttribute('NoOfTickets');

  this.prizeplan = node.getAttribute('Prizeplan');
  this.prizeplanInfo = node.getAttribute('PrizePlanInfo');
  this.prizes = node.getAttribute('Prizes');

  this._prizes = this.prizes.split(',');
  for (var j = 0; j < this._prizes.length; ++j) {
    this._prizes[j] = parseInt(this._prizes[j], 10);
  }

  this._prizesSorted = this.prizes.split(',');
  for (var j = 0; j < this._prizesSorted.length; ++j) {
    this._prizesSorted[j] = parseInt(this._prizesSorted[j], 10);
  }
  this._prizesSorted.sort(sortNumber);

  this.tcount = parseInt(node.getAttribute('TCount'), 10);

  this.wgmap = node.getAttribute('WGMAP');

  this.xIcons = node.getAttribute('XIcons');
  this.xOnSyms = node.getAttribute('XOnSyms');
  this.xStandaloneSym = node.getAttribute('XStandaloneSym');

  this.xPrizes = node.getAttribute('XPrizes');

  this.scratchesToWinOnRows = node.getAttribute('ScratchesToWinOnRows');

  var arr = this.prizeplanInfo.split('/');
  this._winnings = [];
  this._totalNumberOfPrizes = 0;
  this._totalSumOfPrizes = 0;
  var i,
    winnings_arr = arr[3].split(','),
    item,
    amount;
  for (i = 0; i < winnings_arr.length; i++) {
    item = winnings_arr[i].split(':');
    amount = Number(item[1]);
    this._totalSumOfPrizes += amount * Number(item[0]);
    this._totalNumberOfPrizes += amount;
    this._winnings.unshift([item[1], item[0], item[2]]);
  }
  this._totalWinnings = [this._totalNumberOfPrizes, '', this._totalSumOfPrizes];
};

GameConfig.prototype.fromJson = function(object) {
  this.gameId = object['gameId'];
  this.ticketPrice = object['ticketPrice'];
  this.currency = object['Currency'];

  this.cat1 = object['Cat1'];
  this.cat2 = object['Cat2'];

  this.name = object['Name'];
  this.namet = object['namet'];

  this.noOfPrizes1 = object['NoOfPrizes1'];
  this.noOfTickets = object['NoOfTickets'];

  this.prizeplan = object['Prizeplan'];
  this.prizeplanInfo = object['PrizePlanInfo'];
  this.prizes = object['Prizes'];

  this.tcount = object['TCount'];
  this.wgmap = object['WGMAP'];

  this.xIcons = object['XIcons'];
  this.xOnSyms = object['XOnSyms'];
  this.xStandaloneSym = object['XStandaloneSym'];

  this.XPrizes = object['XPrizes'];

  this.scratchesToWinOnRows = object['ScratchesToWinOnRows'];
};

function Game() {
  this.id = '';

  this.subsystem = null;
  this.gametype = null;
  this.model = null;
  this.modelt = null;

  this.prio = null;
  this.fprio = null;
  this.webclient = null;

  this.promoid = null;
  this.webminiclient = null;
  this.currency = null;
  this.descr = null;

  this.icon = null;
  this.name = null;

  this.namet = null;
  this.price = null;
}
ClassUtil.CreateClass(Game);

Game.prototype.parseXML = function(node) {
  this.id = node.getAttribute('id');

  this.subsystem = node.getAttribute('subsystem');
  this.gametype = node.getAttribute('gametype');
  this.model = node.getAttribute('model');
  this.modelt = node.getAttribute('modelt');

  this.prio = node.getAttribute('prio');
  this.fprio = node.getAttribute('fprio');
  this.webclient = node.getAttribute('webclient');

  this.promoid = node.getAttribute('promoid');
  this.webminiclient = node.getAttribute('webminiclient');
  this.currency = node.getAttribute('currency');
  this.descr = node.getAttribute('descr');

  this.icon = node.getAttribute('icon');
  this.name = node.getAttribute('name');

  this.namet = node.getAttribute('namet');
  this.price = node.getAttribute('price');

  this.cat1 = node.getAttribute('cat1');

  if (this.subsystem.toLowerCase() === 'bingo') {
    this.pprio = node.getAttribute('pprio');
    this.chatrooms = node.getAttribute('chatrooms');
    this.drawpublishtime = node.getAttribute('drawpublishtime');
    this.playmode = node.getAttribute('playmode');
    this.starttime = node.getAttribute('starttime');
    this.sts = node.getAttribute('sts');

    this.schema = node.getAttribute('schema');

    if (this.playmode.toLowerCase() === 'singleuser') {
      this.denoms = node.getAttribute('denoms');
      this.maxwin = node.getAttribute('maxwin');
    } else {
      this.chatters = node.getAttribute('chatters');
      this.online = node.getAttribute('online');
      this.players = node.getAttribute('players');
      this.jackpotvalue = node.getAttribute('jackpotvalue');
      this.alltickets = node.getAttribute('alltickets');
      this.ball = node.getAttribute('ball');
      this.jackpotcalls = node.getAttribute('jackpotcalls');
      this.pot = node.getAttribute('pot');
    }
  }
};

function LotteryData(correctObject) {
  if (correctObject != ___correctObject___LotteryData) {
    throw new Error('LotteryData() tried to instantiate Singleton');
  }

  this.ticketSize = { width: 640, height: 840 }; 

  this.dynamicValue = {};
  this.wagerXIconsLookup = null;
  this.wagerIdentity = null;
  this.symbolLookup = null;

  this.currencies = null;

  this.animations = {};
  this.colors = {};
  this.links = {};
  this.texts = {};

  this.gameSettings = {};
  this.gameLayout = {};

  this.gameConfig = new GameConfig();
  this.model = '';
  this.currency = '';

  this.player = new Player();
  this.settings = new Settings();

  this.wager = new Wager();
  this.next_wager = null;
  this.wagerData = {};

  this.defaultDefinition = new DefaultDefinition(this.settings);
  this.dataDefinition = this.defaultDefinition;

  this.flags = {};
  for (var key in LotteryData.Flag) {
    this.flags[key] = false;
  }
  this.flags['initiator'] = 'internal';

  for (var i = 0; i < LotteryData.DynamicKeys.length; i++) {
    this.dynamicValue[LotteryData.DynamicKeys[i]] = '';
  }
}
ClassUtil.CreateClass(LotteryData);

LotteryData.Flag = {
  initiator: 'initiator',
  audio: 'audio', 
  bought: 'bought', 
  debug: 'debug', 
  login: 'login', 
  payok: 'payok', 
  ongoing: 'ongoing', 

  demo: 'demo', 
  free: 'free', 
  replay: 'replay', 
  result: 'result', 
  won: 'won', 

  count: 'count', 
  husk: 'husk',
  show_check_win_button: 'show_check_win_button',

  next_ongoing: 'next_ongoing', 
  next_free: 'next_free' 
};

LotteryData.DynamicKeys = [
  'price',
  'nooftickets',
  'skinid',
  'ticketid',
  'paytable',
  'engineidandversion',
  'gameidandversion',
  'winamount',
  'extraicon'
];

LotteryData.prototype.initDataDefinition = function() {
  this.defaultDefinition.init(this.model);
  this.defaultDefinition.updateData(SceneGraph.isPortrait());
  this.defaultDefinition.parse();

  this.currencies = new Currencies(this.dataDefinition.data['currencies']);
  this.thousandSeparator = '.';

  if (
    this.model !== 'kryss' &&
    this.model !== 'bingo' &&
    this.model !== 'scratchandmatch' &&
    this.model !== 'pyramidkeno'
  ) {
    this.setSymbolLookupByGameConfig(this.gameConfig);
  }
  this.setMultiplierLookupByGameConfig(this.gameConfig);

  this.demoDefinition = new DemoDefinition();
  this.ticketSize = this.dataDefinition.data.size;

  this.setDynamicValue(
    'price',
    this.getFormatted(this.gameConfig.ticketPrice, this.gameConfig.currency)
  );
  this.setDynamicValue(
    'nooftickets',
    this.getFormatted(this.gameConfig.noOfTickets, '')
  );

  this.balance = new Balance();
  this.bonus = new Bonus();

  this.styles = new styles();

  this.resources = {};
  this.animations = {};
  this.colors = {};
  this.links = {};
  this.texts = {};

  this.gameSettings = {};
  this.gameLayout = {};

  this.defaultPlayerSettings = {};

  var defaultPlayerSettingsObj = this.dataDefinition.data[
    'defaultPlayerSettings'
  ];
  if (!!defaultPlayerSettingsObj) {
    this.defaultPlayerSettings = defaultPlayerSettingsObj;

    for (var key in defaultPlayerSettingsObj) {
      this.setFlag(LotteryData.Flag[key], defaultPlayerSettingsObj[key]);
    }
  }

  for (var t in this.dataDefinition.data['texts']) {
    this.texts[t] = this.dataDefinition.data['texts'][t];
  }
  for (var c in this.dataDefinition.data['colors']) {
    this.colors[c] = this.dataDefinition.data['colors'][c];
  }

  this.createResources(this.dataDefinition.data['resources']);

  this.setDynamicValue(
    'engineidandversion',
    this.dataDefinition.data['idClientSoftware'].name +
      ', version:' +
      this.dataDefinition.data['idClientSoftware'].version +
      ', ' +
      this.dataDefinition.data['idClientSoftware']['date']
  );

};

LotteryData.prototype.createResources = function(resources) {
  if (!!resources) {
    if (!!resources['textures']) {
      for (var id in resources['textures']) {
        this.resources[id] = ValueUtil.createTextureFromGraphics(
          resources['textures'][id]
        );
      }
    }
  }
};

LotteryData.prototype.setTicketSize = function(size) {
  this.ticketSize = size;
};

LotteryData.prototype.getTicketSize = function() {
  return this.ticketSize;
};

LotteryData.prototype.getBaseFont = function() {
  return JSON.parse(JSON.stringify(this.dataDefinition.data.font)); 
};

LotteryData.prototype.setSpinnerColor = function(spinnerColor) {
  this.colors['colorSpinner'].color = spinnerColor;
};

LotteryData.prototype.getSpinnerColor = function() {
  return this.colors['colorSpinner'].color;
};

LotteryData.prototype.getFlags = function() {
  return this.flags;
};

LotteryData.prototype.getFlag = function(key) {
  return this.flags[key];
};

LotteryData.prototype.setFlag = function(key, value) {
  this.flags[key] = value;
  if (key === LotteryData.Flag['audio']) {
    if (value) {
      AudioManager.GetInstance().UnMute();
    } else {
      AudioManager.GetInstance().Mute();
    }
    ViewController.getInstance().sendEvent(EventModel.events._audio);
  }
  console.log('* Flag ' + key + ', value:' + value);
};

LotteryData.prototype.setDynamicValue = function(key, value) {
  this.dynamicValue[key] = value;
};

LotteryData.prototype.getDynamicValue = function(key) {
  return this.dynamicValue[key];
};

LotteryData.prototype.getData = function(key) {
  var result = null;

  switch (key) {
    case 'paytablewinnings':
      result = this.gameConfig._winnings;
      break;

    case 'paytabletotalwinnings':
      result = this.gameConfig._totalWinnings;
      break;

    default:
      break;
  }
  return result;
};

LotteryData.prototype.getAudioDataDuration = function(id) {
  var result = null;

  if (!!this.gameSettings['audio']) {
    if (!!this.gameSettings['audio']['audioPositions']) {
      if (!!this.gameSettings['audio']['audioPositions'][id]) {
        result = this.gameSettings['audio']['audioPositions'][id]['duration'];
      }
    }
  }
  return result;
};

LotteryData.prototype.getDialogData = function(id) {
  var dialogsArray = this.dataDefinition.data['dialogs'];

  return dialogsArray[id];
};

LotteryData.prototype.getStates = function() {
  return this.dataDefinition.data['states'];
};

LotteryData.prototype.getDialogs = function() {
  return this.dataDefinition.data['dialogs'];
};

LotteryData.prototype.GetBasicStyle = function(style_id) {
  return this.styles.GetBasicStyleObject(style_id);
};

LotteryData.prototype.GetStyle = function(style_id, color_id) {
  return this.styles.GetStyleObject(style_id, color_id);
};

LotteryData.prototype.GetStyleColor = function(color_id) {
  return this.styles.GetStyleColor(color_id);
};

LotteryData.prototype.SetStyleColors = function(styles) {
  console.log('SetStyleColors');

  for (var i = 0; i < styles.length; i++) {
    this.styles.SetStyleColor(styles[i].id, styles[i].color);
  }
};

LotteryData.prototype.SetStyleDefaultColors = function(colors) {
  console.log('SetStyleDefaultColors');

  for (var key in colors) {
    if (colors.hasOwnProperty(key)) {
      this.styles.SetStyleDefaultColor(key, colors[key]);
    }
  }
};

LotteryData.prototype.SetStyle = function(id, object) {
  console.log('SetStyle');

  this.styles.SetStyle(id, object);
};

LotteryData.prototype.getBalance = function() {
  return this.player.balance;
};

LotteryData.prototype.setBalance = function(balance) {
  if (!!this.player) {
    this.player.balance = balance;
  }
};

LotteryData.prototype.getBonus = function() {
  return this.bonus;
};

LotteryData.prototype.setBonus = function(bonus) {
  this.bonus = bonus;
};

LotteryData.prototype.setDefaultPlayerSettings = function(defPlayerSettings) {
  for (var key in defPlayerSettings) {
    this.defaultPlayerSettings[key] = defPlayerSettings[key];
  }
};

LotteryData.prototype.getDefaultPlayerSettings = function() {
  return this.defaultPlayerSettings;
};

LotteryData.prototype.getGameConfig = function() {
  return this.gameConfig;
};

LotteryData.prototype.setSymbolLookupByGameConfig = function(gameConfig) {
  var arr = gameConfig.prizes,
    length = arr.length,
    i;

  var xIcons = gameConfig.xIcons.split(',');
  this.wagerXIconsLookup = {};

  for (i = 0; i < xIcons.length; i++) {
    this.wagerXIconsLookup[i + 1] = xIcons[i].toLowerCase();
  }

  this.symbolLookup = {};
  var mychar = 65;
  for (i = 0; i < gameConfig.xPrizes.length; i++) {
    var sym = '' + String.fromCharCode(mychar + i);
    this.symbolLookup[sym] = sym;
  }
  this.wagerIdentity = {};

  var symbolArray = arr.split(',');
  for (i = 0; i < symbolArray.length; i++) {
    this.wagerIdentity[i + 1] = symbolArray[i];
    this.symbolLookup[i + 1] = this.getFormatted(symbolArray[i], this.currency);
  }
};

LotteryData.prototype.setMultiplierLookupByGameConfig = function(gameConfig) {
  if (!!gameConfig.multiplicators) {
    var arr = gameConfig.multiplicators,
      length = arr.length,
      i;
    this.multiplierLookup = {};

    var multiplierArray = arr.split(',');
    for (i = 0; i < multiplierArray.length; i++) {
      this.multiplierLookup[i + 1] = parseInt(multiplierArray[i], 10);
    }
  } else {
    this.multiplierLookup[1] = '1';
  }
};

LotteryData.prototype.setGameConfig = function(gameConfig) {
  this.gameConfig = gameConfig;
  this.model = gameConfig.model.toLowerCase();

  this.currency = this.gameConfig.currency;
  this.setDynamicValue('icon', this.gameConfig.icon);
};

LotteryData.prototype.getWager = function() {
  return this.wager;
};

LotteryData.prototype.parseWager = function(wager) {
  function convertToLetter(s) {
    var c = parseInt(s, 10) + 64; 
    return '' + String.fromCharCode(c);
  }

  function getWinNumber(arr) {
    var indexesArray = [];
    var max = { key: 0, value: 0 };
    var key;

    for (var i = 0; i < arr.length; i++) {
      key = arr[i];

      if (indexesArray[key]) {
        indexesArray[key]++;
      } else {
        indexesArray[key] = 1;
      }
      if (max.value < indexesArray[key]) {
        max.key = key;
        max.value = indexesArray[key];
      }
    }
    if (max.value === 3) {
      return max.key;
    }
    return -1;
  }

  this.wagerData = { model: this.model };
  this.wagerData.extraIcon = '';
  var bet = wager.bets[0];
  var betData = bet['data'];

  var data_dict = (function(d) {
    var dict = {};
    for (var i = 0; i < d.length; i++) {
      var x = d[i].match(/(.+)=(.*)/);
      dict[x[1]] = x[2];
    }
    return dict;
  })(betData.split(';'));

  var raw_symbols_arr = data_dict['D'].split('/');
  var raw_symbols_arr_t = data_dict['T'].split('/');
  console.log('d=' + data_dict['D']);

  this.wagerData.winamount = raw_symbols_arr_t[3];
  this.wagerData.extraWinType = raw_symbols_arr_t[5];

  if (!!data_dict['SkinId']) {
    this.wagerData.skinid = parseInt(data_dict['SkinId'], 10);
  } else {
    this.wagerData.skinid = 0;
  }
  this.setDynamicValue('skinid', this.wagerData.skinid);

  if (raw_symbols_arr_t[0] === 'DEMO') {
    this.setDynamicValue('ticketid', 'DEMOLOTT');
  } else {
    this.setDynamicValue(
      'ticketid',
      this.gameConfig.cat1 + this.gameConfig.cat2 + '-' + raw_symbols_arr_t[0]
    );
  }

  this.wagerData.iswin = bet['status'] === 'WON';
  this.setFlag(LotteryData.Flag['won'], this.wagerData.iswin);
  this.wagerData.winningNumber = raw_symbols_arr[0].split(',').sort();
  this.wagerData.wagerWinningId = raw_symbols_arr[0].split(',').sort();

  this.wagerData.multiplier = this.multiplierLookup[
    parseInt(raw_symbols_arr[2], 10)
  ];
  var ordinary_symbols = raw_symbols_arr[1].split(',');
  var extra_symbols = raw_symbols_arr[3].split(',');

  this.setDynamicValue('winamount', Math.floor(wager.won));

  this.wagerData.wagerIdArray = [];
  for (var i = 0; i < ordinary_symbols.length; i++) {
    var xicon = '';
    if (ordinary_symbols[i].startsWith('X')) {
      this.wagerData.wagerIdArray[i] = this.wagerXIconsLookup[
        ordinary_symbols[i].substring(1)
      ];
    } else {
      if (extra_symbols[i] !== '0') {
        xicon = this.wagerXIconsLookup[extra_symbols[i]];
      }
      this.wagerData.wagerIdArray[i] =
        xicon + this.wagerIdentity[ordinary_symbols[i]];
    }
  }

  if (
    this.wagerData.winningNumber[0] > 0 ||
    this.wagerData.winningNumber[0].startsWith('X')
  ) {
    for (var j = 0; j < this.wagerData.winningNumber.length; j++) {
      this.wagerData.wagerWinningId[j] = this.wagerIdentity[
        this.wagerData.winningNumber[j]
      ];

      for (var i = 0; i < ordinary_symbols.length; i++) {
        if (
          ordinary_symbols[i] === this.wagerData.winningNumber[j] &&
          extra_symbols[i] > 0
        ) {
          this.wagerData.winningNumber = convertToLetter(extra_symbols[i]);
          this.wagerData.wagerWinningId[j] =
            this.wagerXIconsLookup[extra_symbols[i]] +
            this.wagerIdentity[ordinary_symbols[i]];
          this.wagerData.extraIcon = this.wagerXIconsLookup[extra_symbols[i]];
          break;
        } else if (
          ordinary_symbols[i] === this.wagerData.winningNumber[j] &&
          ordinary_symbols[i].startsWith('X')
        ) {
          this.wagerData.wagerWinningId[
            j
          ] = this.wagerData.extraIcon = this.wagerXIconsLookup[
            ordinary_symbols[i].substring(1)
          ];
          break;
        }
      }
    }
  }
  this.setDynamicValue('extraicon', this.wagerData.extraIcon);

  this.wagerData.symbols = ordinary_symbols;

  for (var i = 0; i < this.wagerData.symbols.length; i++) {
    if (extra_symbols[i] !== '0') {
      this.wagerData.symbols[i] = convertToLetter(extra_symbols[i]);
    }
  }

  this.wagerData.wagerMultiplierId = '';
  this.wagerData.wagerMultiplierFlagIsThird = false;
  var multiplierId = '';
  if (raw_symbols_arr.length > 4) {
    multiplierId = raw_symbols_arr[4].toLowerCase();

    switch (multiplierId) {
      case 'third':
        this.wagerData.wagerMultiplierId = this.wagerData.wagerIdArray.pop();
        this.wagerData.multiplier = this.wagerData.symbols.splice(-1, 1);
        this.wagerData.wagerMultiplierFlagIsThird = true;
        break;
      case 'star':
        this.wagerData.wagerMultiplierId = 'xstar';
        break;
      case '':
        this.wagerData.wagerMultiplierId =
          'x' + this.multiplierLookup[raw_symbols_arr[2]];
        break;
      case 'joker':
        this.wagerData.wagerMultiplierId =
          'x' + this.multiplierLookup[raw_symbols_arr[2]];
        var jokerArray = raw_symbols_arr[5].split(',');
        for (var i = 0; i < jokerArray.length; i++) {
          if (jokerArray[i] === '1') {
            this.wagerData.wagerIdArray[i] = 'joker';
          }
        }
        break;
      default:
        throw 'Error';
        break;
    }
  } else {
    this.wagerData.wagerMultiplierId =
      'x' + this.multiplierLookup[raw_symbols_arr[2]];
  }

  this.wagerData.prizes = [];

  this.wagerData.winSymbols = [];
  this.wagerData.winningIndexes = [];
  this.wagerData.winningMultiplier = false;
  if (this.wagerData.iswin) {
    this.wagerData.flagMultiplierPartOfWin = true;
  } else {
    this.wagerData.flagMultiplierPartOfWin = false;
  }

  if (multiplierId === 'star') {
    if (this.wagerData.iswin) {
      var winningNumber = getWinNumber(this.wagerData.symbols);
      for (i = 0; i < this.wagerData.symbols.length; i++) {
        if (this.wagerData.symbols[i] === winningNumber) {
          this.wagerData.winningIndexes.push(i);
        }
      }

      this.wagerData.winningMultiplier = true;
    } else {
      this.wagerData.flagMultiplierPartOfWin = false;
    }
  } else {
    for (var j = 0; j < this.wagerData.winningNumber.length; j++) {
      for (i = 0; i < this.wagerData.symbols.length; i++) {
        console.log(this.wagerData.symbols[i], this.wagerData.winningNumber[j]);
        if (this.wagerData.symbols[i] === this.wagerData.winningNumber[j]) {
          this.wagerData.winningIndexes.push(i);
          this.wagerData.winSymbols.push(1);
        } else {
          this.wagerData.winSymbols.push(0);
        }
      }
    }
    if (multiplierId === 'third') {
      this.wagerData.flagMultiplierPartOfWin = false;

      for (var i = 0; i < this.wagerData.wagerWinningId.length; i++) {
        if (
          this.wagerData.iswin &&
          this.wagerData.wagerWinningId[i] === this.wagerData.wagerMultiplierId
        ) {
          this.wagerData.winningMultiplier = true;
          this.wagerData.flagMultiplierPartOfWin = true;
        }
      }
    } else {
      this.wagerData.winningMultiplier =
        this.wagerData.multiplier > 1 ? true : false;
    }
  }

  this.wagerData.scratchArray = [];
  for (var i = 0; i < this.wagerData.symbols.length; i++) {
    this.wagerData.scratchArray[i] = this.symbolLookup[
      this.wagerData.symbols[i]
    ];
  }
};

LotteryData.prototype.parseWagerKryss = function(wager) {
  this.wagerData = { model: this.model };
  this.wagerData.extraIcon = '';
  var bet = wager.bets[0];
  var betData = bet['data'];

  var data_dict = (function(d) {
    var dict = {};
    for (var i = 0; i < d.length; i++) {
      var x = d[i].match(/(.+)=(.*)/);
      dict[x[1]] = x[2];
    }
    return dict;
  })(betData.split(';'));

  var raw_symbols_arr = data_dict['D'].split('/');
  var raw_symbols_arr_t = data_dict['T'].split('/');
  console.log('d=' + data_dict['D']);

  this.wagerData.winamount = raw_symbols_arr_t[3];
  this.wagerData.extraWinType = raw_symbols_arr_t[5];

  if (!!data_dict['SkinId']) {
    this.wagerData.skinid = parseInt(data_dict['SkinId'], 10);
  } else {
    this.wagerData.skinid = 0;
  }
  this.setDynamicValue('skinid', this.wagerData.skinid);

  if (raw_symbols_arr_t[0] === 'DEMO') {
    this.setDynamicValue('ticketid', 'DEMOLOTT');
  } else {
    this.setDynamicValue(
      'ticketid',
      this.gameConfig.cat1 + this.gameConfig.cat2 + '-' + raw_symbols_arr_t[0]
    );
  }

  this.wagerData.iswin = bet['status'] === 'WON';
  this.setFlag(LotteryData.Flag['won'], this.wagerData.iswin);
  this.wagerData.winningNumber = raw_symbols_arr[0].split(',');
  this.wagerData.gameTable = raw_symbols_arr[2];
  this.wagerData.symbols = raw_symbols_arr[1].split(',');

  this.wagerData.extra = null;
  if (!!raw_symbols_arr[3]) {
    this.wagerData.extra = raw_symbols_arr[3].split(',');
  }

  this.wagerData.extra2 = null;
  if (!!raw_symbols_arr[4]) {
    this.wagerData.extra2 = raw_symbols_arr[4].split(',');
  }

  this.setDynamicValue('winamount', Math.floor(wager.won));
};

LotteryData.prototype.getScratchData = function() {
  return this.wagerData;
};

LotteryData.prototype.getScratchIndexes = function() {
  return this.wagerData.winningIndexes;
};

LotteryData.prototype.setWager = function(wager) {
  this.wager = wager;

  switch (this.model) {
    case 'kryss':
    case 'bingo':
    case 'pyramidkeno':
    case 'scratchandmatch':
      this.parseWagerKryss(wager);
      break;
    default:
      this.parseWager(wager);
      break;
  }
};

LotteryData.prototype.setNextWager = function(wager) {
  this.next_wager = wager;
  this.setFlag(
    LotteryData.Flag['ongoing'],
    this.getFlag(LotteryData.Flag['next_ongoing'])
  );
  this.setFlag(
    LotteryData.Flag['free'],
    this.getFlag(LotteryData.Flag['next_free'])
  );
};

LotteryData.prototype.parseNextWagerSkin = function(wager) {
  var bet = wager.bets[0];
  var betData = bet['data'];

  var data_dict = (function(d) {
    var dict = {};
    for (var i = 0; i < d.length; i++) {
      var x = d[i].match(/(.+)=(.*)/);
      dict[x[1]] = x[2];
    }
    return dict;
  })(betData.split(';'));

  var nextSkinId = !!data_dict['SkinId']
    ? parseInt(data_dict['SkinId'], 10)
    : 0;
  return nextSkinId;
};

LotteryData.prototype.setNextWagerToCurrent = function() {
  this.setWager(this.next_wager);
};

LotteryData.prototype.getAnimation = function(string_id) {
  var animations = JSON.parse(
    JSON.stringify(this.dataDefinition.data['animations'][string_id])
  ); 
  return animations;
};

LotteryData.prototype.getColor = function(string_id) {
  var color = { color: '#ffffff' }; 
  try {
    color = JSON.parse(
      JSON.stringify(this.defaultDefinition.data['colors'][string_id])
    ); 
  } catch (e) {
    var data = {
      request: 'internal',
      rc: 612,
      msg: 'Missing color definition:' + string_id
    };
    ViewController.getInstance().sendEvent(EventModel.events._error, data);
  }
  return color;
};

LotteryData.prototype.getLink = function(string_id) {
  var link = '';
  if (!!this.links[string_id]) {
    link = this.links[string_id].link;
  }
  return link;
};

LotteryData.prototype.getText = function(string_id) {
  try {
    var text = JSON.parse(
      JSON.stringify(this.defaultDefinition.data['texts'][string_id])
    ); 

    if (text['flag'] === 'random') {
      var array = text.value;
      var index = Math.floor(Math.random() * array.length);
      console.log('Random value ' + index);
      text.value = array[index];
    } else {
      if (!text) {
        return string_id;
      }

      if (!!text.value) {
        for (var i = 0; i < arguments.length; i++) {
          var str = '%' + i.toString();
          text.value = text.value.split(str).join(arguments[i]);
        }
      } else {
        if (arguments.length === 1) {
          text.value = '';
        } else {
          text.value = arguments[1]; 
        }
      }
    }
    return text;
  } catch (err) {
    console.warn('Missing text key ' + string_id);
    return string_id;
  }
};

LotteryData.prototype.getPlayer = function() {
  return this.player;
};

LotteryData.prototype.getSettings = function() {
  return this.settings;
};

LotteryData.prototype.setSettings = function(settings) {
  for (var p in settings) {
    this.settings[p] = settings[p];
  }
  this.settings.session = 'cookie'; 
};

LotteryData.prototype.getGameSettings = function() {
  return this.gameSettings;
};

LotteryData.prototype.setupContainerLinks = function() {
  if (
    typeof window['NYX']['lottery']['generic']['cb']['setuplinks'] ===
    'function'
  ) {
    window['NYX']['lottery']['generic']['cb']['setuplinks'](this.links);
  }
};

LotteryData.prototype.setLink = function(data) {
  var link = data['url'];
  var delimiter = '?';

  if (data['url'].indexOf(delimiter) !== -1) {
    delimiter = '&';
  }

  if (!!data['param']) {
    if (data['param'].indexOf('session') !== -1) {
      link += delimiter + 'session=' + this.settings.session;
      delimiter = '&';
    }
    if (data['param'].indexOf('gameid') !== -1) {
      link += delimiter + 'gameid=' + this.settings.gameid;
      delimiter = '&';
    }
  }

  data.link = link;
  return data;
};


LotteryData.prototype.setGameSettings = function(game_settings) {
  for (var p in game_settings) {
    this.gameSettings[p] = game_settings[p];
  }

  if (!!game_settings['links']) {
    var linkData = game_settings['links'];
    for (var i = 0; i < linkData.length; i++) {
      this['links'][linkData[i]['id']] = this.setLink(linkData[i]);
    }
  }

  if (!!game_settings['colors']) {
    var colorData = game_settings['colors'];
    for (var c in colorData) {
      this.colors[c] = colorData[c];
    }
  }

  if (!!game_settings['texts']) {
    var textData = game_settings['texts'];
    for (var t in textData) {
      this.texts[t] = textData[t];
    }
  }

  if (!!game_settings['animations']) {
    var animData = game_settings['animations'];
    for (var a in animData) {
      this.animations[a] = animData[a];
    }
  }

  if (!!game_settings.id) {
    var name = '';
    if (!!game_settings.id.name) {
      name = game_settings.id.name;
    }
    var version = '';
    if (!!game_settings.id.version) {
      version = game_settings.id.version;
    }
    this.setDynamicValue('gameidandversion', name + ', version:' + version);

    if (!!game_settings.id.title) {
      document.title = game_settings.id.title;
    }
  }
  if (!!game_settings['formatting']) {
    this.thousandSeparator = game_settings['formatting']['thousandSeparator'];
  }
};

LotteryData.prototype.findLayoutObject = function(id, layoutArray) {
  if (layoutArray.constructor === Array) {
    for (var i = 0; i < layoutArray.length; i++) {
      if (layoutArray[i].id === id) {
        return layoutArray[i];
      }
    }
  } else {
    return layoutArray[id];
  }
  return null;
};

LotteryData.prototype.setLayout = function(game_layout) {
  this.defaultDefinition.setLayout(game_layout);
};

LotteryData.prototype.GetResources = function() {
  return this.resources;
};

LotteryData.prototype.SetResources = function(resources) {
  this.resources = resources;
};

LotteryData.prototype.getCurrency = function() {
  return this.currency;
};

LotteryData.prototype.getFormatted = function(value, currency) {
  if (value === '') {
    return '';
  }
  var result = value
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandSeparator);
  return this.currencies.getFormatted(result, currency);
};


LotteryData.prototype.getPredefinedDemoWager = function(betDataArray) {
  var index = Math.floor(Math.random() * betDataArray.length);
  var betData = betDataArray[index];

  var wager = JSON.parse(JSON.stringify(this.demoDefinition.basedata.wager));

  var data = betData.data.split(';');
  if (data.length < 5) {
    ViewController.getInstance().sendEvent(EventModel.events._error, {
      request: 'internal',
      rc: 630,
      msg: 'Wrong format for demo data.'
    });
    return null;
  }
  var raw_symbols_arr_t = data[4].split('/');
  var wonString = raw_symbols_arr_t[3];
  var wonAmount;

  if (isNaN(wonString)) {
    var wonData = wonString.split(':');
    wonAmount = this.gameConfig._prizesSorted[parseInt(wonData[1], 10) - 1]; 
    raw_symbols_arr_t[3] = wonAmount;
    data[4] = raw_symbols_arr_t.join('/');
  } else {
    wonAmount = parseInt(raw_symbols_arr_t[3], 10);
  }

  wager.won = raw_symbols_arr_t[3];
  wager.bets[0].status = wonAmount > 0 ? 'WON' : 'LOST';
  wager.bets[0].data = data.join(';');

  return wager;
};

LotteryData.prototype.getDemoWager = function(data) {
  if (!!this.dataDefinition.data['demo']) {
    return this.getPredefinedDemoWager(this.dataDefinition.data['demo']);
  } else {
    return this.demoDefinition.getDemoWager(data);
  }
};

LotteryData.prototype.Clear = function() {
  this.gameConfig = new GameConfig();
  this.round = null;
  this.roundInfo = null;
  this.tickets = [];
  this.bets = [];
};

LotteryData.prototype.toJson = function() {
  return JSON.stringify(this);
};

var ___correctObject___LotteryData = '___LotteryData.___correctObject___blabla';
var ___instance___LotteryData = null;
LotteryData.getInstance = function() {
  if (___instance___LotteryData == null) {
    ___instance___LotteryData = new LotteryData(___correctObject___LotteryData);
  }
  return ___instance___LotteryData;
};

function Player() {
  this.accountType = '';
  this.city = '';
  this.country = '';
  this.currency = '';
  this.email = '';
  this.firstName = '';
  this.hasProfile = '';
  this.lastName = '';
  this.latestChange = '';
  this.nickname = '';
  this.nyxAccount = '';
  this.operator = '';
  this.session = '';
  this.supportSteam = '';
  this.userId = '';
  this.username = '';
  this.balance = {
    currency: '',
    amount: 0,
    winnings: '',
    mileage: ''
  };
  this.bonus = {
    currency: '',
    amount: 0
  };
  this.credit = {
    currency: '',
    amount: ''
  };

  this.careof = '';
  this.phone = '';
  this.street = '';
  this.zip = '';
}
ClassUtil.CreateClass(Player);

Player.prototype.ParseXML = function(node) {
  this.accountType = node.getAttribute('accounttype');
  this.city = node.getAttribute('city');
  this.country = node.getAttribute('country');
  this.currency = node.getAttribute('currency');
  this.email = node.getAttribute('email');
  this.firstName = node.getAttribute('firstname');
  this.hasProfile = node.getAttribute('hasprofile');
  this.lastName = node.getAttribute('lastname');
  this.latestChange = node.getAttribute('LatestChange');
  this.nickname = node.getAttribute('nickname');
  this.nyxAccount = node.getAttribute('NyxAccount');
  this.operator = node.getAttribute('operator');
  this.session = node.getAttribute('session');
  this.supportSteam = node.getAttribute('supportsteam');
  this.userId = node.getAttribute('userid');
  this.username = node.getAttribute('username');

  this.careof = node.getAttribute('careof');
  this.phone = node.getAttribute('phone');
  this.street = node.getAttribute('street');
  this.zip = node.getAttribute('zip');

  var balanceNode = node.nextSibling;
  this.balance.currency = balanceNode.getAttribute('currency');
  this.balance.amount = balanceNode.getAttribute('amount');
  this.balance.winnings = balanceNode.getAttribute('winnings');
  this.balance.mileage = balanceNode.getAttribute('mileage');

  var bonusNode = ApiResponse.getSibling(node, 'bonus');
  this.bonus.currency = bonusNode.getAttribute('currency');
  this.bonus.amount = bonusNode.getAttribute('amount');
};

function SnapshootTime() {
  this.t = '';
}
ClassUtil.CreateClass(SnapshootTime);

SnapshootTime.prototype.parseXML = function(timeNode) {
  this.t = timeNode.getAttribute('T');
};

function LastWin() {
  this.winData = '';
}
ClassUtil.CreateClass(LastWin);

LastWin.prototype.parseXML = function(lastWinNode) {
  this.winData = lastWinNode.getAttribute('data');
};

function Bet() {
  this.id = '';
  this.created = '';
  this.step = '';
  this.gameId = '';
  this.roundId = '';
  this.ba = '';
  this.bc = '';
  this.wa = '';
  this.wc = '';
  this.ns = '';
  this.cmds = '';
  this.status = '';
  this.payId = '';
  this.ticketId = '';
  this.data = '';
}
ClassUtil.CreateClass(Bet);

Bet.prototype.parseXML = function(betNode) {
  this.id = betNode.getAttribute('id');
  this.created = betNode.getAttribute('created');
  this.step = betNode.getAttribute('step');
  this.gameId = betNode.getAttribute('gameid');
  this.roundId = betNode.getAttribute('roundid');
  this.ba = betNode.getAttribute('ba');
  this.bc = betNode.getAttribute('bc');
  this.wa = betNode.getAttribute('wa');
  this.wc = betNode.getAttribute('wc');
  this.ns = betNode.getAttribute('ns');
  this.cmds = betNode.getAttribute('cmds');
  this.status = betNode.getAttribute('status'); 
  this.payId = betNode.getAttribute('payid'); 

  var params = betNode.getAttribute('params'); 
  this.ticketId = params.split('ticketid=')[1];

  this.data = betNode.getAttribute('data'); 
};

function Wager() {
  this.id = '';
  this.userid = '';
  this.betted = '';
  this.won = '';

  this.bets = [];
}
ClassUtil.CreateClass(Wager);

Wager.prototype.parseXML = function(node) {
  this.id = node.getAttribute('id'); 
  this.userid = node.getAttribute('userid'); 
  this.betted = node.getAttribute('betted'); 
  this.won = node.getAttribute('won'); 

  this.bets = [];

  var betNode = ApiResponse.getChild(node, 'bet');
  while (betNode != null) {
    var bet = new Bet();
    bet.parseXML(betNode);
    this.bets.push(bet);
    betNode = betNode.nextSibling;
  }
};

function Balance() {
  this.currency = '';
  this.amount = '';
  this.winnings = '';
  this.mileage = '';
}
ClassUtil.CreateClass(Balance);

Balance.prototype.parseXML = function(node) {
  this.currency = node.getAttribute('currency');
  this.amount = node.getAttribute('amount');
  this.winnings = node.getAttribute('winnings');
  this.mileage = node.getAttribute('mileage');

};

function Bonus() {
  this.currency = '';
  this.amount = 0;
}
ClassUtil.CreateClass(Bonus);

Bonus.prototype.parseXML = function(node) {
  this.currency = node.getAttribute('currency');
  this.amount = node.getAttribute('amount');
};

function Currency() {
  this.id = '';
  this.amount = 0;
}
ClassUtil.CreateClass(Currency);

Currency.prototype.parseXML = function(node) {
  this.id = node.getAttribute('id');
  this.amount = node.getAttribute('amount');
};

function Credit() {
  this.currency = '';
  this.amount = 0;
}
ClassUtil.CreateClass(Credit);

Credit.prototype.parseXML = function(node) {
  this.currency = node.getAttribute('currency');
  this.amount = node.getAttribute('amount');
};

function Currencies(object) {
  for (var key in object) {
    this[key] = object[key];
  }
}
ClassUtil.CreateClass(Currencies);

Currencies.prototype.getFormatted = function(value, currency) {
  if (!!this[currency]) {
    return this[currency].replace('%0', value);
  }
  return value;
};

function EventModel() {}
ClassUtil.CreateClass(EventModel);

EventModel.events = {
  audioon: 'audioon', 
  audiooff: 'audiooff', 
  do_buy: 'do_buy', 
  do_check: 'do_check', 
  do_playdemo: 'do_playdemo', 
  do_playnext: 'do_playnext', 
  ev_resultpresented: 'ev_resultpresented', 
  view_info: 'view_info', 
  view_play: 'view_play', 
  getbalance: 'getbalance', 

  _error: '_error', 
  _fail: '_fail', 
  _fatalerror: '_fatalerror', 
  _login: '_login', 

  _audio: '_audio', 
  _do_init: '_do_init', 
  _do_load: '_do_load', 
  _do_replay: '_do_replay', 
  _do_play_replay: '_do_play_replay', 
  _do_hide_loader: '_do_hide_loader', 

  _loadedsettings: '_loadedsettings', 
  _loadedresources: '_loadedresources', 
  _loadedresourcesfailed: '_loadedresourcesfailed', 

  notify: 'notify',
  proxyResponse: 'proxyResponse',
  ticketSetup: 'ticketSetup',
  ticketLoad: 'ticketLoad',
  ticketLoadDemo: 'ticketLoadDemo',
  ticketPayGame: 'ticketPayGame',
  ticketGetGames: 'ticketGetGames',
  ticketGetGameConfig: 'ticketGetGameConfig',
  login: 'login',
  getBalance: 'getBalance',

  _ev_gameResult: '_ev_gameResult',
  _do_checkifwager: '_do_checkifwager', 
  _ev_communicationfailed: '_ev_communicationfailed', 
  _ev_communicationproblem: '_ev_communicationproblem', 
  _ev_communicationok: '_ev_communicationok', 
  _ev_deposit: '_ev_deposit', 
  _ev_initialized: '_ev_initialized', 
  _ev_loggedout: '_ev_loggedout', 
  _ev_message: '_ev_message', 
  _ev_ticketreadytoplay: '_ev_ticketreadytoplay', 
  _ev_ticketresult: '_ev_ticketresult', 
  _ev_replay: '_ev_replay', 
  _do_loadgameassets: '_do_loadgameassets', 
  _play: '_play' 
};

EventModel.prototype.onEvent = function(eventName, data) {
  console.warn('Implementation of onEvent missing');
};

EventModel.prototype.sendEvent = function(eventName, data) {};

function ApiResponse() {
  this.request = null;
  this.rc = null;

  this.msg = '';
}
ClassUtil.CreateClass(ApiResponse);

ApiResponse.prototype.parseXML = function(node) {};

ApiResponse.getChild = function(parent, name) {
  for (var i = 0; i < parent.childNodes.length; i++) {
    var sibling = parent.childNodes[i];
    if (!!sibling.localName && sibling.localName.toLowerCase() === name) {
      return sibling;
    }
  }
  return null;
};

ApiResponse.getSibling = function(node, name) {
  var parent = node.parentNode;

  return ApiResponse.getChild(parent, name);
};

function ApiRequest() {
  this.request = null;
}
ClassUtil.CreateClass(ApiRequest);

ApiRequest.prototype.serialize = function() {
  return {};
};

ApiRequest.prototype.toXML = function() {
  var data = this.serialize();

  if (this.request == null) {
    throw new Error('Missing Request name');
  }

  var doc = '<' + this.request;

  for (var key in data) {
    if (key != 'request') {
      doc += ' ' + key + '="' + data[key] + '"';
    }
  }
  doc += ' />';
  return doc;
};

function FailedResponse() {
  this.request = 'Failed';
  this.valid = true;

}
ClassUtil.CreateClass(FailedResponse);

FailedResponse.prototype.parseXML = function(xml) {
  var node = xml;
};

function LoginResponse() {
  this.request = 'Login';

  this.player = null;
  this.loggedIn = false;
}
ClassUtil.CreateClass(LoginResponse, ApiResponse);

LoginResponse.prototype.parseXML = function(xml) {
  var node = xml;
  this.rc = parseInt(node.getAttribute('rc'), 10);

  if (this.rc !== 0) {
    this.msg = node.getAttribute('msg');
    this.loggedIn = false;
  } else {
    this.loggedIn = true;

    node = node.firstChild;
    this.player = new Player();
    this.player.ParseXML(node);
  }
};

function LoginRequest(data) {
  this.request = 'Login';
  this.language = data.language; 
  this.skin = data.skin;
  this.operator = data.operator;
  this.partner = data.partner;

  this.channel = 'I';
  this.universe = 'Default';

}
ClassUtil.CreateClass(LoginRequest, ApiRequest);

LoginRequest.prototype.serialize = function() {
  var data = {
    request: this.request,
    language: this.language,
    skin: this.skin,
    operator: this.operator,
    partner: this.partner,
    channel: 'I',
    universe: 'Default'
  };
  return data;
};

function GetBalanceResponse() {
  this.request = 'GetBalance';

  this.user = null;
  this.loggedIn = false;
  this.balance = null;
  this.bonus = null;
  this.credit = null;
}
ClassUtil.CreateClass(GetBalanceResponse, ApiResponse);

GetBalanceResponse.prototype.parseXML = function(node) {
  this.rc = parseInt(node.getAttribute('rc'), 10);

  if (this.rc !== 0) {
    this.loggedIn = false;
    this.msg = node.getAttribute('msg');
    this.action = node.getAttribute('action');
  } else {
    this.loggedIn = true;

    var userNode = ApiResponse.getChild(node, 'user');
    this.user = new Player();
    this.user.ParseXML(userNode);

    var balanceNode = ApiResponse.getChild(node, 'balance');
    this.balance = new Balance();
    this.balance.parseXML(balanceNode);

    var bonusNode = ApiResponse.getChild(node, 'bonus');
    this.bonus = new Bonus();
    this.bonus.parseXML(bonusNode);

    var creditNode = ApiResponse.getChild(node, 'credit');
    this.credit = new Credit();
    this.credit.parseXML(creditNode);

  }
};

function GetBalanceRequest(data) {
  this.request = 'GetBalance';
  this.session = data.session;

  this.operator = data.operator; 
  this.partner = data.partner; 
  this.skin = data.skin; 
  this.language = data.language; 
}
ClassUtil.CreateClass(GetBalanceRequest, ApiRequest);

GetBalanceRequest.prototype.serialize = function() {
  var data = {
    request: this.request,
    session: this.session,

    operator: this.operator,
    partner: this.partner,
    skin: this.skin,
    language: this.language
  };
  return data;
};

function GetGameConfigResponse() {
  this.request = 'GetGameConfig';

  this.valid = false;
  this.config = {};

  this.msg = '';
}
ClassUtil.CreateClass(GetGameConfigResponse, ApiResponse);

GetGameConfigResponse.prototype.parseXML = function(node) {
  this.rc = parseInt(node.getAttribute('rc'), 10);

  if (this.rc !== 0) {
    this.msg = node.getAttribute('msg');
    return;
  }

  var configNode = ApiResponse.getChild(node, 'config');

  this.gameConfig = new GameConfig();
  this.gameConfig.parseXML(configNode);
};

function GetGameConfigRequest(data) {
  this.request = 'GetGameConfig';
  this.gameid = data.gameId;
  this.operator = data.operator; 
  this.partner = data.partner; 
  this.skin = data.skin; 
  this.language = data.language; 
}
ClassUtil.CreateClass(GetGameConfigRequest, ApiRequest);

GetGameConfigRequest.prototype.serialize = function() {
  var data = {
    request: this.request,
    gameid: this.gameid,

    operator: this.operator,
    partner: this.partner,
    skin: this.skin,
    language: this.language
  };
  return data;
};

 function GetGameResultResponse() {
  this.request = 'GetGameResult';

  this.wager = null;

  this.balance = null;
  this.bonus = null;

  this.msg = '';
}
ClassUtil.CreateClass(GetGameResultResponse, ApiResponse);

GetGameResultResponse.prototype.parseXML = function(node) {
  this.rc = parseInt(node.getAttribute('rc'), 10);

  if (this.rc !== 0) {
    this.valid = false;
    this.msg = node.getAttribute('msg');
  } else {
    this.valid = true;

    var wagerNode = ApiResponse.getChild(node, 'wager');

    this.wager = new Wager();
    this.wager.parseXML(wagerNode);

    var balanceNode = ApiResponse.getChild(node, 'balance');

    this.balance = new Balance();
    this.balance.parseXML(balanceNode);

    var bonusNode = ApiResponse.getChild(node, 'bonus');

    this.bonus = new Bonus();
    this.bonus.parseXML(bonusNode);
  }
};

function GetGameResultRequest(data) {
  this.request = 'GetGameResult';
  this.gameid = data.gameid;
  this.operator = data.operator; 
  this.partner = data.partner; 
  this.skin = data.skin; 
  this.language = data.language; 

  this.session = data.session;
  this.wagerid = data.wagerid;
  this.p1 = data.p1;
}
ClassUtil.CreateClass(GetGameResultRequest, ApiRequest);

GetGameResultRequest.prototype.serialize = function() {
  var data = {
    request: this.request,
    gameid: this.gameid,

    operator: this.operator,
    partner: this.partner,
    skin: this.skin,
    language: this.language,

    session: this.session,
    wagerid: this.wagerid,
    p1: this.p1
  };
  return data;
};

function GetGamesResponse() {
  this.request = 'GetGames2';

  this.games = [];
}
ClassUtil.CreateClass(GetGamesResponse, ApiResponse);

GetGamesResponse.prototype.parseXML = function(node) {
  this.rc = parseInt(node.getAttribute('rc'), 10);

  if (this.rc !== 0) {
    this.msg = node.getAttribute('msg');
  } else {
    this.games = [];
    var gamesNode = ApiResponse.getChild(node, 'games');
    var gameChildNodes = gamesNode.childNodes || gamesNode.children;

    for (var i = 0; i < gameChildNodes.length; i++) {
      var gameNode = gameChildNodes[i];
      var game = new Game();
      game.parseXML(gameNode);
      this.games.push(game);
    }

    var timeNode = ApiResponse.getChild(node, 'time');
    if (!!timeNode) {
      this.snapshootTime = new SnapshootTime();
      this.snapshootTime.parseXML(timeNode);
    }
    var lastWinNode = ApiResponse.getChild(node, 'lastwin');
    if (!!lastWinNode) {
      this.lastWin = new LastWin();
      this.lastWin.parseXML(lastWinNode);
    }
  }
};

function GetGamesRequest(data) {
  this.request = 'GetGames2';
  this.operator = data.operator; 
  this.partner = data.partner; 
  this.skin = data.skin; 
  this.language = data.language; 

  this.subsystem = data.subsystem;

  this.channel = data.channel;

  if (this.subsystem.toLowerCase() === 'bingo') {
    this.schema = 'Y';
    this.lastwin = '5';
  }
}
ClassUtil.CreateClass(GetGamesRequest, ApiRequest);

GetGamesRequest.prototype.serialize = function() {
  var data = {
    request: this.request,

    operator: this.operator,
    partner: this.partner,
    skin: this.skin,
    language: this.language,

    subsystem: this.subsystem,
    channel: this.channel
  };

  if (this.subsystem.toLowerCase() === 'bingo') {
    data['schema'] = this.schema;
    data['lastwin'] = this.lastwin;
  }

  return data;
};

function GetWagerResponse() {
  this.request = 'GetWager';

  this.valid = false;

  this.empty = true;

  this.gameConfig = null;
  this.wager = null;

  this.msg = '';
}
ClassUtil.CreateClass(GetWagerResponse, ApiResponse);

GetWagerResponse.prototype.parseXML = function(node) {
  this.rc = parseInt(node.getAttribute('rc'), 10);

  if (this.rc === 1022) {
    this.valid = true;
    this.msg = node.getAttribute('msg');
    return;
  } else if (this.rc !== 0) {
    this.valid = false;
    this.msg = node.getAttribute('msg');
    return;
  }
  this.empty = false;
  this.valid = true;

  var wagerNode = ApiResponse.getChild(node, 'wager');

  this.wager = new Wager();
  this.wager.parseXML(wagerNode);

  var configNode = ApiResponse.getChild(node, 'config');

  this.gameConfig = new GameConfig();
  this.gameConfig.parseXML(configNode);
};

function GetWagerRequest(data) {
  this.request = 'GetWager';

  this.gameid = data.gameid;
  this.session = data.session;
  this.operator = data.operator;
  this.partner = data.partner;

  this.wagerid = 0;
  if (!!data.wagerid) {
    this.wagerid = data.wagerid;
  }
  this.skin = data.skin;
  this.language = data.language;

  if (!!data.ref) {
    this.ref = data.ref;
  }

}
ClassUtil.CreateClass(GetWagerRequest, ApiRequest);

GetWagerRequest.prototype.serialize = function() {
  var data = {
    request: this.request,
    session: this.session,
    gameid: this.gameid,
    wagerid: this.wagerid,
    operator: this.operator,
    partner: this.partner,
    skin: this.skin,
    language: this.language
  };

  if (!!this.ref) {
    data['ref'] = this.ref;
  }
  return data;
};

function PayGameResponse() {
  this.request = 'PayGame';

  this.rc = '';

  this.wager = null;

  this.balance = null;

  this.bonus = null;

  this.msg = '';
  this.action = '';
}
ClassUtil.CreateClass(PayGameResponse, ApiResponse);

PayGameResponse.prototype.parseXML = function(node) {
  this.rc = parseInt(node.getAttribute('rc'), 10);

  if (this.rc !== 0) {
    this.msg = node.getAttribute('msg');
    this.action = node.getAttribute('action');
  } else {
    var wagerNode = ApiResponse.getChild(node, 'wager');

    this.wager = new Wager();
    this.wager.parseXML(wagerNode);

    var balanceNode = ApiResponse.getChild(node, 'balance');

    this.balance = new Balance();
    this.balance.parseXML(balanceNode);

    var bonusNode = ApiResponse.getChild(node, 'bonus');

    this.bonus = new Bonus();
    this.bonus.parseXML(bonusNode);
  }
};

function PayGameRequest(data) {
  this.request = 'PayGame';

  this.session = data.session;
  this.gameid = data.gameid;
  this.operator = data.operator;
  this.partner = data.partner;
  this.skin = data.skin;
  this.language = data.language;
  this.wagerId = data.wagerid;
  this.p1 = data.p1;

  if (!!data.skinid) {
    this.skinid = data.skinid;
  }

  if (!!data.voucherid) {
    this.voucherid = data.voucherid;
  }
}
ClassUtil.CreateClass(PayGameRequest, ApiRequest);

PayGameRequest.prototype.serialize = function() {
  var data = {
    request: this.request,
    session: this.session,
    gameid: this.gameid,
    operator: this.operator,
    partner: this.partner,
    skin: this.skin,
    language: this.language,
    wagerid: this.wagerId,
    p1: this.p1
  };

  if (!!this.skinid) {
    data['SkinId'] = this.skinid;
  }

  if (!!this.voucherid) {
    data['voucherid'] = this.voucherid;
  }

  console.log('PayGameRequest.prototype.serialize data = ', data);
  return data;
};


var MessageTypes = {
  Login: {
    Request: LoginRequest,
    Response: LoginResponse
  },
  GetBalance: {
    Request: GetBalanceRequest,
    Response: GetBalanceResponse
  },
  GetGameConfig: {
    Request: GetGameConfigRequest,
    Response: GetGameConfigResponse
  },
  GetGameResult: {
    Request: GetGameResultRequest,
    Response: GetGameResultResponse
  },
  GetGames2: {
    Request: GetGamesRequest,
    Response: GetGamesResponse
  },
  PayGame: {
    Request: PayGameRequest,
    Response: PayGameResponse
  },
  GetWager: {
    Request: GetWagerRequest,
    Response: GetWagerResponse
  },
  Failed: {
    Request: null,
    Response: FailedResponse
  }
};

function ServerConnection() {}
ClassUtil.CreateClass(ServerConnection);
ClassUtil.CreateEventDispatcher(ServerConnection);

ServerConnection.Events.Complete = 'Complete';
ServerConnection.Events.Failed = 'Failed';
ServerConnection.Events.Problem = 'Problem';

ServerConnection.prototype.SerializeForURL = function(object) {
  var string_array = [];
  for (var p in object) {
    if (object.hasOwnProperty(p)) {
      string_array.push(
        encodeURIComponent(p) + '=' + encodeURIComponent(object[p])
      );
    }
  }
  return string_array.join('&');
};

function NYXServerConnection() {
  var nyxroot = LotteryData.getInstance().getSettings().nyxroot;

  if (nyxroot[nyxroot.length - 1] !== '/') {
    nyxroot += '/';
  }

  this.accountUrl = nyxroot + 'nyx/account/accountweb.dll';
  this.gameUrl = nyxroot + 'nyx/game/gameweb.dll';
  this.gameqUrl = nyxroot + 'nyxq/gameweb.dll';

  this.queue = new Array();
  this.keys = {};
  this.counter = 5;

  this.currentRequestObject = null;
}
ClassUtil.CreateClass(NYXServerConnection, ServerConnection);
ClassUtil.CreateEventDispatcher(NYXServerConnection);

NYXServerConnection.prototype.Request = function(id, request, queue, required) {
  var requestObject = { id: id, request: request, required: required };
  if (queue) {
    this.queue.push(requestObject);
  } else {
    this.Load(requestObject);
  }
};

NYXServerConnection.prototype.Load = function(data_object) {
  this.keys[data_object.request.request] = data_object.id;
  this.currentRequestObject = data_object;
  var httpRequest = Device.CreateHTTPRequest();
  httpRequest.onreadystatechange = this.HandleResponse.bind(this, httpRequest);

  httpRequest.open('POST', this.gameUrl, true);
  httpRequest.withCredentials = true;
  var xml = data_object.request.toXML();
  httpRequest.send(xml);

};

NYXServerConnection.prototype.HandleResponse = function(http_request) {
  if (http_request.readyState === 4) {
    if (http_request.status === 200) {
      this.counter = 0;

      var xmlResponse = http_request.responseXML;

      var response = this.ProcessResponse(xmlResponse);
      if (
        this.currentRequestObject.required == true &&
        response.valid == false
      ) {
        setTimeout(this.Load.bind(this, this.currentRequestObject), 300);
        return;
      }

      if (this.queue.length > 0) {
        var nextRequestObject = this.queue[0];
        this.queue.shift();
        this.Load(nextRequestObject);
      }
      this.DispatchEvent(ServerConnection.Events.Complete, response);
    } else {
      if (http_request.status >= 400 && http_request.status < 500) {
        var response = new FailedResponse();
        response.id = this.currentRequestObject.id;
        response.httpRequest = http_request;

        if (this.queue.length > 0) {
          var nextRequestObject = this.queue[0];
          this.queue.shift();
          this.Load(nextRequestObject);
        }
        this.DispatchEvent(ServerConnection.Events.Complete, response);
      } else if (http_request.status >= 500 && http_request.status < 600) {
        this.counter++;
        if (this.counter === 10) {
          this.counter = 0;
          this.DispatchEvent(ServerConnection.Events.Problem, {
            httprequest: http_request,
            request: this.currentRequestObject
          });
        }
        setTimeout(this.Load.bind(this, this.currentRequestObject), 1000);
      } else {
        setTimeout(this.Load.bind(this, this.currentRequestObject), 300);
      }
    }
  }
};

NYXServerConnection.prototype.ProcessResponse = function(responseXML) {
  var node = responseXML.firstChild;

  for (var key in MessageTypes) {
    if (MessageTypes.hasOwnProperty(key)) {
      if (key == node.getAttribute('request')) {
        var response = new MessageTypes[key].Response();
        response.id = this.keys[key];
        response.parseXML(node);
        return response;
      }
    }
  }
  console.warn('Failed to find response object for: ', node);
  var failedResponse = new FailedResponse();
  failedResponse.parseXML(node);
  failedResponse.id = this.currentRequestObject.id;
  return failedResponse;
};

function DataLayer() {}
ClassUtil.CreateClass(DataLayer);

DataLayer.Events.Problem = '_communicationproblem';
DataLayer.Events.Ok = '_communicationok';

DataLayer.prototype.GetResponses = function(id) {
  return null;
};


function NYXDataLayer(server_connection) {
  this.serverConnection = server_connection;

  this.serverConnection.AddEventListener(
    ServerConnection.Events.Complete,
    this.handleResponse,
    this
  );
  this.serverConnection.AddEventListener(
    ServerConnection.Events.Failed,
    this.onFailed,
    this
  );
  this.serverConnection.AddEventListener(
    ServerConnection.Events.Problem,
    this.onProblem,
    this
  );

  this.responses = {};

  this.loadCount = {};

  this.failCount = 0;

  this.communicationProblem = false;
}
ClassUtil.CreateClass(NYXDataLayer, DataLayer);
ClassUtil.CreateEventDispatcher(NYXDataLayer);

NYXDataLayer.prototype.Init = function() {};

NYXDataLayer.prototype.GetResponses = function(id) {
  var responses = this.responses[id];
  this.responses[id] = null;
  if (responses) return responses;
  return new Array();
};

NYXDataLayer.prototype.Request = function(id, data) {

  var queue = false;
  var require = false;

  this.responses[id] = [];
  this.loadCount[id] = 0;

  queue = false;
  require = false;
  var request = new MessageTypes[id].Request(data);

  this.serverConnection.Request(id, request, queue, require);
  this.loadCount[id]++;
};

NYXDataLayer.prototype.onProblem = function(data) {
  this.communicationProblem = true;
  this.DispatchEvent(DataLayer.Events.Problem, {
    event: DataLayer.Events.Problem,
    data: data
  });
};

NYXDataLayer.prototype.onFailed = function(http_error_code, load_data_object) {
  console.log(
    'DataLayer OnFailed this.failCount = ' +
      this.failCount +
      ', http_error_code = ' +
      http_error_code +
      ', load_data_object = ' +
      load_data_object
  );
  if (this.failCount < 5) {
    setTimeout(
      this.serverConnection.Load.bind(this.serverConnection, load_data_object),
      400
    );
  } else {
    throw new Error('Failed to connect! TODO: Handle with dialogue?');
  }

  this.failCount++;
};

NYXDataLayer.prototype.handleResponse = function(response) {
  this.loadCount[response.id]--;
  this.failCount = 0;
  var responseItem;

  if (this.responses[response.id] == null) this.responses[response.id] = [];

  switch (response.request) {
    case 'GetBalance':
      responseItem = new ResponseItem('balance', response);
      this.responses[response.id].push(responseItem);
      break;

    case 'Login':
      responseItem = new ResponseItem('login', response);
      this.responses[response.id].push(responseItem);
      break;

    case 'GetGameConfig':
      responseItem = new ResponseItem('gameconfig', response);
      this.responses[response.id].push(responseItem);
      break;

    case 'GetGameResult':
      responseItem = new ResponseItem('getgameresult', response);
      this.responses[response.id].push(responseItem);
      break;

    case 'GetGames2':
      responseItem = new ResponseItem('getgames', response);
      this.responses[response.id].push(responseItem);
      break;

    case 'PayGame':
      responseItem = new ResponseItem('paygame', response);
      this.responses[response.id].push(responseItem);
      break;

    case 'GetWager':
      responseItem = new ResponseItem('wager', response);
      this.responses[response.id].push(responseItem);
      break;

    case 'Failed':
      responseItem = new ResponseItem('failed', response);
      this.responses[response.id].push(responseItem);
      break;

    default:
      responseItem = response;
      break;
  }

  if (this.loadCount[response.id] <= 0) {
    var currentEvent = response.id;
    this.DispatchEvent(currentEvent, {
      event: currentEvent,
      data: responseItem
    });
  }

  if (this.communicationProblem) {
    this.communicationProblem = false;
    this.DispatchEvent(DataLayer.Events.Ok, {
      event: DataLayer.Events.Ok,
      data: null
    });
  }
};

function Connection(data_layer) {
  this.dataLayer = data_layer;
  this.dataLayer.Init();

  this.dataLayer.AddEventListener(
    DataLayer.Events.Problem,
    this.onDataLayerNotifications,
    this
  );
  this.dataLayer.AddEventListener(
    DataLayer.Events.Ok,
    this.onDataLayerNotifications,
    this
  );
}

ClassUtil.CreateClass(Connection);
ClassUtil.CreateEventDispatcher(Connection);

Connection.prototype.Request = function(id, data) {
  this.dataLayer.AddEventListener(id, this.onDataLayerProcessed, this);
  this.dataLayer.Request(id, data);
};

Connection.prototype.GetResponses = function(id) {
  return this.dataLayer.GetResponses(id);
};

Connection.prototype.onDataLayerNotifications = function(data) {
  this.DispatchEvent(data.event, data.data);
};

Connection.prototype.onDataLayerProcessed = function(data) {
  this.dataLayer.RemoveEventListener(
    data.event,
    this.onDataLayerProcessed,
    this
  );
  this.DispatchEvent(data.event, data.data);
};

function CommunicationServices() {
  this.actionState = 0;
  this.actionString = '';
  this.proxyRequest = {};

  this.retriesCounter = 0;

  this.currentAction = '';
  this.callbackProcess = null;
  this.sendevt = null;
  this.flagNextWager = false;
  this.fail = false;
  this.instance = LotteryData.getInstance();

  var settings = this.instance.getSettings();
  this.isTestCase =
    settings.testCase == null || !settings.testCase ? false : true;

  this.serverConnection = new NYXServerConnection();
  this.dataLayer = new NYXDataLayer(this.serverConnection);
  this.connection = new Connection(this.dataLayer);

  this.connection.AddEventListener(
    DataLayer.Events.Problem,
    this.handleCommunicationProblem,
    this
  );
  this.connection.AddEventListener(
    DataLayer.Events.Ok,
    this.handleCommunicationOk,
    this
  );
}

ClassUtil.CreateClass(CommunicationServices, EventModel);
ClassUtil.CreateEventDispatcher(CommunicationServices);

CommunicationServices.Events.PlayerUpdated = 'playerUpdated';
CommunicationServices.Events.PlayerLoggedOut = 'playerLoggedOut';
CommunicationServices.Events.BalanceUpdated = 'balanceUpdated';
CommunicationServices.Events.Login = 'login';

CommunicationServices.prototype.Init = function(data_layer) {};

CommunicationServices.prototype.sendCommunicationServicesEvent = function(
  event,
  data
) {
  this.sendEvent(event, data);
};

CommunicationServices.prototype.handleMessage = function(
  title,
  message,
  request
) {
  var param = { title: title, message: message, request: request };
  this.sendCommunicationServicesEvent(EventModel.events._ev_message, param);
};

CommunicationServices.prototype.handleCommunicationProblem = function(data) {
  var param;
  if (!!data['httpRequest']) {
    param = {
      request: data.request.id,
      msg: data['httpRequest'].status + '-' + data.httprequest.statusText
    };
  } else {
    param = { request: data.request.id, msg: 'Communication problem.' };
  }
  this.sendCommunicationServicesEvent(
    EventModel.events._ev_communicationproblem,
    param
  );
};

CommunicationServices.prototype.handleCommunicationFailed = function(data) {
  var param;
  if (!!data['httpRequest']) {
    param = {
      request: data.id,
      msg: data['httpRequest'].status + '-' + data['httpRequest'].statusText
    };
  } else {
    param = { request: data.id, msg: data['msg'] };
  }
  if (!!data['rc']) {
    param['rc'] = data['rc'];
  }
  this.sendCommunicationServicesEvent(
    EventModel.events._ev_communicationfailed,
    param
  );
};

CommunicationServices.prototype.handleCommunicationOk = function(data) {
  this.sendCommunicationServicesEvent(EventModel.events._ev_communicationok);
};

CommunicationServices.prototype.onReceivedData = function(response) {
  console.log(
    'Received data ' +
      response.name +
      ' in action ' +
      this.currentAction +
      ', state ' +
      this.actionState +
      ' rc:' +
      response.data.rc +
      ' msg:' +
      response.data.msg
  );

  if (!!this.callbackProcess) {
    this.callbackProcess();
  }
};

CommunicationServices.prototype.handleProxyError = function(response) {
  this.actionState = 100; 
  var data = {
    request: response.data.request,
    rc: response.data.rc,
    msg: response.data.msg,
    action: response.data.action
  };
  var eventName = 'error';

  switch (response.data.request) {
    case 'PayGame':
      eventName = 'PayGameResponse';
      break;
    case 'GetBalance':
      eventName = 'GetBalanceResponse';
      break;
    default:
      break;
  }

  this.sendCommunicationServicesEvent(EventModel.events.proxyResponse, {
    id: eventName,
    data: data
  });
};

CommunicationServices.prototype.handleError = function(response) {
  this.actionState = 100; 
  var data = {
    request: response.data.request,
    rc: response.data.rc,
    msg: response.data.msg
  };
  this.sendCommunicationServicesEvent(EventModel.events._error, data);
};

CommunicationServices.prototype.handleNotLoggedIn = function(response) {
  this.actionState = 100; 
  var data = {
    request: response.data.request,
    rc: response.data.rc,
    msg: response.data.msg
  };

  this.DispatchEvent(
    CommunicationServices.Events.PlayerLoggedOut,
    response.data
  );
  this.sendCommunicationServicesEvent(EventModel.events._login, data);
};

CommunicationServices.prototype.handleNoMoney = function(response) {
  this.actionState = 100; 
  var data = {
    request: response.data.request,
    rc: response.data.rc,
    msg: response.data.msg
  };

  this.sendCommunicationServicesEvent(EventModel.events._ev_deposit, data);
};

CommunicationServices.prototype.onGetBalance = function(response) {
  this.connection.RemoveEventListener('GetBalance', this.onGetBalance, this);

  console.log('onGetBalance received!! - ' + response.name);

  if (response.name === 'failed') {
    this.handleCommunicationFailed(response.data);
  } else {
    if (this.proxyRequest[EventModel.events.getBalance]) {
      this.proxyRequest[EventModel.events.getBalance] = null;
      if (response.data.rc === 0) {
        this.sendCommunicationServicesEvent(EventModel.events.proxyResponse, {
          id: 'GetBalanceResponse',
          data: new IGetBalanceResponse(response.data)
        });
      } else {
        this.handleProxyError(response);
      }
    }
  }
};

CommunicationServices.prototype.onGameConfig = function(response) {
  this.connection.RemoveEventListener('GetGameConfig', this.onGameConfig, this);

  console.log('onGameConfig received!! - ' + response.name);

  switch (response.name) {
    case 'failed':
      this.handleCommunicationFailed(response.data);
      return;
      break;
    case 'gameconfig':
      if (response.data.rc === 0) {
        this.instance.setGameConfig(response.data.gameConfig);
        if (this.proxyRequest[EventModel.events.ticketGetGameConfig]) {
          this.proxyRequest[EventModel.events.ticketGetGameConfig] = null;
          var proxyData = {
            id: 'GetGameConfigResponse',
            data: {
              request: response.data.request,
              rc: response.data.rc,
              config: new IGameConfig(response.data.gameConfig)
            }
          };
          this.sendCommunicationServicesEvent(
            EventModel.events.proxyResponse,
            proxyData
          );
        }
      } else {
        console.log(
          'onGameConfig rc:' + response.data.rc + ' msg:' + response.data.msg
        );
        this.handleError(response);
      }
      break;
    default:
      console.log('onGameConfig - should not happen ' + response.name);
      break;
  }

  this.onReceivedData(response);
};

CommunicationServices.prototype.onGetWager = function(response) {
  this.connection.RemoveEventListener('GetWager', this.onGetWager, this);

  console.log('onGetWager received!! - ' + response.name);

  if (response.data.rc === 0) {
    this.instance.setGameConfig(response.data.gameConfig);
    this.instance.setFlag(LotteryData.Flag['next_ongoing'], true);
    this.instance.setNextWager(response.data.wager); 
  } else {
    if (!LotteryData.getInstance().getFlag(LotteryData.Flag['replay'])) {
      this.retriesCounter++;
      if (this.retriesCounter > 10) {
        this.retriesCounter = 0;
        this.handleError(response);
      } else {
        setTimeout(
          this.getWager.bind(
            this,
            this.instance.getSettings().gameid,
            this.instance.getSettings().wagerid
          ),
          200
        );
        return;
      }
    }
  }

  this.onReceivedData(response);
};

CommunicationServices.prototype.onPayGame = function(response) {
  this.connection.RemoveEventListener('PayGame', this.onPayGame, this);

  console.log('onPayGame received!! - rc:' + response.data.rc);

  if (response.name === 'paygame') {
    if (response.data.rc === 0) {
      if (this.proxyRequest[EventModel.events.ticketPayGame]) {
        this.proxyRequest[EventModel.events.ticketPayGame] = null;
        var proxyData = {
          id: 'PayGameResponse',
          data: new IPayGameResponse(response.data)
        };
        this.sendCommunicationServicesEvent(
          EventModel.events.proxyResponse,
          proxyData
        );
      }
    } else if (response.data.rc === 1000) {
      this.handleProxyError(response);
    } else if (response.data.rc === 1006) {
      this.handleProxyError(response);
    } else {
      this.instance.setFlag(LotteryData.Flag['payok'], false);
      this.handleProxyError(response);
    }
  } else {
    console.log('onPayGame - Handle FAILED');
  }
};

CommunicationServices.prototype.onGetGameResult = function(response) {
  this.connection.RemoveEventListener(
    'GetGameResult',
    this.onGetGameResult,
    this
  );

  console.log('onGetGameResult received!! - ' + response.name);

  if (response.name === 'getgameresult') {
    if (response.data.rc === 0) {
      this.instance.setWager(response.data.wager);
      this.instance.setBalance(response.data.balance);
      this.instance.setBonus(response.data.bonus);
      this.DispatchEvent(
        CommunicationServices.Events.BalanceUpdated,
        response.data
      );
      this.sendCommunicationServicesEvent(
        EventModel.events._ev_gameResult,
        response.data
      );
    } else {
      this.fail = true;
      this.handleCommunicationFailed(response.data);
    }
  } else {
    this.fail = true;
    this.handleCommunicationFailed(response.data);
  }
  this.onReceivedData(response);
};

CommunicationServices.prototype.onGetGames = function(response) {
  this.connection.RemoveEventListener('GetGames', this.onGetGames, this);

  console.log('onGetGames received!! - ' + response.name);

  if (response.name === 'getgames') {
    if (response.data.rc === 0) {
      if (this.proxyRequest[EventModel.events.ticketGetGames]) {
        this.proxyRequest[EventModel.events.ticketGetGames] = null;
        var proxyData = {
          id: 'GetGamesResult',
          data: {
            request: response.data.request,
            rc: response.data.rc,
            games: InterfaceUtil.getGameList(response.data.games)
          }
        };
        if (!!response.data.snapshootTime) {
          proxyData.data['time'] = response.data.snapshootTime.t;
        }
        if (!!response.data.lastWin) {
          proxyData.data['lastwin'] = InterfaceUtil.getLastWinList(
            response.data.lastWin.winData
          );
        }
        this.sendCommunicationServicesEvent(
          EventModel.events.proxyResponse,
          proxyData
        );
      }
    } else {
      this.fail = true;
      this.handleCommunicationFailed(response.data);
    }
  } else {
    this.fail = true;
    this.handleCommunicationFailed(response.data);
  }
};

CommunicationServices.prototype.onLogin = function(response) {
  this.connection.RemoveEventListener('Login', this.onLogin, this);
  if (response.data.rc === 0) {
    if (this.proxyRequest[EventModel.events.login]) {
      this.proxyRequest[EventModel.events.login] = null;
      var proxyData = { id: 'Login', data: new ILoginResponse(response.data) };
      this.sendCommunicationServicesEvent(
        EventModel.events.proxyResponse,
        proxyData
      );
    }
  } else {
    this.fail = true;
    this.handleCommunicationFailed(response.data);
  }
};

CommunicationServices.prototype.getBalance = function() {
  var settings = this.instance.getSettings();
  var requestData = {
    session: settings.session,
    operator: settings.operator,
    partner: settings.partner,
    language: settings.language,
    skin: settings.skin
  };

  this.connection.AddEventListener('GetBalance', this.onGetBalance, this);
  this.connection.Request('GetBalance', requestData);
};

CommunicationServices.prototype.getGameConfig = function() {
  var settings = this.instance.getSettings();

  var requestData = {
    gameId: settings.gameid,
    operator: settings.operator,
    partner: settings.partner,
    language: settings.language,
    skin: settings.skin
  };

  this.connection.AddEventListener('GetGameConfig', this.onGameConfig, this);
  this.connection.Request('GetGameConfig', requestData);
};

CommunicationServices.prototype.getWager = function(gameid, wagerid) {
  var settings = this.instance.getSettings();
  var requestData = {
    gameid: gameid,
    session: settings.session,
    operator: settings.operator,
    partner: settings.partner,
    language: settings.language,
    skin: settings.skin,
    roundid: 0,
    wagerid: wagerid
  };

  if (settings.ref !== 0) {
    requestData.ref = settings.ref;
    requestData.wagerid = 0;
  }

  this.connection.AddEventListener('GetWager', this.onGetWager, this);
  this.connection.Request('GetWager', requestData);
};

CommunicationServices.prototype.login = function() {
  var settings = this.instance.getSettings();

  var requestData = {
    operator: settings.operator,
    partner: settings.partner,
    language: settings.language,
    skin: settings.skin,
    universe: settings.universe,
    handle: settings.handle
  };

  this.connection.AddEventListener('Login', this.onLogin, this);
  this.connection.Request('Login', requestData);
};

CommunicationServices.prototype.payGame = function(data) {
  var settings = this.instance.getSettings();
  var gameid = data['gameid'];
  var ba = data['price'];
  var currency = data['currency'];

  var skinid = 0;
  if (!!data['skinid']) {
    if (isNaN(data['skinid'])) {
      skinid = 0;
    } else {
      skinid = parseInt(data['skinid'], 10);
    }
  }

  var requestData = {
    gameid: gameid,
    session: settings.session,
    operator: settings.operator,
    partner: settings.partner,
    language: settings.language,
    skin: settings.skin,
    p1: 'ba=' + ba + ';TBA=;TBC=' + currency + ';bc=' + currency,
    wagerid: 0
  };

  if (data['voucherid']) {
    requestData.voucherid = data['voucherid'];
  }

  if (skinid > 1) {
    requestData.skinid = skinid;
  }

  console.log('Send pay request, running:' + this.running);
  this.connection.AddEventListener('PayGame', this.onPayGame, this);
  this.connection.Request('PayGame', requestData);
};

CommunicationServices.prototype.getGameResult = function() {
  var settings = this.instance.getSettings();
  var gameConfig = this.instance.getGameConfig();
  var gameid = gameConfig.gameId;
  var ba = gameConfig.ticketPrice;
  var currency = gameConfig.currency;
  var wager = this.instance.getWager();
  var wagerid = wager.id;

  var requestData = {
    gameid: gameid,
    session: settings.session,
    operator: settings.operator,
    partner: settings.partner,
    language: settings.language,
    skin: settings.skin,
    wagerid: wagerid,
    p1: 'ba=' + ba + ';bc=' + currency + ';betid=1;step=1;cmd=CHECKWIN'
  };

  this.connection.AddEventListener('GetGameResult', this.onGetGameResult, this);
  this.connection.Request('GetGameResult', requestData);
};

CommunicationServices.prototype.getGames = function(data) {
  var settings = this.instance.getSettings();

  var requestData = {
    operator: settings.operator,
    partner: settings.partner,
    language: settings.language,
    skin: settings.skin,
    subsystem: 'lottery',
    channel: 'internet'
  };

  if (!!data['subsystem']) {
    requestData.subsystem = data['subsystem'];
  }

  this.connection.AddEventListener('GetGames2', this.onGetGames, this);
  this.connection.Request('GetGames2', requestData);
};

CommunicationServices.prototype.progressStart = function() {
  if (this.fail) {
    this.actionState = 100; 
  }
};

CommunicationServices.prototype.progressEnd = function() {
  this.fail = false;
  this.running = false;
  this.flagNextWager = false;
  this.actionState = 0;
};

CommunicationServices.prototype.checkProgress = function() {
  var settings = this.instance.getSettings();
  this.progressStart();

  if (this.actionState === 1) {
    var session = settings.session;
    if (!!session) {
      this.actionState = 2;
    } else {
      this.sendCommunicationServicesEvent(EventModel.events._login);
      this.actionState = 100; 
    }
  }

  if (this.actionState === 2) {
    this.actionState = 3;

    this.getGameResult();
    return;
  }

  if (this.actionState === 3) {
    this.actionState = 4;

    var wager = this.instance.getWager();

    this.instance.setFlag(LotteryData.Flag['result'], true);
    if (wager.bets[0].status === 'WON') {
      this.instance.setFlag(LotteryData.Flag['won'], true);
    } else {
      this.instance.setFlag(LotteryData.Flag['won'], false);
    }

    this.sendCommunicationServicesEvent(EventModel.events._ev_ticketresult);
    this.actionState = 100; 
  }

  this.progressEnd();

};

CommunicationServices.prototype.checkStart = function() {
  this.callbackProcess = this.checkProgress;
  this.actionState = 1;
  this.checkProgress();
};

CommunicationServices.prototype.checkIfWagerProgress = function() {
  var settings = this.instance.getSettings();
  this.progressStart();

  if (this.actionState === 1) {
    this.actionState = 2;
    var session = settings.session;

    if (session === '') {
      this.actionState = 4; 
    }
  }

  if (this.actionState === 2) {
    this.actionState = 3;

    this.getWager(this.instance.getSettings().gameid, 0);
    return;
  }

  if (this.actionState === 3) {
    this.actionState = 4;
    var flagNextOngoing = this.instance.getFlag(
      LotteryData.Flag['next_ongoing']
    );

    if (flagNextOngoing) {
      this.instance.setFlag(LotteryData.Flag['next_ongoing'], true);
      this.sendCommunicationServicesEvent(this.sendevt);
      this.actionState = 100; 
    }
  }

  if (this.actionState === 4) {
    this.actionState = 5;

    this.sendCommunicationServicesEvent(this.sendevt);
    this.actionState = 100; 
  }

  this.progressEnd();
};

CommunicationServices.prototype.checkIfWagerStart = function(data) {
  console.log('checkIfWagerStart evt:' + data.evt);
  this.callbackProcess = this.checkIfWagerProgress;
  this.sendevt = data.evt;
  this.flagNextWager = true;

  this.instance.setFlag(LotteryData.Flag['next_ongoing'], false);
  this.instance.setFlag(LotteryData.Flag['next_free'], false);
  this.instance.setFlag(LotteryData.Flag['result'], false);
  this.instance.setNextWager(new Wager()); 

  this.actionState = 1;
  this.checkIfWagerProgress();
};

CommunicationServices.prototype.initProgress = function() {
  this.progressStart();

  var settings = this.instance.getSettings();

  if (this.actionState === 1) {
    this.actionState = 2;
    var session = settings.session;

    if (session === '') {
      this.actionState = 4; 
    }
  }

  if (this.actionState === 2) {
    this.actionState = 3;

    this.getWager(settings.gameid, 0);
    return;
  }

  if (this.actionState === 3) {
    this.actionState = 4;
    var flagNextOngoing = this.instance.getFlag(
      LotteryData.Flag['next_ongoing']
    );

    if (flagNextOngoing) {
      this.sendCommunicationServicesEvent(EventModel.events._ev_initialized);
      this.actionState = 100; 
    }
  }

  if (this.actionState === 4) {
    this.actionState = 5;

    this.getGameConfig();
    return;
  }

  if (this.actionState === 5) {
    this.actionState = 6;

    this.sendCommunicationServicesEvent(EventModel.events._ev_initialized);
    this.actionState = 100; 
  }

  this.progressEnd();
};

CommunicationServices.prototype.initStart = function() {
  this.callbackProcess = this.initProgress;
  this.flagNextWager = false;

  this.instance.setFlag(LotteryData.Flag['next_ongoing'], false);
  this.instance.setFlag(LotteryData.Flag['ongoing'], false);
  this.instance.setFlag(LotteryData.Flag['free'], false);
  this.instance.setFlag(LotteryData.Flag['result'], false);

  this.actionState = 1;
  this.initProgress();
};

CommunicationServices.prototype.replayProgress = function() {
  this.progressStart();

  if (this.actionState === 1) {
    this.actionState = 2;

    this.getWager(
      this.instance.getSettings().gameid,
      this.instance.getSettings().wagerid
    );
    return;
  }

  var fail = false;

  if (this.actionState === 2) {
    this.actionState = 3;
    var flagNextOngoing = this.instance.getFlag(
      LotteryData.Flag['next_ongoing']
    );

    if (flagNextOngoing) {
      this.instance.setNextWagerToCurrent();

      var wager = this.instance.getWager();

      this.instance.setFlag(LotteryData.Flag['result'], true);
      if (wager.bets[0].status === 'WON') {
        this.instance.setFlag(LotteryData.Flag['won'], true);
      } else {
        this.instance.setFlag(LotteryData.Flag['won'], false);
      }

    } else {
      fail = true;
      this.handleMessage(
        this.instance.getText('textDialogRcMessageTitle'),
        this.instance.getText('textDialogRcNoWagerMessage'),
        'GetWager'
      );
    }
    this.actionState = 100; 
  }

  this.progressEnd();

  if (fail) {
    this.instance.setFlag(LotteryData.Flag['replay'], false);
    this.sendCommunicationServicesEvent(EventModel.events._do_init);
  } else {
    this.sendCommunicationServicesEvent(EventModel.events._do_checkifwager, {
      evt: EventModel.events._ev_replay
    });
  }
};

CommunicationServices.prototype.ticketLoadProgress = function() {
  var settings = this.instance.getSettings();
  this.progressStart();

  if (this.actionState === 1) {
    this.actionState = 2;

    this.getWager(settings.gameid, settings.wagerid);
    return;
  }

  if (this.actionState === 2) {
    this.actionState = 3;

    var flagNextOngoing = this.instance.getFlag(
      LotteryData.Flag['next_ongoing']
    );

    if (flagNextOngoing) {

      this.sendCommunicationServicesEvent(
        EventModel.events._do_loadgameassets,
        { evt: EventModel.events.ticketSetup }
      );
    } else {
      this.actionState = 100; 
      this.handleMessage(
        this.instance.getText('textDialogRcMessageTitle'),
        this.instance.getText('textDialogRcNoWagerMessage'),
        'GetWager'
      );
    }
    return;
  }

  var fail = false;

  if (this.actionState === 3) {
    this.actionState = 4;
    var flagNextOngoing = this.instance.getFlag(
      LotteryData.Flag['next_ongoing']
    );

    if (flagNextOngoing) {
      this.instance.setNextWagerToCurrent(); 

      var wager = this.instance.getWager();

      if (wager.bets[0].status === 'WON' || wager.bets[0].status === 'LOST') {
        this.instance.setFlag(LotteryData.Flag['result'], true);
        if (wager.bets[0].status === 'WON') {
          this.instance.setFlag(LotteryData.Flag['won'], true);
        } else {
          this.instance.setFlag(LotteryData.Flag['won'], false);
        }

        this.sendCommunicationServicesEvent(EventModel.events._ev_replay);
      } else {
        this.sendCommunicationServicesEvent(
          EventModel.events._ev_ticketreadytoplay
        );
        this.sendCommunicationServicesEvent(EventModel.events._play);
      }
    } else {
      fail = true;
      this.handleMessage(
        this.instance.getText('textDialogRcMessageTitle'),
        this.instance.getText('textDialogRcNoWagerMessage'),
        'GetWager'
      );
    }
    this.actionState = 100; 
  }

  this.progressEnd();
};

CommunicationServices.prototype.ticketLoadStart = function(data) {
  this.callbackProcess = this.ticketLoadProgress;

  this.instance.setFlag(LotteryData.Flag['result'], false);

  this.actionState = 1;
  this.ticketLoadProgress();
};

CommunicationServices.prototype.replayStart = function(data) {
  this.callbackProcess = this.replayProgress;

  this.instance.setFlag(LotteryData.Flag['replay'], true);
  this.instance.setFlag(LotteryData.Flag['ongoing'], false);
  this.instance.setFlag(LotteryData.Flag['free'], false);
  this.instance.setFlag(LotteryData.Flag['result'], false);

  this.actionState = 1;
  this.replayProgress();
};

CommunicationServices.prototype.ticketSetupProgress = function() {
  this.progressStart();

  if (this.actionState === 1) {
    this.actionState = 2;

    this.getGameConfig();
    return;
  }

  if (this.actionState === 2) {
    this.actionState = 3;


    if (this.actionString !== EventModel.events.ticketPayGame) {
      this.sendCommunicationServicesEvent(
        EventModel.events._do_loadgameassets,
        { evt: EventModel.events.ticketSetup }
      );
      return;
    }
  }

  if (this.actionState === 3) {
    this.actionState = 4;

    if (this.actionString === EventModel.events.ticketLoadDemo) {
      this.sendCommunicationServicesEvent(
        EventModel.events.do_playdemo,
        this.ticketSetupData
      );
    }
  }

  this.progressEnd();
};

CommunicationServices.prototype.ticketSetupStart = function(data, string) {
  this.callbackProcess = this.ticketSetupProgress;

  this.actionState = 1;
  this.actionString = string;
  this.ticketSetupData = data;

  if (this.actionString === EventModel.events.ticketLoadDemo) {
    if (!!data['skinid']) {
      this.instance.setDynamicValue('skinid', data['skinid']);
    }
  }
  this.ticketSetupProgress();
};
CommunicationServices.prototype.onEvent = function(eventName, data) {
  console.log(
    'CommunicationServices onEvent ' + eventName + ' running:' + this.running
  );

  switch (eventName) {
    case EventModel.events._loadedresources:
      if (!!this.callbackProcess) {
        this.callbackProcess();
      }
      break;

    case EventModel.events._loadedresourcesfailed:
      if (!!this.callbackProcess) {
        this.actionState = 100; 
        this.callbackProcess();
      }
      break;

    case EventModel.events.ticketGetGameConfig:
      this.proxyRequest[EventModel.events.ticketGetGameConfig] = true;
      this.getGameConfig();
      break;

    case EventModel.events.login:
      this.proxyRequest[EventModel.events.login] = true;
      this.login();
      break;

    case EventModel.events.getBalance:
      this.proxyRequest[EventModel.events.getBalance] = true;
      this.getBalance();
      break;

    case EventModel.events.ticketGetGames:
      this.proxyRequest[EventModel.events.ticketGetGames] = true;
      this.getGames(data);
      break;

    case EventModel.events.ticketPayGame:
      this.proxyRequest[EventModel.events.ticketPayGame] = true;
      this.payGame(data);
      break;

    default:
      break;
  }
  if (this.running) {
    return false;
  }
  this.running = true;
  this.currentAction = eventName;
  this.retriesCounter = 0;

  switch (eventName) {
    case EventModel.events._do_init:
      this.initStart();
      break;

    case EventModel.events.do_check:
      var flagDemo = this.instance.getFlag(LotteryData.Flag['demo']);
      if (flagDemo) {
        this.running = false;
        return;
      }
      this.checkStart();
      break;

    case EventModel.events._do_replay:
      this.replayStart(data);
      break;

    case EventModel.events.ticketSetup:
      this.ticketSetupStart(data, eventName);
      break;

    case EventModel.events.ticketLoadDemo:
      this.ticketSetupStart(data, eventName);
      break;

    case EventModel.events.ticketLoad:
      this.ticketLoadStart(data);
      break;

    case EventModel.events._do_checkifwager:
      this.checkIfWagerStart(data);
      break;

    default:
      this.running = false;
      this.currentAction = '';
      break;
  }
};


function Device(correctObject) {
  if (correctObject != ___correctObject___) {
    throw new Error('Device() tried to instantiate Singleton');
  }
  this.textureScale = 1.0;

  this.orientation = Device.Orientation.Unknown;
  this.size = this.GetViewportSize();
  this.browserType = Device.BrowserTypes.Unknown;
  this.deviceType = Device.Types.Unknown;
  this.urlParameters = {};
}
ClassUtil.CreateClass(Device);
ClassUtil.CreateEventDispatcher(Device);

Device.Events.Resize = 'Resize';
Device.Events.OrientationChange = 'OrientationChange';

Device.Types = {
  Unknown: 0,
  Android: 1,
  iPad: 2,
  iPhone: 3,
  Mac: 4,
  Windows: 5,
  Linux: 6
};

Device.BrowserTypes = {
  Unknown: 0,
  AndroidNative: 1,
  Chrome: 2,
  Safari: 3
};

Device.Orientation = {
  Unknown: -1,
  Portrait: 0,
  Landscape: 1
};

Device.prototype.Init = function() {
  this.size = this.GetViewportSize();

  this.orientation = this.IsPortrait(this.size)
    ? Device.Orientation.Portrait
    : Device.Orientation.Landscape;

  this.CheckDeviceType();
  this.CheckBrowserType();

};


Device.prototype.GetDeviceTypeFromUserAgentString = function() {
  if (navigator.userAgent.match(/android/i) !== null)
    return Device.Types.Android;
  else if (navigator.userAgent.match(/ipad/i) !== null)
    return Device.Types.iPad;
  else if (navigator.userAgent.match(/iphone/i) !== null)
    return Device.Types.iPhone;
  else if (navigator.userAgent.indexOf('Mac OS X') !== -1)
    return Device.Types.Mac;
  else {
    return Device.Types.Unknown;
  }
}
Device.prototype.CheckDeviceType = function() {
  if(navigator.userAgentData) {
    switch (navigator.userAgentData.platform)
    {
      case 'Android':
        this.deviceType = Device.Types.Android;
        break;
      case 'macOS':
        this.deviceType = Device.Types.Mac;
        break;
      case 'Windows':
        this.deviceType = Device.Types.Windows;
        break;
      case 'Linux':
        this.deviceType = Device.Types.Linux;
        break;
      default:
        this.deviceType = this.GetDeviceTypeFromUserAgentString();
        break;
    }
  } else {
    this.deviceType = this.GetDeviceTypeFromUserAgentString();
  }
};



Device.prototype.CheckBrowserType = function() {
  var nua = navigator.userAgent;
  if (
    nua.indexOf('Mozilla/5.0') > -1 &&
    nua.indexOf('Android ') > -1 &&
    nua.indexOf('AppleWebKit') > -1 &&
    !(nua.indexOf('Chrome') > -1)
  ) {
    this.browserType = Device.BrowserTypes.AndroidNative;
  }
  else if (nua.match(/chrome/i) !== null) {
    this.browserType = Device.BrowserTypes.Chrome;
  }
  else
    this.browserType = Device.BrowserTypes.Safari;
};

Device.prototype.OnResize = function(event) {
  this.size = this.GetViewportSize();
  this.DispatchEvent(Device.Events.Resize);

  if (
    this.deviceType != Device.Types.Android &&
    this.deviceType != Device.Types.iPhone &&
    this.deviceType != Device.Types.iPad
  ) {
    var newOrientation = this.IsPortrait(this.size)
      ? Device.Orientation.Portrait
      : Device.Orientation.Landscape;
    if (newOrientation != this.orientation) {
      this.orientation = newOrientation;
      this.DispatchEvent(Device.Events.OrientationChange);
    }
  }
};

Device.prototype.OnOrientationChange = function(event) {
  this.size = this.GetViewportSize();
  this.orientation = this.IsPortrait(this.size)
    ? Device.Orientation.Portrait
    : Device.Orientation.Landscape;
  this.DispatchEvent(Device.Events.OrientationChange);
};

Device.prototype.OnOrientationChangeAndroid = function(event) {
  if (this.deviceType == Device.Types.Android) {
    setTimeout(Device.prototype.OnOrientationChange.bind(this), 500);
    return;
  }
};

Device.prototype.GetViewportSize = function() {
  var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    x = w.innerWidth || e.clientWidth || g.clientWidth,
    y = w.innerHeight || e.clientHeight || g.clientHeight;

  this.textureScale = x / 2048;

  if (this.textureScale >= 0.75) {
    this.textureScale = 1.0;
  } else {
    this.textureScale = 0.5;
  }

  this.textureScale = 1.0; 

  return { width: x, height: y };
};

Device.prototype.IsPortrait = function(size) {
  return size.width < size.height;
};

Device.RequestAnimationFrame = function(callback_function) {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (function() {
      return (
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function(callback, element) {
          window.setTimeout(callback, 1000 / 60);
        }
      );
    })();
  }
  window.requestAnimationFrame(callback_function);
};

Device.CreateHTTPRequest = function() {
  var XMLHttpFactories = [
    function() {
      return new XMLHttpRequest();
    },
    function() {
      return new ActiveXObject('Msxml2.XMLHTTP');
    },
    function() {
      return new ActiveXObject('Msxml3.XMLHTTP');
    },
    function() {
      return new ActiveXObject('Microsoft.XMLHTTP');
    }
  ];

  var httpRequest = false;
  for (var i = 0; i < XMLHttpFactories.length; i++) {
    try {
      httpRequest = XMLHttpFactories[i]();
    } catch (e) {
      continue;
    }
    break;
  }
  return httpRequest;
};

var ___correctObject___ = '___Device.___correctObject___blabla';
var ___instance___ = null;
Device.getInstance = function() {
  if (___instance___ == null) {
    ___instance___ = new Device(___correctObject___);
  }
  return ___instance___;
};


function LoaderController() {
  this.config = {};
  this.config.applicationURL = 'nyxconf/application.json';

  this.loader = new PIXI.loaders.Loader();
  this.loader.pre(function(resource, next) {
    if (resource.url.indexOf('?') === -1) {
      resource.url += PIXI.loaders.Loader.optNoCacheParam;
    }
    next();
  });

  this.loaderDialog = null;
  this.dataInstance = LotteryData.getInstance();
  this.size = this.dataInstance.getTicketSize();

  this.layer = null;
  this.assetsVer = '';

  this.imagesToLoad = null;
  this.imagesToLoadGlobal = null;
}
ClassUtil.CreateClass(LoaderController, EventModel);

LoaderController.prototype.startLoaderDialog = function() {
  this.layer = SceneGraph.GetLayer(SceneGraph.Layers.Overlay);

  this.loaderDialog = new LoaderDialog();
  this.layer.addChild(this.loaderDialog);
  this.loaderDialog.position.x = 0.5 * this.size.width;
  this.loaderDialog.position.y = 0.5 * this.size.height;
};

LoaderController.prototype.startLoading = function() {
  var data = {
    id: 'Svs nyx client',
    operator: 'SVSD',
    partner: 'SVSD',
    skinname: 'default',
    channel: 'channel',
    universe: 'default',
    language: 'sv',
    nyxroot: '',
    assetsrootpath: 'assets/'
  };

  console.log('LoaderController - START LOADER');
  if (!!this.config['loader_image']) {
    this.loader.add(
      'loaderimage',
      this.config['loader_image'],
      { crossOrigin: true },
      function(res) {
        console.log('loaderimage loaded');
        PIXI.utils.TextureCache['loaderimage'] = res.texture;

        try {

          data['nyxroot'] = svs.core.jupiter.url() + '/proxy/';
          this.setSettings(data);
        } catch (e) {
          this.loader.add(
            'settings',
            this.config.applicationURL,
            {
              crossOrigin: true,
              loadType: 'json'
            },
            this.onSettingsLoaded.bind(this)
          );
          this.loader.load();
        }
      }.bind(this)
    );

    this.loader.load();
  } else {
    try {

      data['nyxroot'] = svs.core.jupiter.url() + '/proxy/';
      this.setSettings(data);
    } catch (e) {
      this.loader.add(
        'settings',
        this.config.applicationURL,
        {
          crossOrigin: true,
          loadType: 'json'
        },
        this.onSettingsLoaded.bind(this)
      );

      this.loader.load();
    }
  }



};

LoaderController.prototype.setSettings = function(res) {
  console.log('setSettings');
  this.settings = new Settings();

  for (var key in res) {
    this.settings[key] = res[key];
  }
  this.settings.mergeStartupSettings(this.config);
  LotteryData.getInstance().setSettings(this.settings);

  this.sendEvent(EventModel.events._loadedsettings);
};

LoaderController.prototype.onSettingsLoaded = function(res, next) {
  console.log('onSettingsLoaded');
  var settingsObj = res.data;
  this.settings = new Settings();
  this.settings.parseObject(settingsObj);
  this.settings.mergeStartupSettings(this.config);
  LotteryData.getInstance().setSettings(this.settings);

  this.sendEvent(EventModel.events._loadedsettings);
};

LoaderController.prototype.loadAssetsVersion = function() {
  this.assetsVer = '';
  var loadIcon = this.dataInstance.getDynamicValue('icon');

  if (!!this.loader['resources']['assets_ver']) {
    delete this.loader['resources']['assets_ver'];
  }

  this.loader.add(
    'assets_ver',
    this.settings.assetsRootPath +
      this.settings.language +
      '/' +
      loadIcon +
      '/assets_ver.json?t=' +
      Date.now(),
    {
      crossOrigin: true,
      loadType: 'json'
    },
    function(res) {
      if (!!res.error) {
        PIXI.loaders.Loader.optNoCacheParam = '';
        this.loadGame();
        return;
      }

      var assetsVerData = res.data;

      if (!!assetsVerData['assets_ver']) {
        this.assetsVer = '?v=' + assetsVerData['assets_ver'];
      }

      PIXI.loaders.Loader.optNoCacheParam = this.assetsVer;
      this.loadGame();
    }.bind(this)
  );

  this.loader.load();
};

LoaderController.prototype.loadGame = function() {
  var flagLoadGlobalSuccess = false;
  var flagLoadLayoutSuccess = false;
  var flagLoadGameSuccess = false;

  var flagLoadSuccess = true;

  var handleLoadedConfiguration = function(res) {
    var test = res;
    var i = 0;
    var key;

    var images = {};

    if (!!this.imagesToLoadGlobal) {
      if (this.imagesToLoadGlobal.constructor === Array) {
        for (i = 0; i < this.imagesToLoadGlobal.length; ++i) {
          images[this.imagesToLoadGlobal[i]['id']] = this.imagesToLoadGlobal[i];
        }
      } else {
        for (key in this.imagesToLoadGlobal) {
          images[key] = this.imagesToLoadGlobal[key];
        }
      }
    }

    if (!!this.imagesToLoad) {
      if (this.imagesToLoad.constructor === Array) {
        for (i = 0; i < this.imagesToLoad.length; ++i) {
          images[this.imagesToLoad[i]['id']] = this.imagesToLoad[i];
        }
      } else {
        for (key in this.imagesToLoad) {
          images[key] = this.imagesToLoad[key];
        }
      }
    }

    this.imagesLoadCount = 0;
    for (key in images) {
      this.loader.add(
        key,
        this.settings.assetsRootPath +
          this.settings.language +
          '/' +
          loadIcon +
          '/' +
          images[key]['file'] +
          this.assetsVer,
        {
          crossOrigin: true
        },
        function(id, res) {
          if (!!res.error) {
            handleLoadError({
              rc: 604,
              error: { message: 'Failed to load resource ' + res['url'] }
            });
            return;
          }

          PIXI.utils.TextureCache[id] = res.texture;
          this.imagesLoadCount--;
          if (flagLoadSuccess && this.imagesLoadCount === 0) {
            flagLoadGameSuccess = true;
            loaded();
          }
        }.bind(this, key)
      );
      this.imagesLoadCount++;
    }

    this.loader.load();
  }.bind(this);

  var handleLoadError = function(res) {
    var msgUrl = '';
    if (!!res.url) {
      msgUrl = ', url:' + res.url;
    }

    var rc = 620;
    if (!!res.rc) {
      rc = res.rc;
    }

    this.dataInstance.setDynamicValue('loadicon', '');

    var data = {
      request: 'internal',
      rc: rc,
      msg: res.error['message'] + msgUrl
    };

    if (flagLoadSuccess) {
      flagLoadSuccess = false;
      data['msg'] = 'Failed to load' + msgUrl;
    }

    this.sendEvent(EventModel.events._fatalerror, data);
  }.bind(this);

  var loaded = function() {
    if (flagLoadGlobalSuccess && flagLoadLayoutSuccess && flagLoadGameSuccess) {
      this.dataInstance.initDataDefinition(); 
      this.sendEvent(EventModel.events._loadedresources);
    }
  }.bind(this);

  var iconString = this.dataInstance.getDynamicValue('icon');
  var icon = iconString;
  var position = iconString.indexOf('.');

  if (position !== -1) {
    icon = iconString.substr(0, position);
  }


  var skinid = 0;
  if (!!this.dataInstance.next_wager) {
    skinid = this.dataInstance.parseNextWagerSkin(this.dataInstance.next_wager);
  } else {
    skinid = this.dataInstance.getDynamicValue('skinid');
  }
  var loadIcon = this.dataInstance.getDynamicValue('loadicon');
  var loadSkinId = this.dataInstance.getDynamicValue('loadskinid');
  var flagLoadSkinOnly = false;

  if (!!loadIcon) {
    if (loadIcon === icon) {
      if (!!loadSkinId) {
        if (
          (loadSkinId === skinid && skinid > 1) ||
          (loadSkinId === 'default' && skinid < 2)
        ) {
          this.sendEvent(EventModel.events._loadedresources);
          return;
        } else {
          flagLoadSkinOnly = true; 
        }
      }
    }
  }
  this.loader.reset();

  loadIcon = icon;
  if (!!skinid && skinid > 1) {
    loadSkinId = skinid;
  } else {
    loadSkinId = 'default';
  }

  this.dataInstance.setDynamicValue('loadicon', loadIcon);
  this.dataInstance.setDynamicValue('loadskinid', loadSkinId);

  this.loader.add(
    'globals',
    this.settings.assetsRootPath + this.settings.language + '/globals.json',
    {
      crossOrigin: true,
      loadType: 'json'
    },
    function(res) {
      if (!!res.error) {
        handleLoadError(res);
        return;
      }
      var globalSettingsObj = res.data;
      this.dataInstance.defaultDefinition.set('globals', res.data);

      if (!!globalSettingsObj['images']) {
        this.imagesToLoadGlobal = globalSettingsObj['images']; 
      }

      flagLoadGlobalSuccess = true;
      loaded();
    }.bind(this)
  );

  this.loader.add(
    'layout',
    this.settings.assetsRootPath +
      this.settings.language +
      '/' +
      loadIcon +
      '/layout.json?t=' +
      Date.now(),
    {
      crossOrigin: true,
      loadType: 'json'
    },
    function(res) {
      if (!!res.error) {
        handleLoadError(res);
        return;
      }

      console.log('layout loaded');

      var data = res.data;
      if (typeof res.data === 'string') {
        data = JSON.parse(res.data);
      }

      var model = LotteryData.getInstance().getGameConfig().model;
      var gameLayoutObj = data['layout'];
      if (model === gameLayoutObj['model']) {
        LotteryData.getInstance().setLayout(gameLayoutObj);
        this.dataInstance.defaultDefinition.set('layout', res.data['layout']);
        flagLoadLayoutSuccess = true;
        loaded();
      } else {
        handleLoadError({
          rc: 621,
          error: {
            message:
              'Mismatch in models, got ' +
              gameLayoutObj['model'] +
              '. Expected:' +
              model
          }
        });
      }
    }.bind(this)
  );

  this.loader.add(
    'game',
    this.settings.assetsRootPath +
      this.settings.language +
      '/' +
      loadIcon +
      '/game.json?t=' +
      Date.now(),
    {
      crossOrigin: true,
      loadType: 'json'
    },
    function(res) {
      if (!!res.error) {
        handleLoadError(res);
        return;
      }

      var data = res.data;
      if (typeof res.data === 'string') {
        data = JSON.parse(res.data);
      }

      var gameSettingsObj = data['game'];
      this.dataInstance.defaultDefinition.set('game', res.data['game']);

      if (!!gameSettingsObj['images']) {
        var images = gameSettingsObj['images'];

        if (!!gameSettingsObj['skinimages']) {
          if (flagLoadSkinOnly) {
            images = gameSettingsObj['skinimages'][loadSkinId];
          } else {
            var skinImages = gameSettingsObj['skinimages'][loadSkinId];
            if (skinImages.constructor === Array) {
              console.warn('Using old format for defining skin images!');
              images = images.concat(gameSettingsObj['skinimages'][loadSkinId]);
            } else {
              for (var key in skinImages) {
                images[key] = skinImages[key]; 
              }
            }
          }
        }

        if (!images) {
          handleLoadError({
            rc: 605,
            error: { message: 'Missing resources for skinid  ' + loadSkinId }
          });
          return;
        }

        this.imagesToLoad = images;
      } else {
        flagLoadGameSuccess = true;
        loaded();
      }
    }.bind(this)
  );

  this.loader.load(handleLoadedConfiguration);
};

LoaderController.prototype.OnGameResourcesLoaded = function() {
  console.log('OnGameResourcesLoaded');


  this.sendEvent(EventModel.events._loadedresources);
};

LoaderController.prototype.onEvent = function(eventName, data) {
  switch (eventName) {
    case EventModel.events._do_load: 
      this.startLoading();
      break;
    case EventModel.events._do_hide_loader:
      console.log('LoaderController - STOP LOADER');
      if (!!this.loaderDialog) {
        this.loaderDialog.hide(true);
        this.loaderDialog.onHidden();
      }
      break;

    case EventModel.events._do_loadgameassets:
      this.loadAssetsVersion();
      break;

    default:
      break;
  }
};

function IBalance(balance) {
  this['currency'] = balance.currency;
  this['amount'] = balance.amount;
  this['winnings'] = balance.winnings;
  this['mileage'] = balance.mileage;
}
ClassUtil.CreateClass(IBalance);

function IBet(bet) {
  this['id'] = bet.id;
  this['created'] = bet.created;
  this['step'] = bet.step;
  this['gameId'] = bet.gameId;
  this['roundId'] = bet.roundId;
  this['ba'] = bet.ba;
  this['bc'] = bet.bc;
  this['wa'] = bet.wa;
  this['wc'] = bet.wc;
  this['ns'] = bet.ns;
  this['cmds'] = bet.cmds;
  this['status'] = bet.status;
  this['payId'] = bet.payId;
  this['data'] = bet.data;

  var data_dict = (function(d) {
    var dict = {};
    for (var i = 0; i < d.length; i++) {
      var x = d[i].match(/(.+)=(.*)/);
      dict[x[1]] = x[2];
    }
    return dict;
  })(bet.data.split(';'));

  this['wagerId'] = data_dict['Wager_id'];
}
ClassUtil.CreateClass(IBet);

function IBonus(bonus) {
  this['currency'] = bonus.currency;
  this['amount'] = bonus.amount;
}
ClassUtil.CreateClass(IBonus);

function ICredit(credit) {
  this['currency'] = credit.currency;
  this['amount'] = credit.amount;
}
ClassUtil.CreateClass(ICredit);

function IGameConfig(gameconfig) {
  this['gameid'] = gameconfig.gameId;
  this['ticketPrice'] = gameconfig.ticketPrice;
  this['currency'] = gameconfig.currency;

  this['icon'] = gameconfig.icon;

  this['name'] = gameconfig.name;
  this['namet'] = gameconfig.namet;

  this['model'] = gameconfig.model;

  this['multiplicators'] = gameconfig.multiplicators;
  this['multNames'] = gameconfig.multNames;

  this['noOfPrizes1'] = gameconfig.noOfPrizes1;
  this['noOfTickets'] = gameconfig.noOfTickets;

  this['prizeplan'] = gameconfig.prizeplan;
  this['prizeplanInfo'] = gameconfig.prizeplanInfo;
  this['prizes'] = gameconfig.prizes;

  this['xIcons'] = gameconfig.xIcons;
  this['xOnSyms'] = gameconfig.xOnSyms;

  this['xPrizes'] = gameconfig.xPrizes;

  this['_winnings'] = gameconfig._winnings;
  this['_totalNumberOfPrizes'] = gameconfig._totalNumberOfPrizes;
  this['_totalSumOfPrizes'] = gameconfig._totalSumOfPrizes;
  this['_totalWinnings'] = gameconfig._totalWinnings;
}
ClassUtil.CreateClass(IGameConfig);

function IUser(user) {
  this['accountType'] = user.accountType;
  this['city'] = user.city;
  this['country'] = user.country;
  this['currency'] = user.currency;
  this['email'] = user.email;
  this['firstName'] = user.firstName;
  this['hasProfile'] = user.hasProfile;
  this['lastName'] = user.lastName;
  this['latestChange'] = user.latestChange;
  this['nickname'] = user.nickname;
  this['session'] = user.session;
  this['userid'] = user.userId;
  this['username'] = user.username;

  this['careof'] = user.careof;
  this['phone'] = user.phone;
  this['street'] = user.street;
  this['zip'] = user.zip;

  this['balance'] = new IBalance(user.balance);
  this['bonus'] = new IBonus(user.bonus);
  this['credit'] = new ICredit(user.credit);
}
ClassUtil.CreateClass(IUser);

function IWager(wager) {
  this['id'] = wager.id;
  this['userid'] = wager.userid;
  this['betted'] = wager.betted;
  this['won'] = wager.won;

  this['bets'] = [];

  for (var i = 0; i < wager.bets.length; i++) {
    this['bets'].push(new IBet(wager.bets[i]));
  }
}
ClassUtil.CreateClass(IWager);

function IGame(game) {
  this['id'] = game.id;

  this['subsystem'] = game.subsystem;
  this['gametype'] = game.gametype;
  this['model'] = game.model;
  this['modelt'] = game.modelt;

  this['prio'] = game.prio;
  this['fprio'] = game.fprio;
  this['webclient'] = game.webclient;

  this['promoid'] = game.promoid;
  this['webminiclient'] = game.webminiclient;

  this['currency'] = game.currency;
  this['descr'] = game.descr;

  this['icon'] = game.icon;
  this['name'] = game.name;

  this['namet'] = game.namet;
  this['price'] = game.price;

  this['cat1'] = game.cat1;

  if (this['subsystem'].toLowerCase() === 'bingo') {
    this['pprio'] = game.pprio;
    this['chatrooms'] = game.chatrooms;
    this['drawpublishtime'] = game.drawpublishtime;
    this['playmode'] = game.playmode;
    this['starttime'] = game.starttime;
    this['sts'] = game.sts;

    this['schema'] = game.schema;

    if (this['playmode'].toLowerCase() === 'singleuser') {
      this['denoms'] = game.denoms;
      this['maxwin'] = game.maxwin;
    } else {
      this['chatters'] = game.chatters;
      this['online'] = game.online;
      this['players'] = game.players;
      this['jackpotvalue'] = game.jackpotvalue;
      this['alltickets'] = game.alltickets;
      this['ball'] = game.ball;
      this['jackpotcalls'] = game.jackpotcalls;
      this['pot'] = game.pot;
      this['moneyrain'] = false;
      if (game.icon.lastIndexOf('_vinstregn') !== -1) {
        this['moneyrain'] = true;
      }
    }
  }
}
ClassUtil.CreateClass(IGame);

function ILoginResponse(loginresponse) {
  this['request'] = 'Login';
  this['rc'] = loginresponse.rc;

  if (loginresponse.rc !== 0) {
    this['loggedIn'] = false;
    this['msg'] = loginresponse.msg;
    this['action'] = loginresponse.action;
  } else {
    this['loggedIn'] = true;

    this['user'] = new IUser(loginresponse.player);
  }
}
ClassUtil.CreateClass(ILoginResponse);

function IGetBalanceResponse(getbalanceresponse) {
  this['request'] = 'GetBalance';
  this['rc'] = getbalanceresponse.rc;

  if (getbalanceresponse.rc !== 0) {
    this['loggedIn'] = false;
    this['msg'] = getbalanceresponse.msg;
    this['action'] = getbalanceresponse.action;
  } else {
    this['loggedIn'] = true;

    this['user'] = new IUser(getbalanceresponse.user);
  }
}
ClassUtil.CreateClass(IGetBalanceResponse);

function IPayGameResponse(paygameresponse) {
  this['request'] = 'PayGame';
  this['rc'] = paygameresponse.rc;

  if (paygameresponse.rc !== 0) {
    this['msg'] = paygameresponse.msg;
    this['action'] = paygameresponse.action;
  } else {
    this['wager'] = new IWager(paygameresponse.wager);

    this['balance'] = new IBalance(paygameresponse.balance);
    this['bonus'] = new IBonus(paygameresponse.bonus);
  }
}
ClassUtil.CreateClass(IPayGameResponse);

function UiElement(id, type, data, layer) {
  this.id = id;
  this.data = data;
  this.type = type;
  this.layer = layer;

  this.instance = LotteryData.getInstance();
  this.flags = this.instance.getFlags();

  this.active = false;

  this.allElements = {};
  this.images = {};
  this.buttons = {};
  this.colors = {};
  this.elements = {};
  this.texts = {};
  this.scratch = {};
  this.result = {};
  this.paytable = {};
  this.scroll = {};
  this.graphics = {};
  this.animations = {};
  this.resources = {};

  this.myActiveTweens = {};
  this.myActiveTweensQueue = {};

  this.onenter = null;
  this.onexit = null;

  this.parentContainer = new PIXI.Container();
  this.parentContainer.id = id;
  this.parentContainer.visible = false;
  this.layer.addChild(this.parentContainer);
}
ClassUtil.CreateClass(UiElement);
ClassUtil.CreateEventDispatcher(UiElement);

UiElement.prototype.createObjectContainer = function(data) {
  var width = 1;
  var height = 1;

  if (!!data && !!data['size']) {
    width = data['size']['width'];
    height = data['size']['height'];
  }
  var graphic = new PIXI.Graphics();
  graphic.beginFill(0xffffff, 0);
  graphic.drawRect(0, 0, width, height);
  graphic.updateBounds();
  graphic.endFill();

  return new PIXI.Sprite(graphic.generateTexture(false));
};

UiElement.prototype.setActive = function(flag) {
  this.active = flag;

  if (this.active) {
    for (var id in this.buttons) {
      this.buttons[id].element.unBlock();
    }
  } else {
    for (var id in this.buttons) {
      this.buttons[id].element.block();
    }
  }
};

UiElement.prototype.doCall = function(target, param) {
  if (!!this.allElements[target].element.doCall) {
    this.allElements[target].element.doCall(param);
  } else {
    console.warn('Bad definition for call target:' + target);
  }
};

UiElement.prototype.setScratchEnabled = function(target, flag) {
  this.scratch[target].element.setEnabled(flag);
};

UiElement.prototype.findLayoutData = function(myId, dataArray) {
  for (var i = 0; i < dataArray.length; i++) {
    if ((myId = dataArray[i].id)) {
      return dataArray[i];
    }
  }
  return null;
};

UiElement.prototype.updateView = function(flagPortrait, size) {
  return; 
};

UiElement.prototype.updateVisibilityForObject = function(object, param) {
  var testObject = undefined;
  var testArray = [];

  if (!!object['condition']) {
    testObject = this.flags;
    testArray = object['condition'];
  } else {
    if (!!object['parameter']) {
      if (object.elementData['index'] !== undefined) {
        if (!!param) {
          testObject = param[object.elementData['index']];
        }
        testArray = object['parameter'];
      } else {
        testObject = param;
        testArray = object['parameter'];
      }
      if (testObject === undefined) {
        object.element.visible = false;
      }
    }
  }

  if (!!testObject) {
    var visible = true;
    for (var flag in testArray) {
      if (!!testArray[flag]['_attr']) {
        switch (testArray[flag]['_attr']) {
          case 'lessThen':
            if (testObject[flag] > testArray[flag]['value']) {
              visible = false;
            }
            break;

          case 'between':
            if (
              testObject[flag] < testArray[flag]['low'] ||
              testObject[flag] > testArray[flag]['high']
            ) {
              visible = false;
            }
            break;

          case 'not':
            if (testObject[flag] === testArray[flag]['value']) {
              visible = false;
            }
            break;

          default:
            if (testObject[flag] !== testArray[flag]['value']) {
              visible = false;
            }
            break;
        }
      } else {
        if (testObject[flag] !== testArray[flag]) {
          visible = false;
        }
      }
    }
    object.element.visible = visible;
  }
};

UiElement.prototype.updateVisibility = function(objectList) {
  console.log('updateVisibility');

  for (var id in objectList) {
    this.updateVisibilityForObject(objectList[id]);
  }
};

UiElement.prototype.updateDynamicTextForObject = function(id, object) {
  if (!!object.data['dyn']) {
    var value = this.instance.getDynamicValue(object.data['dyn']);
    if (object.data['format'] === 'money') {
      var currency = this.instance.getCurrency();
      value = this.instance.getFormatted(value, currency);
    }
    object.element.text = this.instance.getText(id, value).value;
  }
  if (!!object.data['flag']) {
    if (object.data['flag'].indexOf('random') !== -1) {
      object.element.text = this.instance.getText(id).value;
    }
  }
};

UiElement.prototype.updateDynamicText = function(object) {
  for (var id in object) {
    this.updateDynamicTextForObject(id, object[id]);
  }
};

UiElement.prototype.updateParameterText = function(object, data) {
  for (var id in object) {
    if (!!object[id].data['param']) {
      var value = data[object[id].data['param']];
      if (!value) {
        value = '';
      }
      object[id].element.text = this.instance.getText(id, value).value;
    }
  }
};

UiElement.prototype.updateColor = function(object) {
  for (var id in object) {
    for (var i = 0; i < this.data['colors'].length; i++) {
      if (id === this.data['colors'][i]['id']) {
        var data = this.data['colors'][i];

        if (!!data.position) {
          object[id].element.position.x = data.position.x;
          object[id].element.position.y = data.position.y;
        }
        var colorData = this.colors[id].colorData;
        var alpha = !!colorData.alpha ? parseFloat(colorData.alpha) : 1;

        object[id].element.clear();
        object[id].element.beginFill(
          parseInt(colorData.color.replace(/^#/, ''), 16),
          alpha
        );
        object[id].element.drawRect(0, 0, data.size.width, data.size.height);
        object[id].element.endFill();
      }
    }
  }
};

UiElement.prototype.getPaytableData = function(array, useCurrency) {
  var result = ['', '', ''];

  for (var i = 0; i < array.length; i++) {
    var count = parseInt(array[i][0], 10);
    if (count !== 0) {
      result[0] +=
        this.instance.getFormatted(Math.floor(array[i][0]), '') + '\n';
      result[1] +=
        this.instance.getFormatted(Math.floor(array[i][1]), useCurrency) + '\n';
      result[2] +=
        this.instance.getFormatted(Math.floor(array[i][2]), useCurrency) + '\n';
    }
  }

  return result;
};

UiElement.prototype.updateGraphics = function(object) {
  for (var id in object) {
    var referenceElement = this.findElement(
      this.parentContainer,
      object[id].data.target
    );

    var x =
      referenceElement.position.x -
      referenceElement.anchor.x * referenceElement.width;
    if (
      !!object[id].data.position &&
      object[id].data.position.x !== 'relative'
    ) {
      x = object[id].data.position.x;
    }

    var height = parseInt(referenceElement.style.font, 10);
    var y = referenceElement.position.y - referenceElement.anchor.y * height;
    if (
      !!object[id].data.position &&
      object[id].data.position.y !== 'relative'
    ) {
      y = object[id].data.position.y;
    } else {
      if (object[id].data['flag'] === 'below') {
        y += height + object[id].data['margin'];
      }
      if (object[id].data['flag'] === 'above') {
        y -= object[id].data['margin'];
      }
    }
    object[id].element.position.x = x;
    object[id].element.position.y = y;
  }
};

UiElement.prototype.updatePaytable = function(object, eventName) {
  var payTableWinnings = this.instance.getData('paytablewinnings');
  var payTableTotalWinnings = this.instance.getData('paytabletotalwinnings');
  var currency = this.instance.getCurrency();

  if (eventName === '_play' || eventName === '_do_play_replay') {
    var payTableData = this.getPaytableData(payTableWinnings, currency);

    for (var id in object) {
      var useCurrency = '';

      for (var i = 0; i < 3; i++) {
        var paytable = object[id].data['paytable'];

        var colElement = this.findElement(
          this.parentContainer,
          paytable.cols[i].title + '1'
        );
        colElement.text = payTableData[i];
        colElement.position.x = paytable.cols[i].x - 0.5 * colElement.width;

        var colTotalElement = this.findElement(
          this.parentContainer,
          paytable.cols[i].title + '2'
        );
        colTotalElement.text = this.instance.getFormatted(
          payTableTotalWinnings[i],
          useCurrency
        );

        colTotalElement.position.x = paytable.cols[i].x;
        colTotalElement.position.y =
          colElement.position.y +
          colElement.height +
          paytable['margins']['tableTotal'];
      }
    }
  }
};

UiElement.prototype.setResult = function() {
  for (var id in this.result) {
    this.result[id].element.setResult();
  }
};

UiElement.prototype.update = function(data, eventName) {
  this.updateVisibility(this.images);

  this.updateVisibility(this.buttons);

  this.updateVisibility(this.texts);
  this.updateDynamicText(this.texts);
  this.updateParameterText(this.texts, data);
  this.updatePaytable(this.paytable, eventName);
  this.updateGraphics(this.graphics);
  this.updateColor(this.colors);
};

UiElement.prototype.getData = function(id, data) {
  var inheritId = data[id]['inherit'];

  if (!!inheritId) {
    var result = JSON.parse(JSON.stringify(data[inheritId])); 

    for (var key in data[id]) {
      if (key !== 'inherit') {
        result[key] = data[id][key];
      }
    }
    return result;
  } else {
    return data[id];
  }
};

UiElement.prototype.findElement = function(element, id) {
  if (element.id == id) {
    return element;
  } else if (!!this.allElements[id]) {
    return this.allElements[id].element;
  }
  return null;
};

UiElement.prototype.updateElements = function(object, data) {
  var elementsString = object.target;
  var array = elementsString.split(',');

  function updateIdArray() {
    for (var i = 0; i < array.length; i++) {
      if (!!this.buttons[array[i]]) {
        this.updateVisibilityForObject(this.buttons[array[i]], data);
      } else if (!!this.texts[array[i]]) {
        this.updateVisibilityForObject(this.texts[array[i]], data);
        this.updateDynamicTextForObject(this.texts[array[i]]);
      } else if (!!this.images[array[i]]) {
        this.updateVisibilityForObject(this.images[array[i]], data);
      }
    }
  }

  var tween = new TWEEN.Tween(this)
    .to({}, 0)
    .onComplete(updateIdArray.bind(this));

  return tween;
};

UiElement.prototype.setThisFlag = function(object) {
  var flag = object['flag'];
  var value = object.value;

  function setFlag() {
    console.log('UiElement.setFlag flag:' + flag + ' value:' + value);
    this.instance.setFlag(flag, value);
  }

  var tween = new TWEEN.Tween(this).to({}, 0).onComplete(setFlag.bind(this));

  return tween;
};

UiElement.prototype.createAnimationTween = function(object) {
  var id = object['target'];

  function startAnimation() {
    console.log('UiElement.startAnimation ' + id);
    this.animations[id].element.alpha = 1;
    this.animations[id].element.gotoAndPlay(1);
  }

  var tween = new TWEEN.Tween(this)
    .to({}, 0)
    .onStart(startAnimation.bind(this));

  return tween;
};

UiElement.prototype.createCall = function(object) {
  var tween = new TWEEN.Tween().to({}, 10);

  tween.onComplete(
    function() {
      var target = object['target'];
      var data = this.allElements[target];
      return function() {
        var element = data.element;
        console.log('Do call object :' + target.id);
        element.doCall(object, data);
      };
    }.bind(this)()
  );
  return tween;
};

UiElement.prototype.deleteObject = function(object) {
  var tween = new TWEEN.Tween().to({}, 10);

  tween.onComplete(
    function() {
      var target = object['target'];
      var data = this.allElements[target];
      return function() {
        var element = data.element;
        console.log('Delete object :' + target.id);
        element.parent.removeChild(element);
        element.destroy();
      };
    }.bind(this)()
  );
  return tween;
};

UiElement.prototype.sendEvt = function(object) {
  var tween = new TWEEN.Tween().to({}, 10);

  tween.onComplete(
    (function() {
      var evt = object['evt'];
      return function() {
        console.log('Generated event:' + evt);
        ViewController.getInstance().sendEvent(evt);
      };
    })()
  );
  return tween;
};

UiElement.prototype.getEasingById = function(id) {
  var result = null;

  switch (id) {
    case 'Linear':
      result = TWEEN.Easing.Linear.None;
      break;

    case 'CubicIn':
      result = TWEEN.Easing.Cubic.In;
      break;

    case 'CubicInOut':
      result = TWEEN.Easing.Cubic.InOut;
      break;

    case 'CubicOut':
      result = TWEEN.Easing.Cubic.Out;
      break;

    case 'QuadIn':
      result = TWEEN.Easing.Quadratic.In;
      break;

    case 'QuadInOut':
      result = TWEEN.Easing.Quadratic.InOut;
      break;

    case 'QuadOut':
      result = TWEEN.Easing.Quadratic.Out;
      break;

    case 'QuarticIn':
      result = TWEEN.Easing.Quartic.In;
      break;

    case 'QuarticInOut':
      result = TWEEN.Easing.Quartic.InOut;
      break;

    case 'QuarticOut':
      result = TWEEN.Easing.Quartic.Out;
      break;

    case 'QuinticIn':
      result = TWEEN.Easing.Quintic.In;
      break;

    case 'QuinticInOut':
      result = TWEEN.Easing.Quintic.InOut;
      break;

    case 'QuinticOut':
      result = TWEEN.Easing.Quintic.Out;
      break;

    case 'SinusoidalIn':
      result = TWEEN.Easing.Sinusoidal.In;
      break;

    case 'SinusoidalInOut':
      result = TWEEN.Easing.Sinusoidal.InOut;
      break;

    case 'SinusoidalOut':
      result = TWEEN.Easing.Sinusoidal.Out;
      break;

    case 'ExponentialIn':
      result = TWEEN.Easing.Exponential.In;
      break;

    case 'ExponentialInOut':
      result = TWEEN.Easing.Exponential.InOut;
      break;

    case 'ExponentialOut':
      result = TWEEN.Easing.Exponential.Out;
      break;

    case 'CircularIn':
      result = TWEEN.Easing.Circular.In;
      break;

    case 'CircularInOut':
      result = TWEEN.Easing.Circular.InOut;
      break;

    case 'CircularOut':
      result = TWEEN.Easing.Circular.Out;
      break;

    case 'ElasticIn':
      result = TWEEN.Easing.Elastic.In;
      break;

    case 'ElasticInOut':
      result = TWEEN.Easing.Elastic.InOut;
      break;

    case 'ElasticOut':
      result = TWEEN.Easing.Elastic.Out;
      break;

    case 'BackIn':
      result = TWEEN.Easing.Back.In;
      break;

    case 'BackInOut':
      result = TWEEN.Easing.Back.InOut;
      break;

    case 'BackOut':
      result = TWEEN.Easing.Back.Out;
      break;

    case 'BounceIn':
      result = TWEEN.Easing.Bounce.In;
      break;

    case 'BounceInOut':
      result = TWEEN.Easing.Bounce.InOut;
      break;

    case 'BounceOut':
      result = TWEEN.Easing.Bounce.Out;
      break;

    default:
      break;
  }
  return result;
};

UiElement.prototype.createTween = function(object) {
  var fromData = {};
  var toData = {};
  var tween;
  var element;
  var dynamicPosition = { xstart: 0, ystart: 0, xdelta: 0, ydelta: 0 };

  var toValue = object['to'];
  if (toValue.indexOf('<') !== -1) {
    var key = toValue.slice(toValue.indexOf('<') + 1, toValue.indexOf('>'));
    toValue = this.instance.getFlag(key);
  }

  var key = object['param'];
  var valueArray = [toValue];

  if (isNaN(toValue)) {
    valueArray = toValue.split(',');
  }

  if (valueArray.length > 1) {
    for (var j = 0; j < valueArray.length; j++) {
      var item = valueArray[j].split(':');
      if (item.length > 1) {
        toData[item[0]] = parseFloat(item[1]);
      } else {
        toData = parseFloat(valueArray[j]);
      }
    }

    element = this.findElement(this.parentContainer, object.target);
    tween = new TWEEN.Tween(element[key]).to(toData, object.time);
  } else {
    toData[key] = parseFloat(valueArray[0]); 
    element = this.findElement(this.parentContainer, object.target);
    tween = new TWEEN.Tween(element).to(toData, object.time);
  }

  if (!!object['delay']) {
    tween.delay(parseInt(object['delay'], 10));
  }

  if (!!object['easing']) {
    var easing = this.getEasingById(object['easing']);
    if (!!easing) {
      tween.easing(easing);
    }
  }

  return tween;
};

UiElement.prototype.addTween = function(tweenArray, tween, paralell) {
  if (tween.constructor === Array) {
    if (tween.length > 0) {
      if (!!paralell && paralell) {
        if (tweenArray.length === 0) {
          var startTween = new TWEEN.Tween().to({}, 10);
          tweenArray.push(startTween); 
        }
        tweenArray[tweenArray.length - 1].chain.apply(this, tween);
        tweenArray.push(tween[0]); 
      } else {
        if (tweenArray.length > 0) {
          tweenArray[tweenArray.length - 1].chain(tween[0]);
        }
        tweenArray = tweenArray.concat(tween);
      }
    }
  } else {
    if (tweenArray.length > 0) {
      tweenArray[tweenArray.length - 1].chain(tween);
    }
    tweenArray.push(tween);
  }
  return tweenArray;
};

UiElement.prototype.handleQueingOfTweens = function(tweenArray, id) {
  function onMyComplete() {
    if (
      !!this.myActiveTweensQueue[id] &&
      this.myActiveTweensQueue[id].length > 0
    ) {
      var tweens = this.myActiveTweensQueue[id].splice(0, 1);
      tweens[0][0].start();
    } else {
      delete this.myActiveTweensQueue[id];
      delete this.myActiveTweens[id];
    }
  }

  var tween = new TWEEN.Tween(this)
    .to({}, 0)
    .onComplete(onMyComplete.bind(this));

  tweenArray = this.addTween(tweenArray, tween);

  if (!!this.myActiveTweens[id]) {
    if (!this.myActiveTweensQueue[id]) {
      this.myActiveTweensQueue[id] = [];
    }
    this.myActiveTweensQueue[id].push(tweenArray);
  } else {
    this.myActiveTweens[id] = tweenArray;
    tweenArray[0].start();
  }
};

UiElement.prototype.createTask = function(tasklistItem, data) {
  var tween = null;

  switch (tasklistItem['task']) {
    case 'sendEvt':
      tween = this.sendEvt(tasklistItem);
      break;

    case 'animate':
      tween = this.createAnimationTween(tasklistItem);
      break;

    case 'call':
      tween = this.createCall(tasklistItem);
      break;

    case 'delete':
      tween = this.deleteObject(tasklistItem);
      break;

    case 'scratch':
      break;

    case 'set':
      tween = this.setThisFlag(tasklistItem);
      break;

    case 'update':
      tween = this.updateElements(tasklistItem, data);
      break;

    case 'presentresult':
      tween = this.result[tasklistItem.target].element.presentResult(
        tasklistItem
      );
      break;

    case 'tween':
      tween = this.createTween(tasklistItem);
      break;

    default:
      break;
  }

  return tween;
};

UiElement.prototype.doTasks = function(object, data) {
  var tasklist = object['obj']['tasklist'];
  var tween;
  var tweens = [];
  var subTweens = [];
  var subList;

  for (var i = 0; i < tasklist.length; i++) {
    if (tasklist[i].constructor === Array) {
      subTweens = [];
      subList = tasklist[i];
      for (var j = 0; j < subList.length; ++j) {
        if (subList[j].constructor === Array) {
          subTweens.push(this.doTasks(subList[j], data));
        } else {
          subTweens.push(this.createTask(subList[j], data));
        }
      }
      tweens = this.addTween(tweens, subTweens, true);
    } else {
      tween = this.createTask(tasklist[i], data);

      if (!!tween) {
        tweens = this.addTween(tweens, tween);
      }
    }
  }

  if (!!object['obj']['queue']) {
    this.handleQueingOfTweens(tweens, object['obj']['queue']);
  } else {
    tweens[0].start();
  }
};

UiElement.prototype.setScale = function(element, scale) {
  element.scale.x = scale.x;
  element.scale.y = scale.y;
};

UiElement.prototype.setPosition = function(element, position, parentSize) {
  if (!!position) {
    if (position['xalign'] === 'center') {
      element.anchor.x = 0.5;
      element.position.x = position.x;
    } else {
      if (position.x === 'center') {
        element.anchor.x = 0.5;
        element.position.x = 0.5 * parentSize.width;
      } else {
        element.position.x = position.x;
      }
    }

    if (position['yalign'] === 'center') {
      element.anchor.y = 0.5;
      element.position.y = position.y;
    } else {
      if (position.y === 'center') {
        element.anchor.y = 0.5;
        element.position.y = 0.5 * parentSize.height;
      } else {
        element.position.y = position.y;
      }
    }
  }

  if (!!element.data && !!element.data['anchor']) {
    element.anchor.x = element.data['anchor'].x;
    element.anchor.y = element.data['anchor'].y;
  }
};

UiElement.prototype.createEventListeners = function(element, data) {
  console.log('createEventListeners');
  var instance = ViewController.getInstance();

  if (!!data['onevt']) {
    var onEvent = data['onevt'];

    if (onEvent.constructor === Array) {
      for (var i = 0; i < onEvent.length; i++) {
        instance.addGameEventListener(onEvent[i]['id'], {
          evt: onEvent[i]['id'],
          condition: onEvent[i]['condition'],
          parameter: onEvent[i]['parameter'],
          action: onEvent[i].action,
          state: this.type,
          obj: onEvent[i],
          func: this.doTasks.bind(this),
          onenter: data['onenter'],
          object: this
        });
      }
    } else {
      for (var key in onEvent) {
        instance.addGameEventListener(key, {
          evt: key,
          condition: onEvent[key]['condition'],
          parameter: onEvent[key]['parameter'],
          action: onEvent[key].action,
          state: this.type,
          obj: onEvent[key],
          func: this.doTasks.bind(this),
          onenter: data['onenter'],
          object: this
        });
      }
    }
  }

  if (!!data['onenter']) {
    this.onenter = data['onenter'];
  }

  if (!!data['onexit']) {
    this.onexit = data['onexit'];
  }
};

UiElement.prototype.createImages = function(element, data) {
  try {
    if (!!data.images) {
      var image;
      for (var key in data.images) {
        var frameId = key;
        if (!!data.images[key]['frameId']) {
          frameId = data.images[key]['frameId'];
        }
        image = new PIXI.Sprite.fromFrame(frameId);
        image.id = key;
        image.data = data.images[key];


        ValueUtil.setAttributes(image, data.images[key]);

        if (!!image.data['scale']) {
          this.setScale(image, image.data['scale']);
        }
        this.allElements[key] = this.images[key] = {
          element: image,
          elementData: data.images[key],
          data: data,
          condition: data.images[key]['condition'],
          parameter: data.images[key]['parameter']
        };
      }
    }
  } catch (error) {
    var errData = { request: '', rc: '', msg: error.message };
    ViewController.getInstance().sendEvent(
      EventModel.events._fatalerror,
      errData
    );
  }
};

UiElement.prototype.createButtons = function(element, data) {
  if (!!data['buttons']) {
    var image;

    for (var key in data['buttons']) {
      var button = new ButtonSprite();
      button.id = key;

      button.setSpritesFromData(data['buttons'][key]);

      if (data['buttons'][key]['anchor']) {
        button.anchor.x = data['buttons'][key]['anchor'].x;
        button.anchor.y = data['buttons'][key]['anchor'].y;
      }


      button.position = new PIXI.Point(
        data['buttons'][key].position.x,
        data['buttons'][key].position.y
      );

      var _this = this;

      button.AddEventListener(
        ButtonSprite.Events.Click,
        (function() {
          var buttonData = data['buttons'][key];
          return function() {
            console.log('### Button pressed:' + buttonData['evt']);
            if (this.active) {
              LotteryData.getInstance().setFlag('initiator', buttonData['evt']);
              ViewController.getInstance().sendEvent(
                buttonData['evt'],
                buttonData
              );
            }
          };
        })(),
        _this
      );

      this.allElements[key] = this.buttons[key] = {
        element: button,
        elementData: data['buttons'][key],
        condition: data['buttons'][key]['condition'],
        parameter: data['buttons'][key]['parameter']
      };
    }
  }
};

UiElement.prototype.createColors = function(element, data) {
  if (!!data['colors']) {
    var color;
    for (var key in data['colors']) {
      var colorData = this.instance.getColor(key);
      var alpha =
        colorData['alpha'] !== undefined ? parseFloat(colorData['alpha']) : 1;

      color = new PIXI.Graphics();
      color.id = key;
      color.data = data['colors'][key];

      var width = data['colors'][key].size.width;
      var height = data['colors'][key].size.height;

      if (width === 'scene') {
        width = SceneGraph.getSceneSize().width; 
      }
      if (height === 'scene') {
        height = SceneGraph.getSceneSize().height; 
      }

      color.clear();
      color.beginFill(parseInt(colorData.color.replace(/^#/, ''), 16), alpha);
      color.drawRect(0, 0, width, height);
      color.endFill();

      this.allElements[key] = this.colors[key] = {
        element: color,
        elementData: element.data['colors'][key],
        condition: data['colors'][key]['condition'],
        parameter: data['colors'][key]['parameter'],
        param: data['colors'][key]['param'],
        dyn: data['colors'][key]['dyn'],
        colorData: colorData
      };
    }
  }
};

UiElement.prototype.createElements = function(element, data) {
  if (!!data['elements']) {
    var myElement;

    for (var id in data['elements']) {
      myElement = new GameElement(
        id,
        this.getData(id, data['elements']),
        this.resources
      );

      this.allElements[id] = this.elements[id] = {
        element: myElement,
        elementData: data['elements'][id],
        condition: data['elements'][id]['condition'],
        parameter: data['elements'][id]['parameter'],
        param: data['elements'][id]['param'],
        dyn: data['elements'][id]['dyn']
      };

      this.setPosition(myElement, data['elements'][id]['position'], data);

      element.addChild(myElement);
    }
  }
};

UiElement.prototype.createTextItem = function(id, element, data, parentSize) {
  var styleId = !!data.style ? data.style : id;
  var fontData = this.instance.getBaseFont();
  var textData = this.instance.getText(styleId);

  for (var key in textData) {
    fontData[key] = textData[key];
  }

  var textValue = textData['value'];
  var text = new PIXI.Text(textValue);
  text.id = id;

  if (!!data.anchor) {
    text.anchor.x = data.anchor.x;
    text.anchor.y = data.anchor.y;
  }
  var format = '';
  if (fontData['style'] !== '') {
    format += fontData['style'] + ' ';
  }

  var style = {
    fontStyle: format,
    fontSize: fontData['fontSize'] + 'px ',
    fontFamily: fontData['family'],
    fill: fontData['color'],
    align: fontData['align']
  };
  if (!!fontData['wordWrap']) {
    style['wordWrap'] = fontData['wordWrap'];
  }
  if (!!fontData['wordWrapWidth']) {
    style['wordWrapWidth'] = fontData['wordWrapWidth'];
  }

  text.style = style;

  this.setPosition(text, data.position, parentSize.size);

  this.allElements[id] = this.texts[id] = {
    element: text,
    data: data,
    elementData: data,
    condition: data['condition'],
    parameter: data['parameter']
  };
};

UiElement.prototype.createTexts = function(element, data) {
  if (!!data['texts']) {
    var text;
    for (var key in data['texts']) {
      this.createTextItem(key, element, data['texts'][key], data);
    }
  }
};

UiElement.prototype.createGraphics = function(
  element,
  colorData,
  position,
  data
) {
  var alpha = !!colorData.alpha ? parseFloat(colorData.alpha) : 1;

  var divider = new PIXI.Graphics();
  divider.id = data.id;
  divider.position.x = position.x;
  divider.position.y = position.y;

  divider.clear();
  divider.beginFill(parseInt(colorData.color.replace(/^#/, ''), 16), alpha);
  divider.drawRect(0, 0, data.size.width, data.size.height);
  divider.endFill();

  this.allElements[data.id] = this.graphics[data.id] = {
    element: divider,
    elementData: data,
    condition: data['condition'],
    parameter: data['parameter'],
    colorData: colorData,
    data: data
  };
};

UiElement.prototype.createDivider = function(element, data) {
  if (!!data['divider']) {
    var divider;
    for (var i = 0; i < data['divider'].length; i++) {
      var referenceElement = this.findElement(
        this.parentContainer,
        data['divider'][i].target
      );
      var colorData = this.instance.getColor(data['divider'][i].color);

      var x =
        referenceElement.position.x -
        referenceElement.anchor.x * referenceElement.width;
      if (
        !!data['divider'][i].position &&
        data['divider'][i].position.x !== 'relative'
      ) {
        x = data['divider'][i].position.x;
      }
      var y =
        referenceElement.position.y -
        referenceElement.anchor.y * referenceElement.height;
      if (
        !!data['divider'][i].position &&
        data['divider'][i].position.y !== 'relative'
      ) {
        y = data['divider'][i].position.y;
      } else {
        if (data['divider'][i]['flag'] === 'below') {
          y += 0.5 * referenceElement.height + data['divider'][i].margin;
        }
        if (data['divider'][i]['flag'] === 'above') {
          y -= data['divider'][i].margin;
        }
      }

      this.createGraphics(
        element,
        colorData,
        { x: x, y: y },
        data['divider'][i]
      );
      console.log('creating divider');
    }
  }
};

UiElement.prototype.createPaytable = function(element, data) {
  if (!!data['paytable']) {
    var generatedData = {};
    generatedData.id = data['paytable'].id;
    generatedData.position = data['paytable'].position;
    generatedData['divider'] = data['paytable']['divider'];
    generatedData.texts = generatedData['texts'] = [];
    var yPos = 0;
    var margins = data['paytable']['margins'];

    for (var i = 0; i < data['paytable'].cols.length; i++) {
      generatedData.texts.push({
        id: data['paytable'].cols[i].title,
        anchor: { x: 0.5, y: 0.5 },
        position: { x: data['paytable'].cols[i].x, y: yPos }
      });

      generatedData.texts.push({
        id: data['paytable'].cols[i].title + '1',
        style: 'textDialogPayTable',
        position: {
          x: data['paytable'].cols[i].x,
          y: yPos + margins['titleTable']
        }
      });

      generatedData.texts.push({
        id: data['paytable'].cols[i].title + '2',
        style: 'textDialogPayTableTotal',
        anchor: { x: 0.5, y: 0.5 },
        position: { x: 0, y: 0 } 
      });
    }

    yPos += margins['titleTable'];

    var newContainer = new PIXI.Container();

    this.createView(newContainer, generatedData);

    this.allElements[data['paytable'].id] = this.paytable[
      data['paytable'].id
    ] = {
      element: newContainer,
      elementData: data,
      data: data
    };
  }
};

UiElement.prototype.createAnimations = function(element, data) {
  function whenComplete(anim) {
    anim.alpha = 0;
  }

  var instance = ViewController.getInstance();
  try {
    if (!!data['animations']) {
      var anim;
      for (var i = 0; i < data['animations'].length; i++) {
        var animItem = data['animations'][i];
        var animData = this.instance.getAnimation(animItem['use']);
        var framesData = animData['frames'].split(',');
        var frames = [];

        for (var j = 0; j < framesData.length; j++) {
          frames[j] = PIXI.Texture.fromFrame(framesData[j]);
        }

        anim = new PIXI.extras.AnimatedSprite(frames);
        var fps = parseInt(animData['fps'], 10);
        anim.animationSpeed = fps / 60;
        anim.loop = false; 
        anim.alpha = 0; 
        anim.onComplete = whenComplete.bind(this, anim);

        anim.id = data['animations'][i].id;
        anim.position = new PIXI.Point(
          data['animations'][i].position.x,
          data['animations'][i].position.y
        );
        this.allElements[data['animations'][i].id] = this.animations[
          data['animations'][i].id
        ] = {
          element: anim,
          elementData: data,
          data: data,
          condition: data['animations'][i]['condition'],
          parameter: data['animations'][i]['parameter']
        };
      }
    }
  } catch (error) {
    var errData = { request: '', rc: '', msg: error.message };
    ViewController.getInstance().sendEvent(
      EventModel.events._fatalerror,
      errData
    );
  }
};

UiElement.prototype.createTaskList = function(element, data) {
  var instance = ViewController.getInstance();

  if (!!data['tasklist']) {
    var evtArray = data['tasklist'];

    for (var i = 0; i < evtArray.length; i++) {
      instance.addGameEventListener(evtArray[i]['onevt'], {
        evt: evtArray[i]['onevt'],
        condition: evtArray[i].condition,
        parameter: evtArray[i].parameter,
        action: evtArray[i].action,
        obj: evtArray[i],
        func: this.doTasks.bind(this),
        object: this
      });
    }
  }
};

UiElement.prototype.createScratch = function(element, data) {
  var scratch;

  if (!!data['scratch']) {
    if (data['scratch'].constructor === Array) {
      for (var i = 0; i < data['scratch'].length; i++) {
        var spriteElement = this.findElement(
          element,
          data['scratch'][i].parent
        );
        var scratchConfig = {
          id: data['scratch'][i].id,
          element: spriteElement,
          parent: data['scratch'][i].parent,
          hitarea: data['scratch'][i]['hitarea'],
          tool: data['scratch'][i]['tool'],
          data: data['scratch'][i]
        };
        scratch = new ScratchView(scratchConfig);

        this.allElements[data['scratch'][i].id] = this.scratch[
          data['scratch'][i].id
        ] = { element: scratch, config: scratchConfig };
      }
    } else {
      for (var key in data['scratch']) {
        var spriteElement = this.findElement(
          element,
          data['scratch'][key].parent
        );
        var scratchConfig = {
          id: key,
          element: spriteElement,
          parent: data['scratch'][key].parent,
          hitarea: data['scratch'][key]['hitarea'],
          tool: data['scratch'][key]['tool'],
          data: data['scratch'][key]
        };
        scratch = new ScratchView(scratchConfig);

        this.allElements[key] = this.scratch[key] = {
          element: scratch,
          config: scratchConfig
        };
      }
    }
  }
};

UiElement.prototype.createHitarea = function(element, data) {
  if (!!data['hitarea']) {
    var hitarea;
    for (var i = 0; i < data['hitarea'].length; i++) {
      element.hitArea = new PIXI.Rectangle(
        data['hitarea'][i].position.x,
        data['hitarea'][i].position.y,
        data['hitarea'][i].size.width,
        data['hitarea'][i].size.height
      );
      element.interactive = true;
      var evt = data['hitarea'][i]['evt'];

      element.click = element['tap'] = function() {
        ViewController.getInstance().sendEvent(evt);
      };
    }
  }
};

UiElement.prototype.createResultScratch = function(element, data) {
  var spriteElement = this.findElement(element, data.parent);
  var resultConfig = {
    id: data.id,
    element: spriteElement,
    data: data
  };

  var result = new ResultView(resultConfig);

  this.result[data.id] = {
    element: result,
    config: resultConfig,
    elementData: data
  };
};

UiElement.prototype.createGameResult = function(id, element, data, model) {
  var spriteElement = this.findElement(element, data.parent);
  var dataConfig = { data: data, element: spriteElement };
  var result;

  switch (model) {
    case 'bingo':
      result = new ResultBingo(dataConfig);
      break;
    case 'scratchandmatch':
      result = new ResultMatcha(dataConfig);
      break;
    case 'pyramidkeno':
      result = new ResultKeno(dataConfig);
      break;
    case 'kryss':
    default:
      result = new ResultKryss(dataConfig);
      break;
  }

  this.allElements[id] = this.result[id] = {
    element: result,
    data: data,
    elementData: data
  };
};

UiElement.prototype.createResult = function(element, data) {
  if (!!data.result) {
    for (var key in data.result) {
      switch (this.instance.model) {
        case 'kryss':
        case 'bingo':
        case 'pyramidkeno':
        case 'scratchandmatch':
          this.createGameResult(
            key,
            element,
            data.result[key],
            this.instance.model
          );
          break;

        default:
          data.result[key].id = key;
          this.createResultScratch(element, data.result[key]);
          break;
      }
    }
  }
};

UiElement.prototype.createScroll = function(element, data) {
  console.log('createScroll');
  if (!!data.scroll) {
    var scroll;
    for (var i = 0; i < data.scroll.length; i++) {
      scroll = new Scroll(element, data.scroll[i], data.size);

      this.scroll[data.scroll[i].id] = {
        object: scroll,
        element: element,
        data: data.scroll[i],
        size: data.size
      };
    }
  }
};

UiElement.prototype.getParentSize = function(element) {
  if (
    (element.parent.width === 0 && element.parent.height === 0) ||
    element.parent instanceof PIXI.Container
  ) {
    if (!!element.parent.data && !!element.parent.data.size) {
      return element.parent.data.size;
    } else if (!!element.parent.texture) {
      return element.parent.texture;
    } else {
      return element.parent; 
    }
  } else {
    return element.parent;
  }
};

UiElement.prototype.createGenericData = function(element, data) {
  for (var elementId in this.allElements) {
    var myElementData = this.allElements[elementId];
    var parentId = myElementData.elementData.parent;

    if (
      (!!myElementData.excludedFlag && myElementData.excludedFlag) ||
      !!myElementData.element.parent
    ) {
    } else {
      if (!!parentId && !!this.allElements[parentId]) {
        this.allElements[parentId].element.addChild(myElementData.element);
      } else {
        element.addChild(myElementData.element);
      }
    }
  }

  for (var elementId in this.allElements) {
    var myElementData = this.allElements[elementId];
    var parentSize = this.getParentSize(myElementData.element);

    this.setPosition(
      myElementData.element,
      myElementData.elementData.position,
      parentSize
    );
  }
};

UiElement.prototype.updateAttributes = function(element, data) {
  for (var key in data) {
    if (
      !!data[key] &&
      data[key].constructor !== Array &&
      data[key].constructor !== Object
    ) {
      this[key] = data[key];
    }
  }
};

UiElement.prototype.createView = function(element, data) {
  if (!!data.id) {
    element.id = data.id;
  }
  element.data = data;
  this.allElements[element.id] = {
    element: element,
    elementData: data,
    excludedFlag: true
  };

  var scaleX = 1;
  var scaleY = 1;
  if (!!data['scale']) {
    scaleX = data['scale'].x;
    scaleY = data['scale'].y;
    this.setScale(element, data['scale']);
  }

  if (!!data['position']) {
    if (!!data['anchor']) {
      if (!!data['size']) {
        var x =
          data['position'].x +
          data['anchor'].x * data['size']['width'] * (1 - scaleX);
        var y =
          data['position'].y +
          data['anchor'].y * data['size']['height'] * (1 - scaleY);
        element.position = new PIXI.Point(x, y);
      } else {
        element.position = new PIXI.Point(
          data['position'].x,
          data['position'].y
        );
      }
    } else {
      element.position = new PIXI.Point(data['position'].x, data['position'].y);
    }
  }

  try {
    this.updateAttributes(element, data);

    this.createEventListeners(element, data);
    this.createImages(element, data);
    this.createButtons(element, data);
    this.createColors(element, data);
    this.createTexts(element, data);

    this.createAnimations(element, data); 
    this.createPaytable(element, data);
    this.createDivider(element, data);
    this.createElements(element, data);

    this.createGenericData(element, data);

    this.createHitarea(element, data);
    this.createScratch(element, data);
    this.createResult(element, data);
    this.createScroll(element, data);

    var containers = data['containers'];

    if (!!containers) {
      for (var containerKey in containers) {
        var newContainer = new PIXI.Container();
        newContainer.id = containerKey;
        element.addChild(newContainer);
        this.createView(newContainer, containers[containerKey]);
      }
    }
  } catch (error) {
    var errData = {
      id: 'fatalerror',
      data: {
        request: 'internal',
        rc: 603,
        msg: 'Can not create view ' + data.id
      }
    };
    ViewController.getInstance().sendEvent(
      EventModel.events._fatalerror,
      errData
    );
  }
};

UiElement.prototype.setup = function() {
  while (this.parentContainer.children.length > 0) {
    this.parentContainer.removeChildAt(0);
  }

  this.createView(this.parentContainer, this.data);
};

UiElement.prototype.updateImages = function(element, data) {
  if (!!data.images) {
    for (var i = 0; i < data.images.length; i++) {
      var imageElement = this.findElement(element, data.images[i].id);

      imageElement.position = new PIXI.Point(
        data.images[i].position.x,
        data.images[i].position.y
      );
      imageElement.alpha = 1;
      if (!!data.images[i].alpha) {
        imageElement.alpha = data.images[i].alpha;
      }
    }
  }
};

UiElement.prototype.updateDataView = function(element, data) {
  if (!!data['position']) {
    this.setPosition(element, data['position'], element.parent);
  }
  if (!!data['scale']) {
    this.setScale(element, data['scale']);
  }
  this.updateImages(element, data);

  var containers = data['containers'];

  if (!!containers) {
    for (var i = 0; i < containers.length; i++) {
      var childData = containers[i];
      var childElement = this.findElement(element, childData.id);

      this.updateDataView(childElement, childData);
    }
  }
};

UiElement.prototype.resetData = function() {
  if (!!this.data['position']) {
    this.parentContainer.position.x = this.data['position'].x;
    this.parentContainer.position.y = this.data['position'].y;
  }
  this.updateDataView(this.parentContainer, this.data);

  for (var key in this.result) {
    this.result[key].element.reset();
  }

  for (var key in this.scratch) {
    this.scratch[key].element.resetData();
  }
};

UiElement.prototype.destroy = function() {
  for (var key in this.allElements) {
    this.allElements[key].element.destroy();
  }
  this.allElements = {};
};

function GameState(id, data, layer) {
  UiElement.call(this, id, 'gamestate', data, layer);

  this.setup();
}
ClassUtil.CreateClass(GameState, UiElement);
ClassUtil.CreateEventDispatcher(UiElement);

GameState.Events.Begin = 'Begin';
GameState.Events.End = 'End';

GameState.Types = {
  Undefined: 'Undefined',
  Loading: 'Loading'
};

GameState.prototype.setup = function() {
  if (!!this.data) {
    UiElement.prototype.setup.call(this);
  }
};

GameState.prototype.doCall = function(target, param) {
  UiElement.prototype.doCall.call(this, target, param);
};


GameState.prototype.run = function() {
  UiElement.prototype.setActive.call(this, true);

  this.update(undefined, undefined);
  this.DispatchEvent(GameState.Events.Begin);

  this.parentContainer.visible = true;
  this.running = true;
};

GameState.prototype.resetData = function() {
  UiElement.prototype.resetData.call(this);
};

GameState.prototype.stop = function() {
  UiElement.prototype.setActive.call(this, false);

  this.parentContainer.visible = false;
  this.running = false;

  if (!!this.data) {
    this.resetData();
  }
};

GameState.prototype.destroy = function() {
  UiElement.prototype.destroy.call(this);
};

function LoadingGameState(id, type, layer) {
  GameState.call(this, id, type, layer);
}
ClassUtil.CreateClass(LoadingGameState, GameState);
ClassUtil.CreateEventDispatcher(LoadingGameState);

LoadingGameState.prototype.Setup = function() {

  while (this.parentContainer.children.length > 0) {
    this.parentContainer.removeChildAt(0);
  }

};

LoadingGameState.prototype.Run = function() {
  GameState.prototype.Run.call(this);

  this.DispatchEvent(GameState.Events.Begin);
};

LoadingGameState.prototype.Stop = function() {
  GameState.prototype.Stop.call(this);
};

function Engine(eventCallback, options) {
  this.eventCallback = eventCallback;
  this.options = options;

  this.raId = 0;
  this.scratchActive = false;

  this.device = Device.getInstance();
  this.dataInstance = LotteryData.getInstance();

  this.communicationservices = null;
  this.playercontroller = null;

  this.eventListenerList = [];

  this.viewcontroller = null;

  this.resizeTimeoutId = 0;

  this.device.Init();


  this.loaderController = new LoaderController();

  this.addGameEventListener(this.loaderController);

  var res = {};
  res.data = {
    application: {
      id: 'Svs nyx client',
      operator: 'SVSD',
      partner: 'SVSD',
      skinname: 'default',
      channel: 'channel',
      universe: 'default',
      language: 'sv',
      nyxroot: '',
      assetsrootpath: 'trissassets/'
    }
  };

  try {

    res.data['application']['nyxroot'] = svs.core.jupiter.url() + '/proxy/';
    res.data['application']['assetsrootpath'] =
      svs.core.config.data.svsconfig.cdn2 + '/nyx/trissassets/';

  } catch (err) {
  }

  this.loaderController.onSettingsLoaded(res, null);

  if (!!options) {
    if (!!options['operator']) {
      this.dataInstance.settings.operator = options['operator'];
    }
    if (!!options['partner']) {
      this.dataInstance.settings.partner = options['partner'];
    }
  }
}
ClassUtil.CreateClass(Engine, EventModel);

Engine.prototype.callback = function(eventId, opt_data) {
  setTimeout(this.eventCallback.bind(this, eventId, opt_data), 50);
};



Engine.prototype.setup = function(data) {
  this.scratchActive = true;
  SceneGraph.setup(
    data,
    0,
    this.dataInstance.getTicketSize(),
    this.device.size
  );

  if (this.viewcontroller === null) {
    this.viewcontroller = ViewController.getInstance();
    this.addGameEventListener(this.viewcontroller);

    this.loaderController.startLoaderDialog();

    AudioManager.GetInstance().SetRenderer(AudioManager.GetHTMLAudioRenderer());
  }

  this.viewcontroller.init(); 

  this.lastUpdateTime = Date.now();
  this.raId = window.requestAnimationFrame(this.update.bind(this));

  this.callback('GameSetupReady', {
    canvasDomElement: SceneGraph.renderer.view
  });
};

Engine.prototype.destroy = function() {
  this.scratchActive = false;
  if (this.raId !== 0) {
    window.cancelAnimationFrame(this.raId);
    this.raId = 0;
  }
};

Engine.prototype.setConfig = function(config) {
  this.config = config;

  if (!!this.config['debug']) {
    this.dataInstance.setFlag(LotteryData.Flag['debug'], this.config['debug']);
  }

  this.loaderController = new LoaderController();
};

Engine.prototype.setHusk = function(huskData) {
  if (!!huskData) {
    if (!isMsIE()) {
      this.dataInstance.setFlag(LotteryData.Flag['husk'], huskData);
    } else {
      this.dataInstance.setFlag(LotteryData.Flag['husk'], false);
    }
  } else {
    this.dataInstance.setFlag(LotteryData.Flag['husk'], false);
  }
};

Engine.prototype.trigger = function(id, data) {
  switch (id) {
    case 'audio':
      if (data['audio']) {
        this.sendEvent('audioon');
      } else {
        this.sendEvent('audiooff');
      }
      break;
    case 'login':
      this.sendEvent(id, data);
      break;

    case 'ticketCheckResult':
      this.sendEvent('do_check');
      break;

    case 'ticketSetup':
    case 'ticketLoadDemo':
    case 'ticketGetGameConfig':
      SceneGraph.enableAutoPrevent();
      var gameid = data['gameid'];
      if (!!gameid) {
        this.dataInstance.getSettings().gameid = data['gameid'];
        if (id === 'ticketLoadDemo') {
          this.setHusk(data['displayHusk']);
        }
        this.sendEvent(id, data);
      } else {
        var errorData = {
          rc: '602',
          msg: 'Missing gameid in request',
          request: id
        };
        this.handleError('internal', errorData);
      }
      break;

    case 'ticketPayGame':
      var gameid = data['gameid'];
      if (!!gameid) {
        if (!!data['price'] && !!data['currency']) {
          this.dataInstance.getSettings().gameid = data['gameid'];

          if (!!data['voucherid']) {
            var voucherid = data['voucherid'];
            if (voucherid.length === 12 && voucherid.indexOf(' ') === -1) {
              this.sendEvent(id, data);
            } else {
              var errorData = {
                rc: '606',
                msg: 'Invalid voucherid ' + voucherid,
                request: id
              };
              this.handleError('internal', errorData);
            }
          } else {
            this.sendEvent(id, data);
          }
        } else {
          var errorData = {
            rc: '602',
            msg: 'Missing parameter(s) in request',
            request: id
          };
          this.handleError('internal', errorData);
        }
      } else {
        var errorData = {
          rc: '602',
          msg: 'Missing gameid in request',
          request: id
        };
        this.handleError('internal', errorData);
      }
      break;

    case 'ticketLoad':
      SceneGraph.enableAutoPrevent();
      var ref = data['svsid']; 
      var wagerid = data['wagerid'];
      if (!!ref) {
        this.dataInstance.setFlag(LotteryData.Flag['demo'], false);

        this.dataInstance.getSettings().ref = ref;
        this.dataInstance.getSettings().wagerid = 0;

        this.setHusk(data['displayHusk']);

        this.sendEvent(id, data);
      } else {
        if (!!wagerid) {
          this.dataInstance.setFlag(LotteryData.Flag['demo'], false);

          this.dataInstance.getSettings().ref = 0;
          this.dataInstance.getSettings().wagerid = wagerid;

          this.setHusk(data['displayHusk']);

          this.sendEvent(id, data);
        } else {
          var errorData = {
            rc: '602',
            msg: 'Missing wagerid or svsid in request',
            request: id
          };
          this.handleError('internal', errorData);
        }
      }
      break;

    default:
      this.sendEvent(id, data);
      break;
  }
};

Engine.prototype.update = function() {
  var now =
    window.performance !== undefined && window.performance.now !== undefined
      ? window.performance.now()
      : Date.now(); 

  var deltaTime = (now - this.lastUpdateTime) / 1000;


  TWEEN.update(now);

  SceneGraph.Render();

  this.lastUpdateTime = now;
  Device.RequestAnimationFrame(this.update.bind(this));
};

Engine.prototype.addGameEventListener = function(module) {
  module.sendEvent = this.sendEvent.bind(this);

  this.eventListenerList.push(module);
};

Engine.prototype.sendEvent = function(eventId, opt_data) {
  console.log('------ sendEvent ' + eventId + ' ' + opt_data);

  this.onEvent(eventId, opt_data);

  for (var i = 0; i < this.eventListenerList.length; i++) {
    this.eventListenerList[i].onEvent(eventId, opt_data);
  }
};

Engine.prototype.setupAudio = function() {
  console.log('setupAudio');

  var audioMgr = AudioManager.GetInstance();

  audioMgr.Init();

  var gameSettings = this.dataInstance.getGameSettings();
  var spriteData = gameSettings['audio'];
  var settings = this.dataInstance.getSettings();
  var url =
    settings.assetsRootPath +
    settings.language +
    '/' +
    this.dataInstance.getDynamicValue('loadicon') +
    '/';

  if (!!spriteData) {
    audioMgr.AddAudioSprite(spriteData, url);
  }

  var flag = this.dataInstance.getFlag(LotteryData.Flag.audio);
  if (flag) {
    audioMgr.UnMute();
  } else {
    audioMgr.Mute();
  }
};

Engine.prototype.loadedSettings = function() {
  this.communicationservices = new CommunicationServices();
  this.addGameEventListener(this.communicationservices);

};

Engine.prototype.loadedResources = function() {

  this.viewcontroller.setupViews();

};

Engine.prototype.playDemo = function(data) {
  this.dataInstance.setFlag(LotteryData.Flag['demo'], true);
  this.dataInstance.setFlag(LotteryData.Flag['result'], false);

  var demoWager = this.dataInstance.getDemoWager(data);
  if (!!demoWager) {
    this.dataInstance.setWager(demoWager);

    this.sendEvent(EventModel.events._ev_ticketreadytoplay);
    this.sendEvent(EventModel.events.view_play);
  }
};

Engine.prototype.handleDemoResult = function() {
  var flagDemo = this.dataInstance.getFlag(LotteryData.Flag['demo']);

  if (flagDemo) {
    this.dataInstance.setFlag(LotteryData.Flag['result'], true);

    var wager = this.dataInstance.getWager();

    if (wager.bets[0].status === 'WON') {
      this.dataInstance.setFlag(LotteryData.Flag['won'], true);
    } else {
      this.dataInstance.setFlag(LotteryData.Flag['won'], false);
    }

    this.sendEvent(EventModel.events._ev_ticketresult);
  }
};

Engine.prototype.handleInitialized = function() {
  this.sendEvent(EventModel.events._do_hide_loader);
  this.sendEvent(EventModel.events._play);
};

Engine.prototype.handlePlayNext = function() {
  this.dataInstance.setFlag(LotteryData.Flag['result'], false);

  this.dataInstance.setNextWagerToCurrent();
  this.sendEvent(EventModel.events.view_play);

  this.sendEvent(EventModel.events._ev_ticketreadytoplay);
};

Engine.prototype.handleError = function(eventName, data) {
  var errorData = {
    rc: data['rc'],
    msg: data['msg'],
    request: data['request']
  };
  this.callback('error', errorData);
};

Engine.prototype.handleMsg = function(data) {
  var errorData = {
    rc: '613',
    msg: data['title'] + ':' + data['message'],
    request: data['request']
  };
  this.callback('error', errorData);
};

Engine.prototype.handleCommunicationFailed = function(eventName, rc, data) {
  var resultCode = rc;
  if (!!data['rc']) {
    resultCode = data['rc'];
  }
  var errorData = {
    rc: resultCode,
    msg: data['msg'],
    request: data['request']
  };
  this.callback('error', errorData);
};

Engine.prototype.handleScratchResponse = function(id, data) {
  if (this.scratchActive) {
    this.callback(id, data);
  }
};

Engine.prototype.handleProxyResponse = function(data) {
  this.callback(data.id, data.data);
};

Engine.prototype.onEvent = function(eventName, data) {
  switch (eventName) {
    case '_ev_scratch_start':
      this.setupAudio();
      this.handleScratchResponse('ScratchStarted', '');
      break;

    case EventModel.events.do_playnext:
      this.handlePlayNext();
      break;

    case EventModel.events._ev_initialized:
      this.handleInitialized();
      break;

    case EventModel.events._ev_replay:
      this.sendEvent(EventModel.events._do_hide_loader);
      this.sendEvent(EventModel.events._do_play_replay);
      this.sendEvent(EventModel.events._ev_ticketreadytoplay);
      break;

    case EventModel.events._loadedsettings:
      this.loadedSettings();
      break;

    case EventModel.events._loadedresources:
      this.loadedResources();
      this.handleScratchResponse('LoadedAssets', {
        size: this.dataInstance.getTicketSize()
      });
      break;

    case EventModel.events.do_playdemo:
      this.playDemo(data);
      break;

    case EventModel.events.audioon:
      this.dataInstance.setFlag(LotteryData.Flag['audio'], true);
      break;

    case EventModel.events.audiooff:
      this.dataInstance.setFlag(LotteryData.Flag['audio'], false);
      break;

    case EventModel.events._ev_ticketreadytoplay:
      this.handleScratchResponse('GameStarted', '');
      break;

    case EventModel.events.do_check:
      this.handleScratchResponse('DoCheck', '');

      if (this.dataInstance.getFlag(LotteryData.Flag['demo'])) {
        this.handleDemoResult();
        var scData = {
          winFlag: this.dataInstance.getFlag(LotteryData.Flag['won']),
          amount: this.dataInstance.getDynamicValue('winamount'),
          extraicon: this.dataInstance.getDynamicValue('extraicon')
        };
        this.handleScratchResponse('ScratchCompleted', scData);
      }
      break;
    case EventModel.events._ev_gameResult:
      var scData = {
        winFlag: this.dataInstance.getFlag(LotteryData.Flag['won']),
        amount: this.dataInstance.getDynamicValue('winamount'),
        extraicon: this.dataInstance.getDynamicValue('extraicon')
      };
      this.handleScratchResponse('ScratchCompleted', scData);
      break;

    case EventModel.events.ev_resultpresented:
      var scData = {
        winFlag: this.dataInstance.getFlag(LotteryData.Flag['won']),
        amount: this.dataInstance.getDynamicValue('winamount'),
        extraicon: this.dataInstance.getDynamicValue('extraicon')
      };
      if (!this.dataInstance.getFlag('demo')) {
        scData['wager'] = new IWager(this.dataInstance.getWager());
      }

      SceneGraph.renderer.plugins['interaction']['autoPreventDefault'] = false;

      this.handleScratchResponse('GameCompleted', scData);
      break;

    case EventModel.events._do_loadgameassets:
      this.handleScratchResponse('LoadingAssets', '');
      break;

    case EventModel.events._login:
      this.handleProxyResponse({
        id: 'error',
        data: { request: 'internal', rc: 604, msg: 'You are not logged in.' }
      });
      break;

    case EventModel.events._ev_communicationfailed:
      this.handleCommunicationFailed(eventName, '610', data);
      break;

    case EventModel.events._ev_communicationproblem:
      this.handleCommunicationFailed(eventName, '611', data);
      break;

    case EventModel.events._error:
      this.handleError(eventName, data);
      break;

    case EventModel.events._ev_message:
      this.handleMsg(data);
      break;

    case EventModel.events.proxyResponse:
      this.handleProxyResponse(data);
      break;

    case EventModel.events.notify:
      var myData = { id: 'Notify', data: data };
      this.handleProxyResponse(myData);
      break;

    case EventModel.events._fatalerror:
      this.handleProxyResponse({ id: eventName, data: data });
      break;

    default:
      break;
  }
};

Engine.prototype.onResize = function() {
  if (this.resizeTimeoutId === 0) {
    this.resizeTimeoutId = setTimeout(this.doResize.bind(this), 100);
  }
};

Engine.prototype.doResize = function() {
  this.resizeTimeoutId = 0;
  SceneGraph.resize();
};

var nyxClient = window['nyxClient'] || {};
window['nyxClient'] = nyxClient;

var NYX = window['NYX'] || {};
NYX['lottery'] = NYX['lottery'] || {};
NYX['lottery']['generic'] = NYX['lottery']['generic'] || {};
window['NYX'] = NYX;

(function() {

  window['nyxClient']['init'] = function(cb, options) {
    this.eventCallback = cb;

    this.engine = new Engine(this.eventCallback, options);
  };

  window['nyxClient']['setup'] = function(data) {
    if (!!this.engine) {
      this.engine.setup(data);
    } else {
      console.warn(
        'Error - need to call init before requesting setup of canvas!'
      );
    }
  };

  window['nyxClient']['destroy'] = function() {
    if (!!this.engine) {
      this.engine.destroy();
    } else {
      console.warn('Error - need to call init before requesting destroy!');
    }
  };

  window['nyxClient']['trigger'] = function(triggerId, json_data) {
    var data = {};
    if (!!json_data) {
      data = json_data;
    }

    console.log('Trigger:' + triggerId); 

    if (!!this.engine) {
      this.engine.trigger(triggerId, data);
    } else {
      console.warn(
        'Error - need to call init before requesting trigger function!'
      );
    }

  };
})();


 })(window);